! function(e) {
    "function" == typeof define && define.amd ? define("index", e) : e()
}(function() {
    "use strict";

    function e(t) {
        return (e = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
            return typeof e
        } : function(e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
        })(t)
    }

    function t(e, t) {
        if (!(e instanceof t)) throw TypeError("Cannot call a class as a function")
    }

    function i(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
        }
    }

    function n(e, t, n) {
        return t && i(e.prototype, t), n && i(e, n), e
    }

    function s(e) {
        return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function e(t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        })(e)
    }

    function o(e, t) {
        return (o = Object.setPrototypeOf || function e(t, i) {
            return t.__proto__ = i, t
        })(e, t)
    }

    function a() {
        if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
        if ("function" == typeof Proxy) return !0;
        try {
            return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0
        } catch (e) {
            return !1
        }
    }

    function r(e, t, i) {
        return (r = a() ? Reflect.construct : function e(t, i, n) {
            var s = [null];
            s.push.apply(s, i);
            var a = new(Function.bind.apply(t, s));
            return n && o(a, n.prototype), a
        }).apply(null, arguments)
    }

    function l(e) {
        var t = "function" == typeof Map ? new Map : void 0;
        return (l = function e(i) {
            var n;
            if (null === i || (n = i, -1 === Function.toString.call(n).indexOf("[native code]"))) return i;
            if ("function" != typeof i) throw TypeError("Super expression must either be null or a function");
            if (void 0 !== t) {
                if (t.has(i)) return t.get(i);
                t.set(i, a)
            }

            function a() {
                return r(i, arguments, s(this).constructor)
            }
            return a.prototype = Object.create(i.prototype, {
                constructor: {
                    value: a,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), o(a, i)
        })(e)
    }

    function c(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var i = 0, n = Array(t); i < t; i++) n[i] = e[i];
        return n
    }
    var h = {},
        u = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "slideUp",
                value: function e(t, i) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                    t.style[n] = "".concat(t.scrollHeight, "px"), t.offsetHeight, t.style[n] = 0, h[t.id] && (t.removeEventListener("transitionend", h[t.id]), delete h[t.id]);
                    var s = function e(n) {
                        "height" === n.propertyName && (t.removeEventListener("transitionend", e), (i || function() {})())
                    };
                    t.addEventListener("transitionend", s)
                }
            }, {
                key: "slideDown",
                value: function e(t, i) {
                    var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "height";
                    t.style[n] = "".concat(t.scrollHeight, "px");
                    var s = function e(s) {
                        if (s.propertyName === n) {
                            var o = "auto";
                            "max-height" === n && (o = "none"), t.style[n] = o, t.removeEventListener("transitionend", e), delete h[t.id], (i || function() {})()
                        }
                    };
                    t.addEventListener("transitionend", s), h[t.id] = s
                }
            }, ]), e
        }(),
        d = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "getSiblings",
                value: function e(t, i) {
                    for (var n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], s = [], o = t; o = o.previousElementSibling;)(!i || o.matches(i)) && s.push(o);
                    for (n && s.push(t), o = t; o = o.nextElementSibling;)(!i || o.matches(i)) && s.push(o);
                    return s
                }
            }, ]), e
        }(),
        p = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};

    function f(e, t, i) {
        return e(i = {
            path: t,
            exports: {},
            require: function(e, t) {
                return function e() {
                    throw Error("Dynamic requires are not currently supported by @rollup/plugin-commonjs")
                }(e, null == t ? i.path : t)
            }
        }, i.exports), i.exports
    }
    var m, v = (m = f(function(e, t) {
            function i(e) {
                this.listenerMap = [{}, {}], e && this.root(e), this.handle = i.prototype.handle.bind(this), this._removedListeners = []
            }

            function n(e, t) {
                return e.toLowerCase() === t.tagName.toLowerCase()
            }

            function s(e, t) {
                return this.rootElement === window ? t === document || t === document.documentElement || t === window : this.rootElement === t
            }

            function o(e, t) {
                return e === t.id
            }
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = void 0, i.prototype.root = function(e) {
                var t, i = this.listenerMap;
                if (this.rootElement) {
                    for (t in i[1]) i[1].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !0);
                    for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.removeEventListener(t, this.handle, !1)
                }
                if (!e || !e.addEventListener) return this.rootElement && delete this.rootElement, this;
                for (t in this.rootElement = e, i[1]) i[1].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !0);
                for (t in i[0]) i[0].hasOwnProperty(t) && this.rootElement.addEventListener(t, this.handle, !1);
                return this
            }, i.prototype.captureForType = function(e) {
                return -1 !== ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(e)
            }, i.prototype.on = function(e, t, i, a) {
                var r, l, c, h;
                if (!e) throw TypeError("Invalid event type: " + e);
                if ("function" == typeof t && (a = i, i = t, t = null), void 0 === a && (a = this.captureForType(e)), "function" != typeof i) throw TypeError("Handler must be a type of Function");
                return r = this.rootElement, (l = this.listenerMap[a ? 1 : 0])[e] || (r && r.addEventListener(e, this.handle, a), l[e] = []), t ? /^[a-z]+$/i.test(t) ? (h = t, c = n) : /^#[a-z0-9\-_]+$/i.test(t) ? (h = t.slice(1), c = o) : (h = t, c = Element.prototype.matches) : (h = null, c = s.bind(this)), l[e].push({
                    selector: t,
                    handler: i,
                    matcher: c,
                    matcherParam: h
                }), this
            }, i.prototype.off = function(e, t, i, n) {
                var s, o, a, r, l;
                if ("function" == typeof t && (n = i, i = t, t = null), void 0 === n) return this.off(e, t, i, !0), this.off(e, t, i, !1), this;
                if (a = this.listenerMap[n ? 1 : 0], !e) {
                    for (l in a) a.hasOwnProperty(l) && this.off(l, t, i);
                    return this
                }
                if (!(r = a[e]) || !r.length) return this;
                for (s = r.length - 1; s >= 0; s--) o = r[s], t && t !== o.selector || i && i !== o.handler || (this._removedListeners.push(o), r.splice(s, 1));
                return !r.length && (delete a[e], this.rootElement && this.rootElement.removeEventListener(e, this.handle, n)), this
            }, i.prototype.handle = function(e) {
                var t, i, n, s, o, a, r, l, c = e.type,
                    h = [],
                    u = "ftLabsDelegateIgnore";
                if (!0 !== e[u]) {
                    switch (3 === (r = e.target).nodeType && (r = r.parentNode), r.correspondingUseElement && (r = r.correspondingUseElement), n = this.rootElement, s = e.eventPhase || (e.target !== e.currentTarget ? 3 : 2)) {
                        case 1:
                            h = this.listenerMap[1][c];
                            break;
                        case 2:
                            this.listenerMap[0] && this.listenerMap[0][c] && (h = h.concat(this.listenerMap[0][c])), this.listenerMap[1] && this.listenerMap[1][c] && (h = h.concat(this.listenerMap[1][c]));
                            break;
                        case 3:
                            h = this.listenerMap[0][c]
                    }
                    var d = [];
                    for (i = h.length; r && i;) {
                        for (t = 0; t < i && (o = h[t]); t++) r.tagName && ["button", "input", "select", "textarea"].indexOf(r.tagName.toLowerCase()) > -1 && r.hasAttribute("disabled") ? d = [] : o.matcher.call(r, o.matcherParam, r) && d.push([e, r, o]);
                        if (r === n || (i = h.length, (r = r.parentElement || r.parentNode) instanceof HTMLDocument)) break
                    }
                    for (t = 0; t < d.length; t++)
                        if (!(this._removedListeners.indexOf(d[t][2]) > -1) && !1 === (a = this.fire.apply(this, d[t]))) {
                            d[t][0][u] = !0, d[t][0].preventDefault(), l = !1;
                            break
                        }
                    return l
                }
            }, i.prototype.fire = function(e, t, i) {
                return i.handler.call(t, e, t)
            }, i.prototype.destroy = function() {
                this.off(), this.root()
            }, t.default = i, e.exports = t.default
        })) && m.__esModule && Object.prototype.hasOwnProperty.call(m, "default") ? m.default : m,
        g = function() {
            function e() {
                t(this, e), this.domDelegate = new v(document.body), this._attachListeners()
            }
            return n(e, [{
                key: "_attachListeners",
                value: function e() {
                    this.domDelegate.on("click", '[data-action="toggle-collapsible"]:not([disabled])', this._toggleCollapsible.bind(this)), document.addEventListener("collapsible:toggle", this._toggleCollapsible.bind(this))
                }
            }, {
                key: "_toggleCollapsible",
                value: function e(t, i) {
                    var n = this;
                    !i && t.detail && (i = document.querySelector('[aria-controls="'.concat(t.detail.id, '"]')));
                    var s = "true" === i.getAttribute("aria-expanded"),
                        o = i.parentNode;
                    s ? this._close(o) : this._open(o), "false" !== i.getAttribute("data-close-siblings") && d.getSiblings(o).forEach(function(e) {
                        return n._close(e)
                    })
                }
            }, {
                key: "_open",
                value: function e(t) {
                    var i = t.querySelector("[aria-controls]");
                    if (i && "true" !== i.getAttribute("aria-expanded")) {
                        var n = t.querySelector("#".concat(i.getAttribute("aria-controls")));
                        i.setAttribute("aria-expanded", "true"), n.hasAttribute("aria-hidden") && n.setAttribute("aria-hidden", "false"), u.slideDown(n, function() {
                            i.hasAttribute("data-collapsible-force-overflow") && (n.style.overflow = "visible");
                            var e = n.querySelector("[autofocus]");
                            e && e.focus()
                        })
                    }
                }
            }, {
                key: "_close",
                value: function e(t) {
                    var i = t.querySelector("[aria-controls]");
                    if (i && "false" !== i.getAttribute("aria-expanded")) {
                        var n = t.querySelector("#".concat(i.getAttribute("aria-controls")));
                        i.hasAttribute("data-collapsible-force-overflow") && (n.style.overflow = "hidden"), n.hasAttribute("aria-hidden") && n.setAttribute("aria-hidden", "true"), i.setAttribute("aria-expanded", "false"), u.slideUp(n)
                    }
                }
            }, ]), e
        }(),
        y = function() {
            function e(i, n) {
                t(this, e), this.countrySelect = i, this.provinceSelect = n, this.countrySelect && this.provinceSelect && (this._attachListeners(), this._initSelectors())
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.countrySelect && this.countrySelect.removeEventListener("change", this._onCountryChangedListener)
                }
            }, {
                key: "_initSelectors",
                value: function e() {
                    var t = this.countrySelect.getAttribute("data-default");
                    if (t) {
                        for (var i = 0; i !== this.countrySelect.options.length; ++i)
                            if (this.countrySelect.options[i].text === t) {
                                this.countrySelect.selectedIndex = i;
                                break
                            }
                    } else this.countrySelect.selectedIndex = 0;
                    var n = new Event("change", {
                        bubbles: !0
                    });
                    this.countrySelect.dispatchEvent(n);
                    var s = this.provinceSelect.getAttribute("data-default");
                    if (s) {
                        for (var o = 0; o !== this.provinceSelect.options.length; ++o)
                            if (this.provinceSelect.options[o].text === s) {
                                this.provinceSelect.selectedIndex = o;
                                break
                            }
                    }
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._onCountryChangedListener = this._onCountryChanged.bind(this), this.countrySelect.addEventListener("change", this._onCountryChangedListener)
                }
            }, {
                key: "_onCountryChanged",
                value: function e() {
                    var t = this,
                        i = this.countrySelect.options[this.countrySelect.selectedIndex];
                    if (i) {
                        var n = JSON.parse(i.getAttribute("data-provinces") || "[]");
                        if (this.provinceSelect.innerHTML = "", 0 === n.length) {
                            this.provinceSelect.closest(".form__input-wrapper").style.display = "none";
                            return
                        }
                        n.forEach(function(e) {
                            t.provinceSelect.options.add(new Option(e[1], e[0]))
                        }), this.provinceSelect.closest(".form__input-wrapper").style.display = "block"
                    }
                }
            }, ]), e
        }(),
        b = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "matchesBreakpoint",
                value: function e(t) {
                    switch (t) {
                        case "phone":
                            return window.matchMedia("screen and (max-width: 640px)").matches;
                        case "tablet":
                            return window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches;
                        case "tablet-and-up":
                            return window.matchMedia("screen and (min-width: 641px)").matches;
                        case "pocket":
                            return window.matchMedia("screen and (max-width: 1023px)").matches;
                        case "lap":
                            return window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches;
                        case "lap-and-up":
                            return window.matchMedia("screen and (min-width: 1024px)").matches;
                        case "desk":
                            return window.matchMedia("screen and (min-width: 1280px)").matches;
                        case "widescreen":
                            return window.matchMedia("screen and (min-width: 1440px)").matches;
                        case "supports-hover":
                            return window.matchMedia("(hover: hover) and (pointer: fine)").matches
                    }
                }
            }, {
                key: "getCurrentBreakpoint",
                value: function e() {
                    return window.matchMedia("screen and (max-width: 640px)").matches ? "phone" : window.matchMedia("screen and (min-width: 641px) and (max-width: 1023px)").matches ? "tablet" : window.matchMedia("screen and (min-width: 1024px) and (max-width: 1279px)").matches ? "lap" : window.matchMedia("screen and (min-width: 1280px)").matches ? "desk" : void 0
                }
            }, ]), e
        }(),
        $ = function() {
            function e(i, n, s) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.delegateRoot = new v(document.documentElement), this.useInlineNavigation = "inline" === n, this.isNavigationVisible = this.useInlineNavigation, this.openTrigger = s, b.matchesBreakpoint("supports-hover") || (this.openTrigger = "click"), this.openItems = [], this.dropdownActivationTimeouts = {}, this.dropdownDeactivationTimeouts = {}, this.DROPDOWN_TIMEOUT = 100, this._attachListeners(), this.useInlineNavigation && this._setupInlineNavigation()
              const link = document.querySelector('.mobile-navigation__item--last');
              const nav = this;
              if(link){
                link.addEventListener("click", function(e){
                  e.preventDefault();
                    const header = document.querySelector("header.header");
                    const button = document.querySelector(".header__mobile-nav-toggle");

                   const height = window.innerHeight - header.offsetHeight;
                    document.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "true"), document.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "false"), nav.isNavigationVisible = !0, nav.useInlineNavigation = !0;
                    document.querySelector('#mobile-menu').setAttribute("aria-hidden", "false");
                    document.querySelector('#mobile-menu').style.maxHeight = `${height}px`; 
                     setTimeout(() => {
                	        button.click();
                      }, 50);
                              
                 
                })
              }
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off(), this.delegateRoot.off()
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    var i = this;
                    this.useInlineNavigation || this._openNavigation(), d.getSiblings(t.target.parentNode, ".is-dropdown-open").forEach(function(e) {
                        i._deactivateDropdown(t, e.querySelector('[data-type="menuitem"][aria-haspopup]'))
                    }), this._activateDropdown(t, t.target.previousElementSibling)
                }
            }, {
                key: "onBlockDeselect",
                value: function e(t) {
                    this.useInlineNavigation || this._closeNavigation(), this._deactivateDropdown(t, t.target.parentNode)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("focusout", this._onFocusOut.bind(this)), this.delegateRoot.on("click", this._onClick.bind(this)), this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleNavigation.bind(this)), "hover" === this.openTrigger ? (this.delegateElement.on("focusin", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), this.delegateElement.on("mouseover", '[data-type="menuitem"][aria-haspopup]', this._activateDropdown.bind(this)), this.delegateElement.on("mouseover", '[data-type="menu"][aria-hidden="false"]', this._blockDropdownDeactivation.bind(this)), this.delegateElement.on("focusout", ".is-dropdown-open", this._deactivateDropdown.bind(this)), this.delegateElement.on("mouseout", ".is-dropdown-open", this._deactivateDropdown.bind(this))) : this.delegateElement.on("click", '[data-type="menuitem"][aria-haspopup]', this._toggleDropdown.bind(this))                  
                }
            }, {
                key: "_onFocusOut",
                value: function e(t) {
                    null === t.relatedTarget || this.element.contains(t.relatedTarget) || this._closeNavigation()
                }
            }, {
                key: "_onClick",
                value: function e(t) {
                    this.element.contains(t.target) || this._closeNavigation()
                }
            }, {
                key: "_openNavigation",
                value: function e() {
                    !this.useInlineNavigation && (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "true"), this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "false"), this.isNavigationVisible = !0);
              
                }
            }, {
                key: "_closeNavigation",
                value: function e() {
                    var t = this;
                    this.useInlineNavigation || (this.element.querySelector('[data-action="toggle-menu"]').setAttribute("aria-expanded", "false"), this.element.querySelector('[data-type="menu"]').setAttribute("aria-hidden", "true")), this.isNavigationVisible = !1, "click" === this.openTrigger && this.openItems.slice(0).forEach(function(e) {
                        t._deactivateDropdown(event, e)
                    })
                }
            }, {
                key: "_toggleNavigation",
                value: function e(t) {
                    this.isNavigationVisible ? this._closeNavigation() : this._openNavigation()
                }
            }, {
                key: "_toggleDropdown",
                value: function e(t, i) {
                  console.log(this)
                    "false" === i.getAttribute("aria-expanded") && t.preventDefault(), "true" === i.getAttribute("aria-expanded") ? "#" === i.getAttribute("href") && (t.preventDefault(), this._deactivateDropdown(t, i.closest(".is-dropdown-open"))) : this._activateDropdown(t, i)
                }
            }, {
                key: "_activateDropdown",
                value: function e(t, i) {
                    var n = this;
                    "click" === this.openTrigger && this.openItems.slice(0).forEach(function(e) {
                        e.contains(i) || n._deactivateDropdown(t, e)
                    });
                    var s = d.getSiblings(i, "[aria-hidden]")[0],
                        o = function e() {
                            if (i.setAttribute("aria-expanded", "true"), i.parentNode.classList.add("is-dropdown-open"), s.setAttribute("aria-hidden", "false"), "hover" === n.openTrigger && n.dropdownDeactivationTimeouts[s.id] && (clearTimeout(n.dropdownDeactivationTimeouts[s.id]), delete n.dropdownDeactivationTimeouts[s.id]), n.useInlineNavigation) {
                                var t = window.innerWidth,
                                    o = !1;
                                s.querySelectorAll(".nav-dropdown").forEach(function(e) {
                                    e.getBoundingClientRect().right > t && (o = !0)
                                }), o && s.classList.add("nav-dropdown--inverse")
                            }
                            document.body.classList.add("nav-dropdown-open"), i.closest('[data-type="menu"]').classList.add("nav-dropdown--glued"), s.classList.contains("mega-menu") && n._setupMegaMenu(s), "click" === n.openTrigger && n.openItems.push(i.parentNode)
                        };
                    if ("click" === this.openTrigger) o();
                    else {
                        for (var a in this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(a) && (clearTimeout(this.dropdownActivationTimeouts[a]), delete this.dropdownActivationTimeouts[a]);
                        o(), this.dropdownActivationTimeouts[s.id] = setTimeout(() => {
                            o(), delete this.dropdownActivationTimeouts[s.id]
                        }, this.DROPDOWN_TIMEOUT)
                    }
                }
            }, {
                key: "_deactivateDropdown",
                value: function e(t, i) {
                    var n = this;
                    if (!("hover" === this.openTrigger && i.contains(t.relatedTarget))) {
                        var s = i.querySelector("[aria-hidden]"),
                            o = function e() {
                                if (i.classList.remove("is-dropdown-open"), i.querySelector('[data-type="menuitem"]').setAttribute("aria-expanded", "false"), i.querySelector("[aria-hidden]").setAttribute("aria-hidden", "true"), document.body.classList.contains("nav-dropdown-open") && document.body.classList.remove("nav-dropdown-open"), i.closest('[data-type="menu"]').classList.remove("nav-dropdown--glued"), "click" === n.openTrigger) {
                                    i.querySelectorAll(".is-dropdown-open").forEach(function(e) {
                                        n._deactivateDropdown(t, e);
                                        var i = n.openItems.indexOf(e);
                                        i > -1 && n.openItems.splice(i, 1)
                                    });
                                    var s = n.openItems.indexOf(i);
                                    s > -1 && n.openItems.splice(s, 1)
                                }
                            };
                        "click" === this.openTrigger ? o() : this.dropdownDeactivationTimeouts[s.id] = setTimeout(function() {
                            o(), delete n.dropdownDeactivationTimeouts[s.id]
                        }, this.DROPDOWN_TIMEOUT)
                    }
                }
            }, {
                key: "_blockDropdownDeactivation",
                value: function e(t, i) {
                    if (void 0 !== this.dropdownDeactivationTimeouts[i.id])
                        for (var n in clearTimeout(this.dropdownDeactivationTimeouts[i.id]), delete this.dropdownDeactivationTimeouts[i.id], this.dropdownActivationTimeouts) this.dropdownActivationTimeouts.hasOwnProperty(n) && (clearTimeout(this.dropdownActivationTimeouts[n]), delete this.dropdownActivationTimeouts[n])
                }
            }, {
                key: "_setupMegaMenu",
                value: function e(t) {
                    if (!this.useInlineNavigation) {
                        var i = t.closest(".nav-dropdown").clientWidth;
                        t.style.maxWidth = Math.min(1400 - i, parseInt(window.innerWidth - i - 80)) + "px"
                    }
                }
            }, {
                key: "_setupInlineNavigation",
                value: function e() {
                    var t = this;
                    this.element.querySelectorAll(".mega-menu").forEach(function(e) {
                        e.closest(".nav-bar__item").classList.add("nav-bar__item--static")
                    }), "MutationObserver" in window && (this.dropdownMenuObserver = new MutationObserver(function(e) {
                        e.forEach(function(e) {
                            "false" === e.target.getAttribute("aria-hidden") && e.target.style.setProperty("--distance-to-top", "".concat(e.target.getBoundingClientRect().top, "px"))
                        })
                    }), this.element.querySelectorAll(".nav-dropdown .nav-dropdown").forEach(function(e) {
                        t.dropdownMenuObserver.observe(e, {
                            attributes: !0,
                            attributeFilter: ["aria-hidden"]
                        })
                    }))
                }
            }, ]), e
        }(),
        w = function() {
            function e(i) {
                t(this, e), this.element = document.getElementById("mobile-collection-filters"), this.delegateRoot = new v(document.documentElement), this.options = i, this.isOpen = !1, this.element && this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateRoot.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateRoot.on("click", '[aria-controls="mobile-collection-filters"][data-action="open-drawer"]', this.open.bind(this)), this.delegateRoot.on("click", '#mobile-collection-filters [data-action="close-drawer"]', this.close.bind(this)), document.addEventListener("collection-filter:close", this.close.bind(this)), document.addEventListener("click", this._detectOutsideClick.bind(this)), window.addEventListener("resize", this._computeDrawerHeight.bind(this))
                }
            }, {
                key: "open",
                value: function e(t) {
                    t && t.stopPropagation(), this._computeDrawerHeight(), this.isOpen = !0, document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "true"), document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "false"), document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "close",
                value: function e(t) {
                    t && t.stopPropagation(), this.isOpen = !1, document.querySelector('[aria-controls="mobile-collection-filters"]').setAttribute("aria-expanded", "false"), document.getElementById("mobile-collection-filters").setAttribute("aria-hidden", "true"), document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_computeDrawerHeight",
                value: function e() {
                    document.getElementById("mobile-collection-filters").querySelector(".collection-drawer").style.maxHeight = "".concat(window.innerHeight, "px")
                }
            }, {
                key: "_detectOutsideClick",
                value: function e(t) {
                    this.isOpen && !t.target.closest(".collection-drawer__inner") && this.close()
                }
            }, ]), e
        }(),
        E = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.rootDelegateElement = new v(document.body), this.options = JSON.parse(i.getAttribute("data-popup-settings")), this.hasOpenOnceInCurrentPage = !1;
                try {
                    "#exit-popup" === window.location.hash && "captcha" !== window.theme.pageType && this._openPopup()
                } catch (n) {}
                this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    var t = this;
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), b.matchesBreakpoint("supports-hover") && (this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), document.body.addEventListener("mouseleave", function() {
                        t.hasOpenOnceInCurrentPage || t.options.showOnlyOnce && (!t.options.showOnlyOnce || null !== localStorage.getItem("themeExitPopup")) || t._openPopup()
                    }), this._clickOutsideListener = this._checkClickOutside.bind(this))
                }
            }, {
                key: "_openPopup",
                value: function e() {
                    window.theme.isNewsletterPopupOpen || (this.element.setAttribute("aria-hidden", "false"), localStorage.setItem("themeExitPopup", "true"), this.hasOpenOnceInCurrentPage = !0, window.theme.isExitPopupOpen = !0, this.delegateElement.on("click", this._clickOutsideListener), this.rootDelegateElement.on("keyup", this._onKeyPressedListener))
                }
            }, {
                key: "_closePopup",
                value: function e() {
                    this.element.setAttribute("aria-hidden", "true"), window.theme.isExitPopupOpen = !1, this.delegateElement.off("click", this._clickOutsideListener), this.rootDelegateElement.off("keyup", this._onKeyPressedListener)
                }
            }, {
                key: "_checkClickOutside",
                value: function e(t) {
                    this.element.contains(t.target) && this.element !== t.target || this._closePopup()
                }
            }, {
                key: "_onKeyPressed",
                value: function e(t) {
                    "Escape" === t.key && this._closePopup()
                }
            }, ]), e
        }(),
        k = function() {
            function e() {
                t(this, e), this.element = document.querySelector(".loading-bar"), this.element && (document.addEventListener("theme:loading:start", this._onLoadingStart.bind(this)), document.addEventListener("theme:loading:end", this._onLoadingEnd.bind(this)), this.element.addEventListener("transitionend", this._onTransitionEnd.bind(this)))
            }
            return n(e, [{
                key: "_onLoadingStart",
                value: function e() {
                    this.element.classList.add("is-visible"), this.element.style.transform = "scaleX(0.4)"
                }
            }, {
                key: "_onLoadingEnd",
                value: function e() {
                    this.element.style.transform = "scaleX(1)", this.element.classList.add("is-finished")
                }
            }, {
                key: "_onTransitionEnd",
                value: function e(t) {
                    "transform" === t.propertyName && this.element.classList.contains("is-finished") && (this.element.classList.remove("is-visible"), this.element.classList.remove("is-finished"), this.element.style.transform = "scaleX(0)")
                }
            }, ]), e
        }(),
        S = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "trapFocus",
                value: function e(t, i) {
                    this.listeners = this.listeners || {};
                    var n = t.querySelector("[autofocus]") || t;
                    t.setAttribute("tabindex", "-1"), n.focus(), this.listeners[i] = function(e) {
                        t === e.target || t.contains(e.target) || n.focus()
                    }, document.addEventListener("focusin", this.listeners[i])
                }
            }, {
                key: "removeTrapFocus",
                value: function e(t, i) {
                    t && t.removeAttribute("tabindex"), document.removeEventListener("focusin", this.listeners[i])
                }
            }, {
                key: "clearTrapFocus",
                value: function e() {
                    for (var t in this.listeners) this.listeners.hasOwnProperty(t) && document.removeEventListener("focusin", this.listeners[t]);
                    this.listeners = {}
                }
            }, ]), e
        }(),
        x = function() {
            function e(i, n) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.delegateRoot = new v(document.documentElement), this.options = n, this.element && (this.miniCartElement = this.element.querySelector(".mini-cart"), this.isMiniCartOpen = !1, "cart" !== window.theme.pageType && this.miniCartElement && (this.miniCartToggleElement = this.element.querySelector('[aria-controls="'.concat(this.miniCartElement.id, '"]')), this._checkMiniCartScrollability()), this.itemCount = window.theme.cartCount, this._attachListeners())
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculateMiniCartHeightListener)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._calculateMiniCartHeightListener = this._calculateMiniCartHeight.bind(this), "cart" !== window.theme.pageType && "page" !== window.theme.cartType && (this.delegateElement.on("click", '[data-action="toggle-mini-cart"]', this._toggleMiniCart.bind(this)), this.delegateElement.on("keyup", this._checkMiniCartClose.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), window.addEventListener("resize", this._calculateMiniCartHeightListener)), this.delegateRoot.on("click", '[data-action="decrease-quantity"]', this._updateQuantity.bind(this)), this.delegateRoot.on("click", '[data-action="increase-quantity"]', this._updateQuantity.bind(this)), this.delegateRoot.on("change", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantity.bind(this)), this.delegateRoot.on("keyup", ".quantity-selector:not(.quantity-selector--product) .quantity-selector__value", this._updateQuantitySize.bind(this)), this.delegateRoot.on("keydown", ".quantity-selector__value", this._blockEnterKey.bind(this)), this.delegateRoot.on("product:added", this._onProductAdded.bind(this)), this.delegateRoot.on("cart:refresh", this._onCartRefresh.bind(this))
                }
            }, {
                key: "_toggleMiniCart",
                value: function e(t) {
                    t && t.preventDefault(), this.isMiniCartOpen ? this._closeMiniCart() : this._openMiniCart()
                }
            }, {
                key: "_openMiniCart",
                value: function e() {
                    this.miniCartToggleElement.setAttribute("aria-expanded", "true"), "phone" === b.getCurrentBreakpoint() && this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "true"), this.miniCartElement.setAttribute("aria-hidden", "false"), this.isMiniCartOpen = !0, this._calculateMiniCartHeight(), S.trapFocus(this.miniCartElement, "mini-cart"), document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "_closeMiniCart",
                value: function e() {
                    this.miniCartToggleElement.setAttribute("aria-expanded", "false"), "phone" === b.getCurrentBreakpoint() && (this.miniCartToggleElement.querySelector(".header__cart-icon").setAttribute("aria-expanded", "false"), this.miniCartElement.style.maxHeight = ""), this.miniCartElement.setAttribute("aria-hidden", "true"), this.isMiniCartOpen = !1, document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_checkMiniCartClose",
                value: function e(t) {
                    this.isMiniCartOpen && "Escape" === t.key && this._closeMiniCart()
                }
            }, {
                key: "_calculateMiniCartHeight",
                value: function e() {
                    if ("phone" === b.getCurrentBreakpoint()) {
                        if (this.isMiniCartOpen) {
                            var t = window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom;
                            this.miniCartElement.style.maxHeight = "".concat(t, "px");
                            var i = this.miniCartElement.querySelector(".mini-cart__content"),
                                n = this.miniCartElement.querySelector(".mini-cart__recap");
                            n && (i.style.maxHeight = "".concat(t - n.clientHeight, "px"))
                        } else this.miniCartElement.style.maxHeight = "", this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = ""
                    } else this.miniCartElement.style.maxHeight = "", this.miniCartElement.querySelector(".mini-cart__content").style.maxHeight = ""
                }
            }, {
                key: "_updateQuantity",
                value: function e(t, i) {
                    var n = this,
                        s = 1;
                    if (s = "INPUT" === i.tagName ? parseInt(i.value) : parseInt(i.getAttribute("data-quantity")), "page" === window.theme.cartType) {
                        i.hasAttribute("data-href") ? window.location.href = i.getAttribute("data-href") : window.location.href = "".concat(window.routes.cartChangeUrl, "?line=").concat(i.getAttribute("data-line"), "&quantity=").concat(s);
                        return
                    }
                    document.dispatchEvent(new CustomEvent("theme:loading:start")), fetch("".concat(window.routes.cartChangeUrl, ".js"), {
                        body: JSON.stringify({
                            line: i.getAttribute("data-line"),
                            quantity: s
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function(e) {
                        e.json().then(function(e) {
                            n.itemCount = e.item_count, n._rerender(!1).then(function() {
                                document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    }), t.preventDefault()
                }
            }, {
                key: "_updateQuantitySize",
                value: function e(t, i) {
                    i.setAttribute("size", Math.max(i.value.length, 2))
                }
            }, {
                key: "_blockEnterKey",
                value: function e(t) {
                    if ("Enter" === t.key) return !1
                }
            }, {
                key: "_rerender",
                value: function e() {
                    var t = this,
                        i = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0],
                        n = "";
                    if ("cart" !== window.theme.pageType) n = "".concat(window.routes.cartUrl, "?section_id=mini-cart");
                    else {
                        var s = document.querySelector('[data-section-type="cart"]');
                        n = "".concat(window.routes.cartUrl, "?section_id=").concat(s.getAttribute("data-section-id"))
                    }
                    return fetch(n, {
                        credentials: "same-origin",
                        method: "GET",
                        headers: {
                            "Cache-Control": "no-cache"
                        }
                    }).then(function(e) {
                        e.text().then(function(e) {
                            var n = document.createElement("div");
                            if (n.innerHTML = e, n.firstElementChild && n.firstElementChild.hasAttribute("data-item-count") && (t.itemCount = parseInt(n.firstElementChild.getAttribute("data-item-count"))), t.element.querySelector(".header__cart-count").textContent = t.itemCount, "page" !== window.theme.cartType) {
                                if ("cart" !== window.theme.pageType) {
                                    var s = document.createElement("div");
                                    s.innerHTML = e;
                                    var o = t.miniCartElement.querySelector(".mini-cart__line-item-list"),
                                        a = null;
                                    o && (a = o.scrollTop), t.miniCartElement.innerHTML = s.querySelector(".mini-cart").innerHTML;
                                    var r = t.miniCartElement.querySelector(".mini-cart__line-item-list");
                                    r && null !== a && (r.scrollTop = a), t._checkMiniCartScrollability(), t._calculateMiniCartHeight(), t.element.dispatchEvent(new CustomEvent("cart:rerendered"))
                                } else {
                                    var l = document.createElement("div");
                                    l.innerHTML = e, document.querySelector('[data-section-type="cart"]').innerHTML = l.querySelector('[data-section-type="cart"]').innerHTML, i && window.scrollTo({
                                        top: 0,
                                        behavior: "smooth"
                                    }), t.element.dispatchEvent(new CustomEvent("cart:rerendered", {
                                        bubbles: !0
                                    }))
                                }
                            }
                        })
                    })
                }
            }, {
                key: "_checkMiniCartScrollability",
                value: function e() {
                    var t = this.miniCartElement.querySelector(".mini-cart__line-item-list");
                    t && t.scrollHeight > t.clientHeight && t.classList.add("is-scrollable")
                }
            }, {
                key: "_onProductAdded",
                value: function e(t) {
                    var i = this;
                    this.itemCount += t.detail.quantity, this._onCartRefresh().then(function() {
                        "cart" !== window.theme.pageType && ("drawer" !== window.theme.cartType || i.options.useStickyHeader || window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        }), "message" === window.theme.cartType && t.detail.button && (t.detail.button.innerHTML = window.languages.productAddedShort, setTimeout(function() {
                            t.detail.button.innerHTML = window.languages.productFormAddToCart
                        }, 1500)), "cart" !== window.theme.pageType && "drawer" === window.theme.cartType && i._openMiniCart())
                    })
                }
            }, {
                key: "_onCartRefresh",
                value: function e(t) {
                    var i = !0;
                    return t && t.detail && (i = t.detail.scrollToTop), this._rerender(i).then(function() {
                        document.dispatchEvent(new CustomEvent("theme:loading:end"))
                    })
                }
            }, {
                key: "_onWindowClick",
                value: function e(t) {
                    this.miniCartElement && this.isMiniCartOpen && !this.element.contains(t.target) && this._closeMiniCart()
                }
            }, ]), e
        }(),
        _ = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.delegateRoot = new v(document.documentElement), this.mobileMenuElement = this.element.querySelector(".mobile-menu"), this.mobileMenuToggleElement = this.element.querySelector('[aria-controls="'.concat(this.mobileMenuElement.id, '"]')), this.isOpen = !1, this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off(), this.delegateRoot.off(), window.removeEventListener("resize", this._calculatMaxHeightListener)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this), this.delegateElement.on("click", '[data-action="toggle-menu"]', this._toggleMenu.bind(this)), this.delegateElement.on("click", '[data-action="open-panel"]', this._openPanel.bind(this)), this.delegateElement.on("click", '[data-action="close-panel"]', this._closePanel.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), window.addEventListener("resize", this._calculatMaxHeightListener)
                }
            }, {
                key: "_toggleMenu",
                value: function e() {
                    this.isOpen = !this.isOpen, this.mobileMenuToggleElement.setAttribute("aria-expanded", this.isOpen ? "true" : "false"), this.mobileMenuElement.setAttribute("aria-hidden", this.isOpen ? "false" : "true"), this.isOpen ? (this._calculateMaxHeight(), document.body.classList.add("no-mobile-scroll")) : (this.mobileMenuElement.style.maxHeight = "", this.element.querySelectorAll(".mobile-menu__panel.is-open").forEach(function(e) {
                        e.classList.remove("is-open")
                    }), document.body.classList.remove("no-mobile-scroll"))
                }
            }, {
                key: "_openPanel",
                value: function e(t, i) {
                    i.setAttribute("aria-expanded", "true"), this.element.querySelector("#".concat(i.getAttribute("aria-controls"))).classList.add("is-open")
                }
            }, {
                key: "_closePanel",
                value: function e(t, i) {
                    var n = i.closest(".mobile-menu__panel.is-open");
                    n.classList.remove("is-open"), this.element.querySelector('[aria-controls="'.concat(n.id, '"]')).setAttribute("aria-expanded", "false")
                }
            }, {
                key: "_calculateMaxHeight",
                value: function e() {
                    this.isOpen && (this.mobileMenuElement.style.maxHeight = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"))
                }
            }, {
                key: "_onWindowClick",
                value: function e(t) {
                    this.isOpen && !this.element.contains(t.target) && this._toggleMenu()
                }
            }, ]), e
        }(),
        C = function() {
            function e() {
                t(this, e), this.domDelegate = new v(document.body), this.activeModalsQueue = [];
                var i = document.querySelector('.modal[aria-hidden="false"]');
                i && this.activeModalsQueue.push(i), this._attachListeners()
            }
            return n(e, [{
                key: "_attachListeners",
                value: function e() {
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), this.domDelegate.on("click", '[data-action="open-modal"]', this._openModal.bind(this)), this.domDelegate.on("click", '[data-action="close-modal"]', this._closeModal.bind(this)), document.addEventListener("modal:close", this._closeModal.bind(this)), this._clickOutsideListener = this._checkClickOutside.bind(this), this.activeModalsQueue.length > 0 && (document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener))
                }
            }, {
                key: "_openModal",
                value: function e(t, i) {
                    var n = this,
                        s = document.querySelector("#".concat(i.getAttribute("aria-controls")));
                    if (s) {
                        var o = function e(t) {
                            "visibility" === t.propertyName && (s.removeEventListener("transitionend", e), S.trapFocus(s, "modal" + s.id), n.activeModalsQueue.push(s))
                        };
                        return s.addEventListener("transitionend", o), s.setAttribute("aria-hidden", "false"), document.documentElement.classList.add("is-locked"), this.domDelegate.on("click", this._clickOutsideListener), this.domDelegate.on("keyup", this._onKeyPressedListener), !1
                    }
                }
            }, {
                key: "_closeModal",
                value: function e() {
                    if (this.activeModalsQueue.length > 0) {
                        var t = this.activeModalsQueue.pop(),
                            i = function e(i) {
                                "visibility" === i.propertyName && (t.removeEventListener("transitionend", e), S.removeTrapFocus(t, "modal" + t.id), t.dispatchEvent(new CustomEvent("modal:closed")))
                            };
                        t.addEventListener("transitionend", i), t.setAttribute("aria-hidden", "true"), document.documentElement.classList.remove("is-locked"), this.domDelegate.off("click", this._clickOutsideListener), this.domDelegate.off("keyup", this._onKeyPressedListener)
                    }
                }
            }, {
                key: "_checkClickOutside",
                value: function e(t) {
                    if (0 !== this.activeModalsQueue.length) {
                        var i = this.activeModalsQueue[this.activeModalsQueue.length - 1];
                        i && (!i.contains(t.target) || i === t.target) && this._closeModal()
                    }
                }
            }, {
                key: "_onKeyPressed",
                value: function e(t) {
                    "Escape" === t.key && this._closeModal()
                }
            }, ]), e
        }(),
        L = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.rootDelegateElement = new v(document.body), this.options = JSON.parse(i.getAttribute("data-popup-settings"));
                try {
                    "#newsletter-popup" === window.location.hash && "captcha" !== window.theme.pageType ? this._openPopup() : (!this.options.showOnlyOnce || this.options.showOnlyOnce && null === localStorage.getItem("themePopup")) && setTimeout(this._openPopup.bind(this), 1e3 * this.options.apparitionDelay)
                } catch (n) {}
                this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._onKeyPressedListener = this._onKeyPressed.bind(this), this.delegateElement.on("click", '[data-action="close-popup"]', this._closePopup.bind(this)), this._clickOutsideListener = this._checkClickOutside.bind(this)
                }
            }, {
                key: "_openPopup",
                value: function e() {
                    window.theme.isExitPopupOpen || (this.element.setAttribute("aria-hidden", "false"), localStorage.setItem("themePopup", "true"), window.theme.isNewsletterPopupOpen = !0, this.delegateElement.on("click", this._clickOutsideListener), this.rootDelegateElement.on("keyup", this._onKeyPressedListener))
                }
            }, {
                key: "_closePopup",
                value: function e() {
                    this.element.setAttribute("aria-hidden", "true"), window.theme.isNewsletterPopupOpen = !1, this.delegateElement.off("click"), this.rootDelegateElement.off("keyup", this._onKeyPressedListener)
                }
            }, {
                key: "_checkClickOutside",
                value: function e(t) {
                    this.element.contains(t.target) && this.element !== t.target || this._closePopup()
                }
            }, {
                key: "_onKeyPressed",
                value: function e(t) {
                    "Escape" === t.key && this._closePopup()
                }
            }, ]), e
        }(),
        A = f(function(t) {
            ! function(i) {
                var n = function() {},
                    s = i.requestAnimationFrame || i.webkitRequestAnimationFrame || i.mozRequestAnimationFrame || i.msRequestAnimationFrame || function(e) {
                        return setTimeout(e, 16)
                    };

                function o() {
                    var e = this;
                    e.reads = [], e.writes = [], e.raf = s.bind(i)
                }

                function a(e) {
                    e.scheduled || (e.scheduled = !0, e.raf(r.bind(null, e)))
                }

                function r(e) {
                    var t, i = e.writes,
                        s = e.reads;
                    try {
                        n("flushing reads", s.length), l(s), n("flushing writes", i.length), l(i)
                    } catch (o) {
                        t = o
                    }
                    if (e.scheduled = !1, (s.length || i.length) && a(e), t) {
                        if (n("task errored", t.message), e.catch) e.catch(t);
                        else throw t
                    }
                }

                function l(e) {
                    for (var t; t = e.shift();) t()
                }

                function c(e, t) {
                    var i = e.indexOf(t);
                    return !!~i && !!e.splice(i, 1)
                }
                o.prototype = {
                    constructor: o,
                    measure: function e(t, i) {
                        var n = i ? t.bind(i) : t;
                        return this.reads.push(n), a(this), n
                    },
                    mutate: function e(t, i) {
                        var n = i ? t.bind(i) : t;
                        return this.writes.push(n), a(this), n
                    },
                    clear: function e(t) {
                        return c(this.reads, t) || c(this.writes, t)
                    },
                    extend: function t(i) {
                        if ("object" != e(i)) throw Error("expected object");
                        var n = Object.create(this);
                        return function e(t, i) {
                            for (var n in i) i.hasOwnProperty(n) && (t[n] = i[n])
                        }(n, i), n.fastdom = this, n.initialize && n.initialize(), n
                    },
                    catch: null
                };
                var h = i.fastdom = i.fastdom || new o;
                t.exports = h
            }("undefined" != typeof window ? window : p)
        }),
        P = function() {
            function e(i, n) {
                t(this, e), i && (this.element = i, this.options = n, this.lastKnownY = window.scrollY, this.currentTop = 0, this.initialTopOffset = n.offsetTop || parseInt(window.getComputedStyle(this.element).top), this._attachListeners())
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    window.removeEventListener("scroll", this._checkPositionListener)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._checkPositionListener = this._checkPosition.bind(this), window.addEventListener("scroll", this._checkPositionListener)
                }
            }, {
                key: "_checkPosition",
                value: function e() {
                    var t = this;
                    A.measure(function() {
                        var e = t.element.getBoundingClientRect().top + window.scrollY - t.element.offsetTop + t.initialTopOffset,
                            i = t.element.clientHeight - window.innerHeight + (t.options.offsetBottom || 0);
                        window.scrollY < t.lastKnownY ? t.currentTop -= window.scrollY - t.lastKnownY : t.currentTop += t.lastKnownY - window.scrollY, t.currentTop = Math.min(Math.max(t.currentTop, -i), e, t.initialTopOffset), t.lastKnownY = window.scrollY
                    }), A.mutate(function() {
                        t.element.style.top = "".concat(t.currentTop, "px")
                    })
                }
            }, ]), e
        }(),
        I = function() {
            function e() {
                t(this, e), this.delegateElement = new v(document.body), this.delegateRoot = new v(document.documentElement), this.activePopover = null, this._attachListeners()
            }
            return n(e, [{
                key: "_attachListeners",
                value: function e() {
                    this._onLooseFocusListener = this._onLooseFocus.bind(this), this.delegateElement.on("click", '[data-action="toggle-popover"]', this._togglePopover.bind(this)), this.delegateElement.on("click", '[data-action="show-popover-panel"]', this._showPanel.bind(this)), this.delegateRoot.on("click", this._onWindowClick.bind(this)), document.addEventListener("popover:close", this._closeActivePopover.bind(this)), window.addEventListener("resize", this._windowResized.bind(this))
                }
            }, {
                key: "_togglePopover",
                value: function e(t, i) {
                    var n = null !== this.activePopover,
                        s = this.activePopover ? this.activePopover.id : null;
                    !(i.hasAttribute("data-follow-link") && b.matchesBreakpoint(i.getAttribute("data-follow-link"))) && (n && this._closeActivePopover(), (!n || n && i.getAttribute("aria-controls") !== s) && this._openPopover(i), t.preventDefault())
                }
            }, {
                key: "_closeActivePopover",
                value: function e() {
                    this.activePopover.setAttribute("aria-hidden", "true"), document.querySelector('[aria-controls="'.concat(this.activePopover.id, '"]')).setAttribute("aria-expanded", "false"), this.activePopover.removeEventListener("focusout", this._onLooseFocusListener), this.activePopover = null
                }
            }, {
                key: "_openPopover",
                value: function e(t) {
                    var i = document.getElementById(t.getAttribute("aria-controls"));
                    if (t.setAttribute("aria-expanded", "true"), i.setAttribute("aria-hidden", "false"), "phone" === b.getCurrentBreakpoint()) i.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px");
                    else {
                        i.style.height = "";
                        var n = i.querySelector(".popover__panel-list");
                        n && (n.style.height = "".concat(n.clientHeight, "px"))
                    }
                    this.activePopover = i, this.activePopover.addEventListener("focusout", this._onLooseFocusListener)
                }
            }, {
                key: "_showPanel",
                value: function e(t, i) {
                    this.activePopover && this.activePopover.querySelectorAll(".popover__panel").forEach(function(e) {
                        e.id === i.getAttribute("aria-controls") ? (e.classList.add("is-selected"), e.closest(".popover__panel-list").style.height = "".concat(e.clientHeight, "px")) : e.classList.remove("is-selected")
                    })
                }
            }, {
                key: "_onWindowClick",
                value: function e(t) {
                    !("toggle-popover" === t.target.getAttribute("data-action") || t.target.closest('[data-action="toggle-popover"]')) && this.activePopover && !this.activePopover.contains(t.target) && this._closeActivePopover()
                }
            }, {
                key: "_onLooseFocus",
                value: function e(t) {
                    this.activePopover && null !== t.relatedTarget && !this.activePopover.contains(t.relatedTarget) && this._closeActivePopover()
                }
            }, {
                key: "_windowResized",
                value: function e() {
                    "phone" === b.getCurrentBreakpoint() && this.activePopover && (this.activePopover.style.height = "".concat(window.innerHeight - document.querySelector(".header").getBoundingClientRect().bottom, "px"))
                }
            }, ]), e
        }(),
        z = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this._attachListeners(), this.recalculateSwatches()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off(), window.removeEventListener("resize", this._recalculateSwatchesListener)
                }
            }, {
                key: "recalculateSwatches",
                value: function e() {
                    var t = this;
                    A.measure(function() {
                        t.element.querySelectorAll(".product-item__swatch-list").forEach(function(e) {
                            var t = Math.floor(parseInt(Math.min(e.clientWidth, 200)) / 30);
                            A.mutate(function() {
                                var i = e.querySelectorAll(".color-swatch");
                                i.forEach(function(e, n) {
                                    e.classList.remove("color-swatch--view-more"), t === n + 1 && t !== i.length && e.classList.add("color-swatch--view-more")
                                })
                            })
                        })
                    })
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._recalculateSwatchesListener = this.recalculateSwatches.bind(this), this.delegateElement.on("change", ".product-item__swatch-list .color-swatch__radio", this._colorChanged.bind(this)), window.addEventListener("resize", this._recalculateSwatchesListener)
                }
            }, {
                key: "_colorChanged",
                value: function e(t, i) {
                    var n = i.closest(".product-item"),
                        s = i.getAttribute("data-variant-url");
                    n.querySelector(".product-item__image-wrapper").setAttribute("href", s), n.querySelector(".product-item__title").setAttribute("href", s);
                    var o = n.querySelector(".product-item__primary-image");
                    if (i.hasAttribute("data-image-url") && i.getAttribute("data-media-id") !== o.getAttribute("data-media-id")) {
                        var a = document.createElement("img");
                        a.className = "product-item__primary-image lazyload image--fade-in", a.setAttribute("data-media-id", i.getAttribute("data-media-id")), a.setAttribute("data-src", i.getAttribute("data-image-url")), a.setAttribute("data-widths", i.getAttribute("data-image-widths")), a.setAttribute("data-sizes", "auto"), o.parentNode.style.paddingBottom = "".concat(100 / a.getAttribute("data-image-aspect-ratio"), "%"), o.parentNode.replaceChild(a, o)
                    }
                }
            }, ]), e
        }(),
        D = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "formatMoney",
                value: function e(t, i) {
                    "string" == typeof t && (t = t.replace(".", ""));
                    var n = /\{\{\s*(\w+)\s*\}\}/,
                        s = i || "${{amount}}";

                    function o(e, t) {
                        return null == e || e != e ? t : e
                    }

                    function a(e, t, i, n) {
                        if (t = o(t, 2), i = o(i, ","), n = o(n, "."), isNaN(e) || null == e) return 0;
                        var s, a = (e = (e / 100).toFixed(t)).split(".");
                        return a[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (a[1] ? n + a[1] : "")
                    }
                    var r = "";
                    switch (s.match(n)[1]) {
                        case "amount":
                            r = a(t, 2);
                            break;
                        case "amount_no_decimals":
                            r = a(t, 0);
                            break;
                        case "amount_with_space_separator":
                            r = a(t, 2, " ", ".");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            r = a(t, 0, ",", ".");
                            break;
                        case "amount_no_decimals_with_space_separator":
                            r = a(t, 0, " ");
                            break;
                        case "amount_with_comma_separator":
                            r = a(t, 2, ".", ",")
                    }
                    return s.indexOf("with_comma_separator"), s.replace(n, r)
                }
            }, ]), e
        }(),
        T = function() {
            function e() {
                t(this, e)
            }
            return n(e, null, [{
                key: "serialize",
                value: function t(i) {
                    function n(e, t) {
                        var i = e.lastIndexOf("[");
                        if (-1 === i) {
                            var s = {};
                            return s[e] = t, s
                        }
                        var o = e.substr(0, i),
                            a = {};
                        return a[e.substring(i + 1, e.length - 1)] = t, n(o, a)
                    }
                    for (var s = {}, o = 0, a = i.elements.length; o < a; o++) {
                        var r = i.elements[o];
                        if ("" !== r.name && !r.disabled && r.name && !r.disabled && (r.checked || /select|textarea/i.test(r.nodeName) || /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(r.type))) {
                            var l = n(r.name, r.value);
                            s = e.extend(s, l)
                        }
                    }
                    return s
                }
            }, {
                key: "extend",
                value: function t() {
                    for (var i = {}, n = 0; n < arguments.length; n++) ! function t(n) {
                        for (var s in n) n.hasOwnProperty(s) && ("[object Object]" === Object.prototype.toString.call(n[s]) ? i[s] = e.extend(i[s], n[s]) : i[s] = n[s])
                    }(arguments[n]);
                    return i
                }
            }, ]), e
        }(),
        M = function() {
            function e(i) {
                if (t(this, e), this.element = i, this.element) {
                    var n = this.element.querySelector(".store-availabilities-modal");
                    n && document.body.appendChild(n)
                }
            }
            return n(e, [{
                key: "updateWithVariant",
                value: function e(t) {
                    if (this.element) {
                        if (!t) {
                            this.element.textContent = "";
                            return
                        }
                        this._renderAvailabilitySection(t.id)
                    }
                }
            }, {
                key: "_renderAvailabilitySection",
                value: function e(t) {
                    var i = this;
                    this.element.innerHTML = "";
                    var n = document.getElementById("StoreAvailabilityModal-".concat(t));
                    return n && n.remove(), fetch("".concat(window.routes.rootUrlWithoutSlash, "/variants/").concat(t, "?section_id=store-availability")).then(function(e) {
                        return e.text().then(function(e) {
                            var n = document.createElement("div");
                            if (n.innerHTML = e, n.innerHTML = n.firstElementChild.innerHTML, "0" !== n.firstElementChild.getAttribute("data-count")) {
                                i.element.innerHTML = n.innerHTML;
                                var s = document.getElementById("StoreAvailabilityModal-".concat(t));
                                document.body.appendChild(s)
                            }
                        })
                    })
                }
            }, ]), e
        }(),
        q = function() {
            function e(i, n) {
                var s = this;
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = n;
                var o = this.element.querySelector("[data-product-json]");
                if (o) {
                    var a = JSON.parse(o.innerHTML);
                    this.productData = a.product, this.productOptionsWithValues = a.options_with_values, this.variantsInventories = a.inventories || {}, this.variantSelectors = this.element.querySelectorAll(".product-form__option[data-selector-type]"), this.masterSelector = this.element.querySelector("#product-select-".concat(this.productData.id)), this.productData.variants.forEach(function(e) {
                        e.id === a.selected_variant_id && (s.currentVariant = e, s.option1 = e.option1, s.option2 = e.option2, s.option3 = e.option3)
                    }), this.storeAvailability = new M(this.element.querySelector(".product-meta__store-availability-container"))
                }
                this._updateSelectors(this.currentVariant), this._setupStockCountdown(), this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off("click")
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("change", ".product-form__single-selector", this._onOptionChanged.bind(this)), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this))
                }
            }, {
                key: "_onVariantChanged",
                value: function e(t, i) {
                    this._updateProductPrices(i, t), this._updateInventory(i, t), this._updateSku(i, t), this._updateDiscountLabel(i, t), this._updateUnitPrice(i, t), this._updateSelectors(i, t), this._updateAddToCartButton(i, t), this.storeAvailability.updateWithVariant(i), this.element.dispatchEvent(new CustomEvent("variant:changed", {
                        bubbles: !0,
                        detail: {
                            variant: i,
                            previousVariant: t
                        }
                    })), this.masterSelector.dispatchEvent(new Event("change", {
                        bubbles: !0
                    }))
                }
            }, {
                key: "_updateProductPrices",
                value: function e(t, i) {
                    var n = this.element.querySelector(".price-list"),
                        s = window.theme.currencyCodeEnabled ? window.theme.moneyWithCurrencyFormat : window.theme.moneyFormat;
                    if (n) {
                        if (t) {
                            if (i && i.price === t.price && i.compare_at_price === t.compare_at_price) return;
                            n.innerHTML = "", t.compare_at_price > t.price ? (n.innerHTML += '<span class="price price--highlight"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(D.formatMoney(t.price, s), "</span>"), n.innerHTML += '<span class="price price--compare"><span class="visually-hidden">'.concat(window.languages.productRegularPrice, "</span>").concat(D.formatMoney(t.compare_at_price, s), "</span>")) : n.innerHTML += '<span class="price"><span class="visually-hidden">'.concat(window.languages.productSalePrice, "</span>").concat(D.formatMoney(t.price, s), "</span>"), n.style.display = ""
                        } else n.style.display = "none"
                    }
                }
            }, {
                key: "_updateInventory",
                value: function e(t) {
                    if (this.options.showInventoryQuantity && t) {
                        var i = this.element.querySelector(".product-form__inventory"),
                            n = this.variantsInventories[t.id].inventory_management,
                            s = this.variantsInventories[t.id].inventory_policy,
                            o = this.variantsInventories[t.id].inventory_quantity,
                            a = this.variantsInventories[t.id].inventory_message;
                        if (i) {
                            i.classList.remove("inventory--high"), i.classList.remove("inventory--low"), t.available && (null !== n && "deny" === s && this.options.lowInventoryThreshold > 0 && o <= this.options.lowInventoryThreshold ? i.classList.add("inventory--low") : i.classList.add("inventory--high"));
                            var r = this.element.querySelector(".inventory-bar");
                            if (r) {
                                var l = Math.min(Math.max(o / parseInt(r.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                                r.classList.toggle("inventory-bar--hidden", 0 === l), r.firstElementChild.style.width = "".concat(l, "%")
                            }
                            i.innerHTML = a
                        }
                    }
                }
            }, {
                key: "_updateSku",
                value: function e(t, i) {
                    var n = this.element.querySelector(".product-meta__sku");
                    if (n) {
                        var s = n.querySelector(".product-meta__sku-number");
                        if (t && "" !== t.sku) {
                            if (i && i.sku === t.sku) return;
                            s.innerHTML = t.sku, n.style.display = ""
                        } else n.style.display = "none"
                    }
                }
            }, {
                key: "_updateDiscountLabel",
                value: function e(t, i) {
                    if (window.theme.showDiscount) {
                        var n = this.element.querySelector(".product-meta .product-label--on-sale");
                        if (n) {
                            if (t && t.price < t.compare_at_price) {
                                var s = null;
                                s = "percentage" === window.theme.discountMode ? "".concat(Math.round((t.compare_at_price - t.price) * 100 / t.compare_at_price), "%") : "<span>".concat(D.formatMoney(t.compare_at_price - t.price, window.theme.moneyFormat), "</span>"), n.innerHTML = "".concat(window.languages.collectionOnSaleLabel.replace("{{savings}}", s)), n.style.display = "inline-block"
                            } else n.style.display = "none"
                        }
                    }
                }
            }, {
                key: "_updateUnitPrice",
                value: function e(t, i) {
                    var n = this.element.querySelector(".unit-price-measurement");
                    if (n) {
                        if (t && t.unit_price_measurement) {
                            n.parentNode.style.display = "block", n.querySelector(".unit-price-measurement__price").innerHTML = D.formatMoney(t.unit_price, window.theme.moneyFormat), n.querySelector(".unit-price-measurement__reference-unit").innerHTML = t.unit_price_measurement.reference_unit;
                            var s = n.querySelector(".unit-price-measurement__reference-value");
                            s.innerHTML = t.unit_price_measurement.reference_value, s.style.display = 1 === t.unit_price_measurement.reference_value ? "none" : "inline"
                        } else n.parentNode.style.display = "none"
                    }
                }
            }, {
                key: "_updateSelectors",
                value: function e(t) {
                    var i = this,
                        n = function e(t, i, n) {
                            var s = t.getAttribute("data-selector-type");
                            switch (s) {
                                case "color":
                                    t.querySelector(".color-swatch:nth-child(".concat(i + 1, ")")).classList.toggle("color-swatch--disabled", !n);
                                    break;
                                case "variant":
                                    t.querySelector(".variant-swatch:nth-child(".concat(i + 1, ")")).classList.toggle("variant-swatch--disabled", !n);
                                    break;
                                case "block":
                                    t.querySelector(".block-swatch:nth-child(".concat(i + 1, ")")).classList.toggle("block-swatch--disabled", !n)
                            }
                        };
                    this.variantSelectors && this.variantSelectors[0] && this.productOptionsWithValues[0].values.forEach(function(e, t) {
                        n(i.variantSelectors[0], t, i.productData.variants.some(function(t) {
                            return t.option1 === e && t.available
                        })), i.variantSelectors[1] && i.productOptionsWithValues[1].values.forEach(function(e, t) {
                            n(i.variantSelectors[1], t, i.productData.variants.some(function(t) {
                                return t.option2 === e && t.option1 === i.option1 && t.available
                            })), i.variantSelectors[2] && i.productOptionsWithValues[2].values.forEach(function(e, t) {
                                n(i.variantSelectors[2], t, i.productData.variants.some(function(t) {
                                    return t.option3 === e && t.option1 === i.option1 && t.option2 === i.option2 && t.available
                                }))
                            })
                        })
                    })
                }
            }, {
                key: "_updateAddToCartButton",
                value: function e(t) {
                    var i = this.element.querySelector(".product-form__add-button"),
                        n = this.element.querySelector(".product-form__info-list");
                    if (i && (t ? (n.style.display = "block", t.available ? (i.removeAttribute("disabled"), i.classList.remove("button--disabled"), i.classList.add("button--primary"), i.setAttribute("data-action", "add-to-cart"), i.innerHTML = window.languages.productFormAddToCart) : (i.setAttribute("disabled", "disabled"), i.classList.add("button--disabled"), i.classList.remove("button--primary"), i.removeAttribute("data-action"), i.innerHTML = window.languages.productFormSoldOut)) : (i.setAttribute("disabled", "disabled"), i.classList.add("button--disabled"), i.classList.remove("button--primary"), i.removeAttribute("data-action"), i.innerHTML = window.languages.productFormUnavailable, n.style.display = "none"), this.options.showPaymentButton)) {
                        var s = this.element.querySelector(".shopify-payment-button");
                        if (!s) return;
                        t && t.available ? s.style.display = "block" : s.style.display = "none"
                    }
                }
            }, {
                key: "_onOptionChanged",
                value: function e(t, i) {
                    this["option" + i.getAttribute("data-option-position")] = i.value;
                    var n = i.closest(".product-form__option").querySelector(".product-form__selected-value");
                    n && (n.innerHTML = i.value);
                    var s = this.currentVariant;
                    if (this.currentVariant = this._getCurrentVariantFromOptions(), this._onVariantChanged(s, this.currentVariant), this.currentVariant) {
                        if (this.options.enableHistoryState && history.replaceState) {
                            var o = "".concat(window.location.protocol, "//").concat(window.location.host).concat(window.location.pathname, "?variant=").concat(this.currentVariant.id);
                            window.history.replaceState({
                                path: o
                            }, "", o)
                        }
                        this.masterSelector.querySelector("[selected]").removeAttribute("selected"), this.masterSelector.querySelector('[value="'.concat(this.currentVariant.id, '"]')).setAttribute("selected", "selected")
                    }
                }
            }, {
                key: "_getCurrentVariantFromOptions",
                value: function e() {
                    var t = this,
                        i = !1;
                    return this.productData.variants.forEach(function(e) {
                        e.option1 === t.option1 && e.option2 === t.option2 && e.option3 === t.option3 && (i = e)
                    }), i || null
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                  console.log(t)
                    var n = this;
                    if ("page" !== window.theme.cartType) {
                  
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = this.element.querySelector('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                          
                            document.dispatchEvent(new CustomEvent("theme:loading:end")), e.ok ? (i.removeAttribute("disabled"), n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: n.currentVariant,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            })), n.options.isQuickView && "drawer" === window.theme.cartType && document.dispatchEvent(new CustomEvent("modal:close")), "message" === window.theme.cartType && n._showAlert(window.languages.productAdded, "success", i)) : e.json().then(function(e) {
                                n._showAlert(e.description, "error", i)
                            })
                        }), t.preventDefault()
                    }
                }
            }, {
                key: "_setupStockCountdown",
                value: function e() {
                    var t = this,
                        i = this.element.querySelector(".inventory-bar");
                    if (i) {
                        var n = function e() {
                            var n = Math.min(Math.max(t.variantsInventories[t.currentVariant.id].inventory_quantity / parseInt(i.getAttribute("data-stock-countdown-max")) * 100, 0), 100);
                            i.classList.toggle("inventory-bar--hidden", 0 === n), i.firstElementChild.style.width = "".concat(n, "%")
                        };
                        if (window.IntersectionObserver) {
                            var s = new IntersectionObserver(function(e) {
                                e.forEach(function(e) {
                                    e.isIntersecting && (n(), s.disconnect())
                                })
                            });
                            s.observe(i)
                        } else n()
                    }
                }
            }, {
                key: "_showAlert",
                value: function e(t, i, n) {
                    var s = document.createElement("div");
                    s.className = "product-form__status-message", s.innerHTML = '<p class="alert '.concat("success" === i ? "alert--success" : "alert--error", '">').concat(t, "</p>"), n.removeAttribute("disabled"), n.parentNode.insertAdjacentElement("afterend", s), u.slideDown(s), setTimeout(function() {
                        u.slideUp(s, function() {
                            s.remove()
                        })
                    }, 5500)
                }
            }, ]), e
        }(),
        O = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.delegateRoot = new v(document.documentElement), this._attachListeners();
                var n = document.createElement("link");
                n.rel = "stylesheet", n.href = "https://cdn.shopify.com/shopifycloud/model-viewer-ui/assets/v1.0/model-viewer-ui.css", document.head.appendChild(n), window.Shopify.loadFeatures([{
                    name: "model-viewer-ui",
                    version: "1.0",
                    onLoad: this._setupModelViewerUI.bind(this)
                }, {
                    name: "shopify-xr",
                    version: "1.0"
                }, ])
            }
            return n(e, [{
                key: "destroy",
                value: function e() {}
            }, {
                key: "_attachListeners",
                value: function e() {
                    var t = this;
                    this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_play", function() {
                        t.element.dispatchEvent(new CustomEvent("model:played", {
                            bubbles: !0
                        }))
                    }), this.element.querySelector("model-viewer").addEventListener("shopify_model_viewer_ui_toggle_pause", function() {
                        t.element.dispatchEvent(new CustomEvent("model:paused", {
                            bubbles: !0
                        }))
                    })
                }
            }, {
                key: "hasBeenSelected",
                value: function e(t) {
                    b.matchesBreakpoint("supports-hover") && !t && this.modelUi.play()
                }
            }, {
                key: "hasBeenDeselected",
                value: function e() {
                    this.modelUi.pause()
                }
            }, {
                key: "_setupModelViewerUI",
                value: function e() {
                    this.modelElement = this.element.querySelector("model-viewer"), this.modelUi = new window.Shopify.ModelViewerUI(this.modelElement)
                }
            }, ]), e
        }(),
        B = function() {
            function e(i, n) {
                switch (t(this, e), this.element = i, this.delegateElement = new v(this.element), this.enableVideoLooping = n, this.player = null, this.element.getAttribute("data-media-type")) {
                    case "video":
                        var s = document.createElement("link");
                        s.rel = "stylesheet", s.href = "https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css", document.head.appendChild(s), window.Shopify.loadFeatures([{
                            name: "video-ui",
                            version: "1.0",
                            onLoad: this._setupHtml5Video.bind(this)
                        }, ]);
                        break;
                    case "external_video":
                        this._setupExternalVideo()
                }
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.player && this.player.destroy()
                }
            }, {
                key: "hasBeenSelected",
                value: function e(t) {
                    b.matchesBreakpoint("supports-hover") && !t && this.play()
                }
            }, {
                key: "hasBeenDeselected",
                value: function e() {
                    this.pause()
                }
            }, {
                key: "play",
                value: function e() {
                    switch (this.element.getAttribute("data-media-type")) {
                        case "video":
                            this.player.play();
                            break;
                        case "external_video":
                            "youtube" === this.element.getAttribute("data-media-host") ? this.player.playVideo() : this.player.player(), this.element.focus()
                    }
                }
            }, {
                key: "pause",
                value: function e() {
                    switch (this.element.getAttribute("data-media-type")) {
                        case "video":
                            this.player.pause();
                            break;
                        case "external_video":
                            "youtube" === this.element.getAttribute("data-media-host") ? this.player.pauseVideo() : this.player.pause()
                    }
                }
            }, {
                key: "_setupHtml5Video",
                value: function e() {
                    var t = this;
                    this.player = new Shopify.Plyr(this.element.querySelector("video"), {
                        controls: ["play", "progress", "mute", "volume", "play-large", "fullscreen"],
                        loop: {
                            active: this.enableVideoLooping
                        },
                        hideControlsOnPause: !0,
                        clickToPlay: !0,
                        iconUrl: "//cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.svg",
                        tooltips: {
                            controls: !1,
                            seek: !0
                        }
                    }), this.player.on("play", function() {
                        t.element.dispatchEvent(new CustomEvent("video:played", {
                            bubbles: !0
                        }))
                    }), this.player.on("pause", function() {
                        t.element.dispatchEvent(new CustomEvent("video:paused", {
                            bubbles: !0
                        }))
                    })
                }
            }, {
                key: "_setupExternalVideo",
                value: function e() {
                    "youtube" === this.element.getAttribute("data-media-host") ? this._loadYouTubeScript().then(this._setupYouTubePlayer.bind(this)) : "vimeo" === this.element.getAttribute("data-media-host") && this._loadVimeoScript().then(this._setupVimeoPlayer.bind(this))
                }
            }, {
                key: "_setupYouTubePlayer",
                value: function e() {
                    var t = this,
                        i = setInterval(function() {
                            void 0 !== window.YT && void 0 !== window.YT.Player && (t.player = new YT.Player(t.element.querySelector("iframe"), {
                                videoId: t.element.getAttribute("data-video-id"),
                                events: {
                                    onStateChange: function e(i) {
                                        0 === i.data && t.enableVideoLooping && i.target.seekTo(0)
                                    }
                                }
                            }), clearInterval(i))
                        }, 50)
                }
            }, {
                key: "_loadYouTubeScript",
                value: function e() {
                    return new Promise(function(e, t) {
                        var i = document.createElement("script");
                        document.body.appendChild(i), i.onload = e, i.onerror = t, i.async = !0, i.src = "//www.youtube.com/iframe_api"
                    })
                }
            }, {
                key: "_setupVimeoPlayer",
                value: function e() {
                    var t = this,
                        i = setInterval(function() {
                            void 0 !== window.Vimeo && void 0 !== window.Vimeo.Player && (t.player = new Vimeo.Player(t.element.querySelector("iframe")), clearInterval(i))
                        }, 50)
                }
            }, {
                key: "_loadVimeoScript",
                value: function e() {
                    return new Promise(function(e, t) {
                        var i = document.createElement("script");
                        document.body.appendChild(i), i.onload = e, i.onerror = t, i.async = !0, i.src = "//player.vimeo.com/api/player.js"
                    })
                }
            }, ]), e
        }(),
        H = f(function(e) {
            var t, i;
            t = "undefined" != typeof window ? window : p, i = function() {
                function e() {}
                var t = e.prototype;
                return t.on = function(e, t) {
                    if (e && t) {
                        var i = this._events = this._events || {},
                            n = i[e] = i[e] || [];
                        return -1 == n.indexOf(t) && n.push(t), this
                    }
                }, t.once = function(e, t) {
                    if (e && t) {
                        this.on(e, t);
                        var i = this._onceEvents = this._onceEvents || {};
                        return (i[e] = i[e] || {})[t] = !0, this
                    }
                }, t.off = function(e, t) {
                    var i = this._events && this._events[e];
                    if (i && i.length) {
                        var n = i.indexOf(t);
                        return -1 != n && i.splice(n, 1), this
                    }
                }, t.emitEvent = function(e, t) {
                    var i = this._events && this._events[e];
                    if (i && i.length) {
                        i = i.slice(0), t = t || [];
                        for (var n = this._onceEvents && this._onceEvents[e], s = 0; s < i.length; s++) {
                            var o = i[s];
                            n && n[o] && (this.off(e, o), delete n[o]), o.apply(this, t)
                        }
                        return this
                    }
                }, t.allOff = function() {
                    delete this._events, delete this._onceEvents
                }, e
            }, e.exports ? e.exports = i() : t.EvEmitter = i()
        }),
        R = f(function(t) {
            var i, n;
            i = window, n = function t() {
                function i(e) {
                    var t = parseFloat(e);
                    return -1 == e.indexOf("%") && !isNaN(t) && t
                }
                var n, s = "undefined" == typeof console ? function e() {} : function(e) {
                        console.error(e)
                    },
                    o = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth", ],
                    a = o.length;

                function r(e) {
                    var t = getComputedStyle(e);
                    return t || s("Style returned " + t + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), t
                }
                var l = !1;

                function c(t) {
                    if (function e() {
                            if (!l) {
                                l = !0;
                                var t = document.createElement("div");
                                t.style.width = "200px", t.style.padding = "1px 2px 3px 4px", t.style.borderStyle = "solid", t.style.borderWidth = "1px 2px 3px 4px", t.style.boxSizing = "border-box";
                                var s = document.body || document.documentElement;
                                s.appendChild(t);
                                var o = r(t);
                                n = 200 == Math.round(i(o.width)), c.isBoxSizeOuter = n, s.removeChild(t)
                            }
                        }(), "string" == typeof t && (t = document.querySelector(t)), t && "object" == e(t) && t.nodeType) {
                        var s = r(t);
                        if ("none" == s.display) return function e() {
                            for (var t = {
                                    width: 0,
                                    height: 0,
                                    innerWidth: 0,
                                    innerHeight: 0,
                                    outerWidth: 0,
                                    outerHeight: 0
                                }, i = 0; i < a; i++) t[o[i]] = 0;
                            return t
                        }();
                        var h = {};
                        h.width = t.offsetWidth, h.height = t.offsetHeight;
                        for (var u = h.isBorderBox = "border-box" == s.boxSizing, d = 0; d < a; d++) {
                            var p = o[d],
                                f = parseFloat(s[p]);
                            h[p] = isNaN(f) ? 0 : f
                        }
                        var m = h.paddingLeft + h.paddingRight,
                            v = h.paddingTop + h.paddingBottom,
                            g = h.marginLeft + h.marginRight,
                            y = h.marginTop + h.marginBottom,
                            b = h.borderLeftWidth + h.borderRightWidth,
                            $ = h.borderTopWidth + h.borderBottomWidth,
                            w = u && n,
                            E = i(s.width);
                        !1 !== E && (h.width = E + (w ? 0 : m + b));
                        var k = i(s.height);
                        return !1 !== k && (h.height = k + (w ? 0 : v + $)), h.innerWidth = h.width - (m + b), h.innerHeight = h.height - (v + $), h.outerWidth = h.width + g, h.outerHeight = h.height + y, h
                    }
                }
                return c
            }, t.exports ? t.exports = n() : i.getSize = n()
        }),
        F = f(function(e) {
            var t, i;
            t = window, i = function e() {
                var t = function() {
                    var e = window.Element.prototype;
                    if (e.matches) return "matches";
                    if (e.matchesSelector) return "matchesSelector";
                    for (var t = ["webkit", "moz", "ms", "o"], i = 0; i < t.length; i++) {
                        var n = t[i] + "MatchesSelector";
                        if (e[n]) return n
                    }
                }();
                return function e(i, n) {
                    return i[t](n)
                }
            }, e.exports ? e.exports = i() : t.matchesSelector = i()
        }),
        N = f(function(t) {
            var i, n;
            i = window, n = function t(i, n) {
                var s = {};
                s.extend = function(e, t) {
                    for (var i in t) e[i] = t[i];
                    return e
                }, s.modulo = function(e, t) {
                    return (e % t + t) % t
                };
                var o = Array.prototype.slice;
                s.makeArray = function(t) {
                    return Array.isArray(t) ? t : null == t ? [] : "object" == e(t) && "number" == typeof t.length ? o.call(t) : [t]
                }, s.removeFrom = function(e, t) {
                    var i = e.indexOf(t); - 1 != i && e.splice(i, 1)
                }, s.getParent = function(e, t) {
                    for (; e.parentNode && e != document.body;)
                        if (n(e = e.parentNode, t)) return e
                }, s.getQueryElement = function(e) {
                    return "string" == typeof e ? document.querySelector(e) : e
                }, s.handleEvent = function(e) {
                    var t = "on" + e.type;
                    this[t] && this[t](e)
                }, s.filterFindElements = function(e, t) {
                    e = s.makeArray(e);
                    var i = [];
                    return e.forEach(function(e) {
                        if (e instanceof HTMLElement) {
                            if (!t) {
                                i.push(e);
                                return
                            }
                            n(e, t) && i.push(e);
                            for (var s = e.querySelectorAll(t), o = 0; o < s.length; o++) i.push(s[o])
                        }
                    }), i
                }, s.debounceMethod = function(e, t, i) {
                    i = i || 100;
                    var n = e.prototype[t],
                        s = t + "Timeout";
                    e.prototype[t] = function() {
                        clearTimeout(this[s]);
                        var e = arguments,
                            t = this;
                        this[s] = setTimeout(function() {
                            n.apply(t, e), delete t[s]
                        }, i)
                    }
                }, s.docReady = function(e) {
                    var t = document.readyState;
                    "complete" == t || "interactive" == t ? setTimeout(e) : document.addEventListener("DOMContentLoaded", e)
                }, s.toDashed = function(e) {
                    return e.replace(/(.)([A-Z])/g, function(e, t, i) {
                        return t + "-" + i
                    }).toLowerCase()
                };
                var a = i.console;
                return s.htmlInit = function(e, t) {
                    s.docReady(function() {
                        var n = s.toDashed(t),
                            o = "data-" + n,
                            r = document.querySelectorAll("[" + o + "]"),
                            l = document.querySelectorAll(".js-" + n),
                            c = s.makeArray(r).concat(s.makeArray(l)),
                            h = o + "-options",
                            u = i.jQuery;
                        c.forEach(function(i) {
                            var n, s = i.getAttribute(o) || i.getAttribute(h);
                            try {
                                n = s && JSON.parse(s)
                            } catch (r) {
                                a && a.error("Error parsing " + o + " on " + i.className + ": " + r);
                                return
                            }
                            var l = new e(i, n);
                            u && u.data(i, t, l)
                        })
                    })
                }, s
            }, t.exports ? t.exports = n(i, F) : i.fizzyUIUtils = n(i, i.matchesSelector)
        }),
        U = f(function(e) {
            var t, i;
            t = window, i = function e(t, i) {
                function n(e, t) {
                    this.element = e, this.parent = t, this.create()
                }
                var s = n.prototype;
                return s.create = function() {
                    this.element.style.position = "absolute", this.element.setAttribute("aria-hidden", "true"), this.x = 0, this.shift = 0
                }, s.destroy = function() {
                    this.unselect(), this.element.style.position = "";
                    var e = this.parent.originSide;
                    this.element.style[e] = ""
                }, s.getSize = function() {
                    this.size = i(this.element)
                }, s.setPosition = function(e) {
                    this.x = e, this.updateTarget(), this.renderPosition(e)
                }, s.updateTarget = s.setDefaultTarget = function() {
                    var e = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                    this.target = this.x + this.size[e] + this.size.width * this.parent.cellAlign
                }, s.renderPosition = function(e) {
                    var t = this.parent.originSide;
                    this.element.style[t] = this.parent.getPositionValue(e)
                }, s.select = function() {
                    this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden")
                }, s.unselect = function() {
                    this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true")
                }, s.wrapShift = function(e) {
                    this.shift = e, this.renderPosition(this.x + this.parent.slideableWidth * e)
                }, s.remove = function() {
                    this.element.parentNode.removeChild(this.element)
                }, n
            }, e.exports ? e.exports = i(t, R) : (t.Flickity = t.Flickity || {}, t.Flickity.Cell = i(t, t.getSize))
        }),
        W = f(function(e) {
            var t, i;
            t = window, i = function e() {
                function t(e) {
                    this.parent = e, this.isOriginLeft = "left" == e.originSide, this.cells = [], this.outerWidth = 0, this.height = 0
                }
                var i = t.prototype;
                return i.addCell = function(e) {
                    if (this.cells.push(e), this.outerWidth += e.size.outerWidth, this.height = Math.max(e.size.outerHeight, this.height), 1 == this.cells.length) {
                        this.x = e.x;
                        var t = this.isOriginLeft ? "marginLeft" : "marginRight";
                        this.firstMargin = e.size[t]
                    }
                }, i.updateTarget = function() {
                    var e = this.isOriginLeft ? "marginRight" : "marginLeft",
                        t = this.getLastCell(),
                        i = t ? t.size[e] : 0,
                        n = this.outerWidth - (this.firstMargin + i);
                    this.target = this.x + this.firstMargin + n * this.parent.cellAlign
                }, i.getLastCell = function() {
                    return this.cells[this.cells.length - 1]
                }, i.select = function() {
                    this.cells.forEach(function(e) {
                        e.select()
                    })
                }, i.unselect = function() {
                    this.cells.forEach(function(e) {
                        e.unselect()
                    })
                }, i.getCellElements = function() {
                    return this.cells.map(function(e) {
                        return e.element
                    })
                }, t
            }, e.exports ? e.exports = i() : (t.Flickity = t.Flickity || {}, t.Flickity.Slide = i())
        }),
        V = f(function(e) {
            var t, i;
            t = window, i = function e(t, i) {
                var n = {};
                return n.startAnimation = function() {
                    !this.isAnimating && (this.isAnimating = !0, this.restingFrames = 0, this.animate())
                }, n.animate = function() {
                    this.applyDragForce(), this.applySelectedAttraction();
                    var e = this.x;
                    if (this.integratePhysics(), this.positionSlider(), this.settle(e), this.isAnimating) {
                        var t = this;
                        requestAnimationFrame(function e() {
                            t.animate()
                        })
                    }
                }, n.positionSlider = function() {
                    var e = this.x;
                    this.options.wrapAround && this.cells.length > 1 && (e = i.modulo(e, this.slideableWidth), e -= this.slideableWidth, this.shiftWrapCells(e)), this.setTranslateX(e, this.isAnimating), this.dispatchScrollEvent()
                }, n.setTranslateX = function(e, t) {
                    e += this.cursorPosition, e = this.options.rightToLeft ? -e : e;
                    var i = this.getPositionValue(e);
                    this.slider.style.transform = t ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")"
                }, n.dispatchScrollEvent = function() {
                    var e = this.slides[0];
                    if (e) {
                        var t = -this.x - e.target,
                            i = t / this.slidesWidth;
                        this.dispatchEvent("scroll", null, [i, t])
                    }
                }, n.positionSliderAtSelected = function() {
                    this.cells.length && (this.x = -this.selectedSlide.target, this.velocity = 0, this.positionSlider())
                }, n.getPositionValue = function(e) {
                    return this.options.percentPosition ? .01 * Math.round(e / this.size.innerWidth * 1e4) + "%" : Math.round(e) + "px"
                }, n.settle = function(e) {
                    !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * e) && this.restingFrames++, this.restingFrames > 2 && (this.isAnimating = !1, delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]))
                }, n.shiftWrapCells = function(e) {
                    var t = this.cursorPosition + e;
                    this._shiftCells(this.beforeShiftCells, t, -1);
                    var i = this.size.innerWidth - (e + this.slideableWidth + this.cursorPosition);
                    this._shiftCells(this.afterShiftCells, i, 1)
                }, n._shiftCells = function(e, t, i) {
                    for (var n = 0; n < e.length; n++) {
                        var s = e[n],
                            o = t > 0 ? i : 0;
                        s.wrapShift(o), t -= s.size.outerWidth
                    }
                }, n._unshiftCells = function(e) {
                    if (e && e.length)
                        for (var t = 0; t < e.length; t++) e[t].wrapShift(0)
                }, n.integratePhysics = function() {
                    this.x += this.velocity, this.velocity *= this.getFrictionFactor()
                }, n.applyForce = function(e) {
                    this.velocity += e
                }, n.getFrictionFactor = function() {
                    return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"]
                }, n.getRestingPosition = function() {
                    return this.x + this.velocity / (1 - this.getFrictionFactor())
                }, n.applyDragForce = function() {
                    if (this.isDraggable && this.isPointerDown) {
                        var e = this.dragX - this.x - this.velocity;
                        this.applyForce(e)
                    }
                }, n.applySelectedAttraction = function() {
                    if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                        var e = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                        this.applyForce(e)
                    }
                }, n
            }, e.exports ? e.exports = i(t, N) : (t.Flickity = t.Flickity || {}, t.Flickity.animatePrototype = i(t, t.fizzyUIUtils))
        }),
        X = f(function(e) {
            ! function(t, i) {
                if (e.exports) e.exports = i(t, H, R, N, U, W, V);
                else {
                    var n = t.Flickity;
                    t.Flickity = i(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, n.Cell, n.Slide, n.animatePrototype)
                }
            }(window, function e(t, i, n, s, o, a, r) {
                var l = t.jQuery,
                    c = t.getComputedStyle,
                    h = t.console;

                function u(e, t) {
                    for (e = s.makeArray(e); e.length;) t.appendChild(e.shift())
                }
                var d = 0,
                    p = {};

                function f(e, t) {
                    var i = s.getQueryElement(e);
                    if (!i) {
                        h && h.error("Bad element for Flickity: " + (i || e));
                        return
                    }
                    if (this.element = i, this.element.flickityGUID) {
                        var n = p[this.element.flickityGUID];
                        return n.option(t), n
                    }
                    l && (this.$element = l(this.element)), this.options = s.extend({}, this.constructor.defaults), this.option(t), this._create()
                }
                f.defaults = {
                    accessibility: !0,
                    cellAlign: "center",
                    freeScrollFriction: .075,
                    friction: .28,
                    namespaceJQueryEvents: !0,
                    percentPosition: !0,
                    resize: !0,
                    selectedAttraction: .025,
                    setGallerySize: !0
                }, f.createMethods = [];
                var m = f.prototype;
                s.extend(m, i.prototype), m._create = function() {
                    var e = this.guid = ++d;
                    for (var i in this.element.flickityGUID = e, p[e] = this, this.selectedIndex = 0, this.restingFrames = 0, this.x = 0, this.velocity = 0, this.originSide = this.options.rightToLeft ? "right" : "left", this.viewport = document.createElement("div"), this.viewport.className = "flickity-viewport", this._createSlider(), (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this), this.options.on) {
                        var n = this.options.on[i];
                        this.on(i, n)
                    }
                    f.createMethods.forEach(function(e) {
                        this[e]()
                    }, this), this.options.watchCSS ? this.watchCSS() : this.activate()
                }, m.option = function(e) {
                    s.extend(this.options, e)
                }, m.activate = function() {
                    !this.isActive && (this.isActive = !0, this.element.classList.add("flickity-enabled"), this.options.rightToLeft && this.element.classList.add("flickity-rtl"), this.getSize(), u(this._filterFindCellElements(this.element.children), this.slider), this.viewport.appendChild(this.slider), this.element.appendChild(this.viewport), this.reloadCells(), this.options.accessibility && (this.element.tabIndex = 0, this.element.addEventListener("keydown", this)), this.emitEvent("activate"), this.selectInitialIndex(), this.isInitActivated = !0, this.dispatchEvent("ready"))
                }, m._createSlider = function() {
                    var e = document.createElement("div");
                    e.className = "flickity-slider", e.style[this.originSide] = 0, this.slider = e
                }, m._filterFindCellElements = function(e) {
                    return s.filterFindElements(e, this.options.cellSelector)
                }, m.reloadCells = function() {
                    this.cells = this._makeCells(this.slider.children), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize()
                }, m._makeCells = function(e) {
                    return this._filterFindCellElements(e).map(function(e) {
                        return new o(e, this)
                    }, this)
                }, m.getLastCell = function() {
                    return this.cells[this.cells.length - 1]
                }, m.getLastSlide = function() {
                    return this.slides[this.slides.length - 1]
                }, m.positionCells = function() {
                    this._sizeCells(this.cells), this._positionCells(0)
                }, m._positionCells = function(e) {
                    e = e || 0, this.maxCellHeight = e && this.maxCellHeight || 0;
                    var t = 0;
                    if (e > 0) {
                        var i = this.cells[e - 1];
                        t = i.x + i.size.outerWidth
                    }
                    for (var n = this.cells.length, s = e; s < n; s++) {
                        var o = this.cells[s];
                        o.setPosition(t), t += o.size.outerWidth, this.maxCellHeight = Math.max(o.size.outerHeight, this.maxCellHeight)
                    }
                    this.slideableWidth = t, this.updateSlides(), this._containSlides(), this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0
                }, m._sizeCells = function(e) {
                    e.forEach(function(e) {
                        e.getSize()
                    })
                }, m.updateSlides = function() {
                    if (this.slides = [], this.cells.length) {
                        var e = new a(this);
                        this.slides.push(e);
                        var t = "left" == this.originSide ? "marginRight" : "marginLeft",
                            i = this._getCanCellFit();
                        this.cells.forEach(function(n, s) {
                            if (!e.cells.length) {
                                e.addCell(n);
                                return
                            }
                            var o = e.outerWidth - e.firstMargin + (n.size.outerWidth - n.size[t]);
                            i.call(this, s, o) || (e.updateTarget(), e = new a(this), this.slides.push(e)), e.addCell(n)
                        }, this), e.updateTarget(), this.updateSelectedSlide()
                    }
                }, m._getCanCellFit = function() {
                    var e = this.options.groupCells;
                    if (!e) return function() {
                        return !1
                    };
                    if ("number" == typeof e) {
                        var t = parseInt(e, 10);
                        return function(e) {
                            return e % t != 0
                        }
                    }
                    var i = "string" == typeof e && e.match(/^(\d+)%$/),
                        n = i ? parseInt(i[1], 10) / 100 : 1;
                    return function(e, t) {
                        return t <= (this.size.innerWidth + 1) * n
                    }
                }, m._init = m.reposition = function() {
                    this.positionCells(), this.positionSliderAtSelected()
                }, m.getSize = function() {
                    this.size = n(this.element), this.setCellAlign(), this.cursorPosition = this.size.innerWidth * this.cellAlign
                };
                var v = {
                    center: {
                        left: .5,
                        right: .5
                    },
                    left: {
                        left: 0,
                        right: 1
                    },
                    right: {
                        right: 0,
                        left: 1
                    }
                };
                return m.setCellAlign = function() {
                    var e = v[this.options.cellAlign];
                    this.cellAlign = e ? e[this.originSide] : this.options.cellAlign
                }, m.setGallerySize = function() {
                    if (this.options.setGallerySize) {
                        var e = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                        this.viewport.style.height = e + "px"
                    }
                }, m._getWrapShiftCells = function() {
                    if (this.options.wrapAround) {
                        this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                        var e = this.cursorPosition,
                            t = this.cells.length - 1;
                        this.beforeShiftCells = this._getGapCells(e, t, -1), e = this.size.innerWidth - this.cursorPosition, this.afterShiftCells = this._getGapCells(e, 0, 1)
                    }
                }, m._getGapCells = function(e, t, i) {
                    for (var n = []; e > 0;) {
                        var s = this.cells[t];
                        if (!s) break;
                        n.push(s), t += i, e -= s.size.outerWidth
                    }
                    return n
                }, m._containSlides = function() {
                    if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                        var e = this.options.rightToLeft,
                            t = this.slideableWidth - this.getLastCell().size[e ? "marginLeft" : "marginRight"],
                            i = t < this.size.innerWidth,
                            n = this.cursorPosition + this.cells[0].size[e ? "marginRight" : "marginLeft"],
                            s = t - this.size.innerWidth * (1 - this.cellAlign);
                        this.slides.forEach(function(e) {
                            i ? e.target = t * this.cellAlign : (e.target = Math.max(e.target, n), e.target = Math.min(e.target, s))
                        }, this)
                    }
                }, m.dispatchEvent = function(e, t, i) {
                    var n = t ? [t].concat(i) : i;
                    if (this.emitEvent(e, n), l && this.$element) {
                        var s = e += this.options.namespaceJQueryEvents ? ".flickity" : "";
                        if (t) {
                            var o = l.Event(t);
                            o.type = e, s = o
                        }
                        this.$element.trigger(s, i)
                    }
                }, m.select = function(e, t, i) {
                    if (this.isActive) {
                        if (e = parseInt(e, 10), this._wrapSelect(e), (this.options.wrapAround || t) && (e = s.modulo(e, this.slides.length)), this.slides[e]) {
                            var n = this.selectedIndex;
                            this.selectedIndex = e, this.updateSelectedSlide(), i ? this.positionSliderAtSelected() : this.startAnimation(), this.options.adaptiveHeight && this.setGallerySize(), this.dispatchEvent("select", null, [e]), e != n && this.dispatchEvent("change", null, [e]), this.dispatchEvent("cellSelect")
                        }
                    }
                }, m._wrapSelect = function(e) {
                    var t = this.slides.length;
                    if (!(this.options.wrapAround && t > 1)) return e;
                    var i = s.modulo(e, t),
                        n = Math.abs(i - this.selectedIndex),
                        o = Math.abs(i + t - this.selectedIndex),
                        a = Math.abs(i - t - this.selectedIndex);
                    !this.isDragSelect && o < n ? e += t : !this.isDragSelect && a < n && (e -= t), e < 0 ? this.x -= this.slideableWidth : e >= t && (this.x += this.slideableWidth)
                }, m.previous = function(e, t) {
                    this.select(this.selectedIndex - 1, e, t)
                }, m.next = function(e, t) {
                    this.select(this.selectedIndex + 1, e, t)
                }, m.updateSelectedSlide = function() {
                    var e = this.slides[this.selectedIndex];
                    e && (this.unselectSelectedSlide(), this.selectedSlide = e, e.select(), this.selectedCells = e.cells, this.selectedElements = e.getCellElements(), this.selectedCell = e.cells[0], this.selectedElement = this.selectedElements[0])
                }, m.unselectSelectedSlide = function() {
                    this.selectedSlide && this.selectedSlide.unselect()
                }, m.selectInitialIndex = function() {
                    var e = this.options.initialIndex;
                    if (this.isInitActivated) {
                        this.select(this.selectedIndex, !1, !0);
                        return
                    }
                    if (e && "string" == typeof e && this.queryCell(e)) {
                        this.selectCell(e, !1, !0);
                        return
                    }
                    var t = 0;
                    e && this.slides[e] && (t = e), this.select(t, !1, !0)
                }, m.selectCell = function(e, t, i) {
                    var n = this.queryCell(e);
                    if (n) {
                        var s = this.getCellSlideIndex(n);
                        this.select(s, t, i)
                    }
                }, m.getCellSlideIndex = function(e) {
                    for (var t = 0; t < this.slides.length; t++)
                        if (-1 != this.slides[t].cells.indexOf(e)) return t
                }, m.getCell = function(e) {
                    for (var t = 0; t < this.cells.length; t++) {
                        var i = this.cells[t];
                        if (i.element == e) return i
                    }
                }, m.getCells = function(e) {
                    e = s.makeArray(e);
                    var t = [];
                    return e.forEach(function(e) {
                        var i = this.getCell(e);
                        i && t.push(i)
                    }, this), t
                }, m.getCellElements = function() {
                    return this.cells.map(function(e) {
                        return e.element
                    })
                }, m.getParentCell = function(e) {
                    var t = this.getCell(e);
                    return t || (e = s.getParent(e, ".flickity-slider > *"), this.getCell(e))
                }, m.getAdjacentCellElements = function(e, t) {
                    if (!e) return this.selectedSlide.getCellElements();
                    t = void 0 === t ? this.selectedIndex : t;
                    var i = this.slides.length;
                    if (1 + 2 * e >= i) return this.getCellElements();
                    for (var n = [], o = t - e; o <= t + e; o++) {
                        var a = this.options.wrapAround ? s.modulo(o, i) : o,
                            r = this.slides[a];
                        r && (n = n.concat(r.getCellElements()))
                    }
                    return n
                }, m.queryCell = function(e) {
                    if ("number" == typeof e) return this.cells[e];
                    if ("string" == typeof e) {
                        if (e.match(/^[#\.]?[\d\/]/)) return;
                        e = this.element.querySelector(e)
                    }
                    return this.getCell(e)
                }, m.uiChange = function() {
                    this.emitEvent("uiChange")
                }, m.childUIPointerDown = function(e) {
                    "touchstart" != e.type && e.preventDefault(), this.focus()
                }, m.onresize = function() {
                    this.watchCSS(), this.resize()
                }, s.debounceMethod(f, "onresize", 150), m.resize = function() {
                    if (this.isActive) {
                        this.getSize(), this.options.wrapAround && (this.x = s.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.emitEvent("resize");
                        var e = this.selectedElements && this.selectedElements[0];
                        this.selectCell(e, !1, !0)
                    }
                }, m.watchCSS = function() {
                    this.options.watchCSS && (-1 != c(this.element, ":after").content.indexOf("flickity") ? this.activate() : this.deactivate())
                }, m.onkeydown = function(e) {
                    var t = document.activeElement && document.activeElement != this.element;
                    if (this.options.accessibility && !t) {
                        var i = f.keyboardHandlers[e.keyCode];
                        i && i.call(this)
                    }
                }, f.keyboardHandlers = {
                    37: function e() {
                        var t = this.options.rightToLeft ? "next" : "previous";
                        this.uiChange(), this[t]()
                    },
                    39: function e() {
                        var t = this.options.rightToLeft ? "previous" : "next";
                        this.uiChange(), this[t]()
                    }
                }, m.focus = function() {
                    var e = t.pageYOffset;
                    this.element.focus({
                        preventScroll: !0
                    }), t.pageYOffset != e && t.scrollTo(t.pageXOffset, e)
                }, m.deactivate = function() {
                    this.isActive && (this.element.classList.remove("flickity-enabled"), this.element.classList.remove("flickity-rtl"), this.unselectSelectedSlide(), this.cells.forEach(function(e) {
                        e.destroy()
                    }), this.element.removeChild(this.viewport), u(this.slider.children, this.element), this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)), this.isActive = !1, this.emitEvent("deactivate"))
                }, m.destroy = function() {
                    this.deactivate(), t.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), l && this.$element && l.removeData(this.element, "flickity"), delete this.element.flickityGUID, delete p[this.guid]
                }, s.extend(m, r), f.data = function(e) {
                    var t = (e = s.getQueryElement(e)) && e.flickityGUID;
                    return t && p[t]
                }, s.htmlInit(f, "flickity"), l && l.bridget && l.bridget("flickity", f), f.setJQuery = function(e) {
                    l = e
                }, f.Cell = o, f.Slide = a, f
            })
        }),
        j = f(function(e) {
            var t, i;
            t = window, i = function e(t, i) {
                function n() {}
                var s = n.prototype = Object.create(i.prototype);
                s.bindStartEvent = function(e) {
                    this._bindStartEvent(e, !0)
                }, s.unbindStartEvent = function(e) {
                    this._bindStartEvent(e, !1)
                }, s._bindStartEvent = function(e, i) {
                    var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener",
                        s = "mousedown";
                    t.PointerEvent ? s = "pointerdown" : "ontouchstart" in t && (s = "touchstart"), e[n](s, this)
                }, s.handleEvent = function(e) {
                    var t = "on" + e.type;
                    this[t] && this[t](e)
                }, s.getTouch = function(e) {
                    for (var t = 0; t < e.length; t++) {
                        var i = e[t];
                        if (i.identifier == this.pointerIdentifier) return i
                    }
                }, s.onmousedown = function(e) {
                    var t = e.button;
                    (!t || 0 === t || 1 === t) && this._pointerDown(e, e)
                }, s.ontouchstart = function(e) {
                    this._pointerDown(e, e.changedTouches[0])
                }, s.onpointerdown = function(e) {
                    this._pointerDown(e, e)
                }, s._pointerDown = function(e, t) {
                    !e.button && !this.isPointerDown && (this.isPointerDown = !0, this.pointerIdentifier = void 0 !== t.pointerId ? t.pointerId : t.identifier, this.pointerDown(e, t))
                }, s.pointerDown = function(e, t) {
                    this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t])
                };
                var o = {
                    mousedown: ["mousemove", "mouseup"],
                    touchstart: ["touchmove", "touchend", "touchcancel"],
                    pointerdown: ["pointermove", "pointerup", "pointercancel"]
                };
                return s._bindPostStartEvents = function(e) {
                    if (e) {
                        var i = o[e.type];
                        i.forEach(function(e) {
                            t.addEventListener(e, this)
                        }, this), this._boundPointerEvents = i
                    }
                }, s._unbindPostStartEvents = function() {
                    this._boundPointerEvents && (this._boundPointerEvents.forEach(function(e) {
                        t.removeEventListener(e, this)
                    }, this), delete this._boundPointerEvents)
                }, s.onmousemove = function(e) {
                    this._pointerMove(e, e)
                }, s.onpointermove = function(e) {
                    e.pointerId == this.pointerIdentifier && this._pointerMove(e, e)
                }, s.ontouchmove = function(e) {
                    var t = this.getTouch(e.changedTouches);
                    t && this._pointerMove(e, t)
                }, s._pointerMove = function(e, t) {
                    this.pointerMove(e, t)
                }, s.pointerMove = function(e, t) {
                    this.emitEvent("pointerMove", [e, t])
                }, s.onmouseup = function(e) {
                    this._pointerUp(e, e)
                }, s.onpointerup = function(e) {
                    e.pointerId == this.pointerIdentifier && this._pointerUp(e, e)
                }, s.ontouchend = function(e) {
                    var t = this.getTouch(e.changedTouches);
                    t && this._pointerUp(e, t)
                }, s._pointerUp = function(e, t) {
                    this._pointerDone(), this.pointerUp(e, t)
                }, s.pointerUp = function(e, t) {
                    this.emitEvent("pointerUp", [e, t])
                }, s._pointerDone = function() {
                    this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone()
                }, s._pointerReset = function() {
                    this.isPointerDown = !1, delete this.pointerIdentifier
                }, s.pointerDone = function e() {}, s.onpointercancel = function(e) {
                    e.pointerId == this.pointerIdentifier && this._pointerCancel(e, e)
                }, s.ontouchcancel = function(e) {
                    var t = this.getTouch(e.changedTouches);
                    t && this._pointerCancel(e, t)
                }, s._pointerCancel = function(e, t) {
                    this._pointerDone(), this.pointerCancel(e, t)
                }, s.pointerCancel = function(e, t) {
                    this.emitEvent("pointerCancel", [e, t])
                }, n.getPointerPoint = function(e) {
                    return {
                        x: e.pageX,
                        y: e.pageY
                    }
                }, n
            }, e.exports ? e.exports = i(t, H) : t.Unipointer = i(t, t.EvEmitter)
        }),
        Z = f(function(e) {
            var t, i;
            t = window, i = function e(t, i) {
                function n() {}
                var s = n.prototype = Object.create(i.prototype);
                s.bindHandles = function() {
                    this._bindHandles(!0)
                }, s.unbindHandles = function() {
                    this._bindHandles(!1)
                }, s._bindHandles = function(e) {
                    for (var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", n = e ? this._touchActionValue : "", s = 0; s < this.handles.length; s++) {
                        var o = this.handles[s];
                        this._bindStartEvent(o, e), o[i]("click", this), t.PointerEvent && (o.style.touchAction = n)
                    }
                }, s._touchActionValue = "none", s.pointerDown = function(e, t) {
                    this.okayPointerDown(e) && (this.pointerDownPointer = {
                        pageX: t.pageX,
                        pageY: t.pageY
                    }, e.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(e), this.emitEvent("pointerDown", [e, t]))
                };
                var o = {
                        TEXTAREA: !0,
                        INPUT: !0,
                        SELECT: !0,
                        OPTION: !0
                    },
                    a = {
                        radio: !0,
                        checkbox: !0,
                        button: !0,
                        submit: !0,
                        image: !0,
                        file: !0
                    };
                return s.okayPointerDown = function(e) {
                    var t = o[e.target.nodeName],
                        i = a[e.target.type],
                        n = !t || i;
                    return n || this._pointerReset(), n
                }, s.pointerDownBlur = function() {
                    var e = document.activeElement;
                    e && e.blur && e != document.body && e.blur()
                }, s.pointerMove = function(e, t) {
                    var i = this._dragPointerMove(e, t);
                    this.emitEvent("pointerMove", [e, t, i]), this._dragMove(e, t, i)
                }, s._dragPointerMove = function(e, t) {
                    var i = {
                        x: t.pageX - this.pointerDownPointer.pageX,
                        y: t.pageY - this.pointerDownPointer.pageY
                    };
                    return !this.isDragging && this.hasDragStarted(i) && this._dragStart(e, t), i
                }, s.hasDragStarted = function(e) {
                    return Math.abs(e.x) > 3 || Math.abs(e.y) > 3
                }, s.pointerUp = function(e, t) {
                    this.emitEvent("pointerUp", [e, t]), this._dragPointerUp(e, t)
                }, s._dragPointerUp = function(e, t) {
                    this.isDragging ? this._dragEnd(e, t) : this._staticClick(e, t)
                }, s._dragStart = function(e, t) {
                    this.isDragging = !0, this.isPreventingClicks = !0, this.dragStart(e, t)
                }, s.dragStart = function(e, t) {
                    this.emitEvent("dragStart", [e, t])
                }, s._dragMove = function(e, t, i) {
                    this.isDragging && this.dragMove(e, t, i)
                }, s.dragMove = function(e, t, i) {
                    e.preventDefault(), this.emitEvent("dragMove", [e, t, i])
                }, s._dragEnd = function(e, t) {
                    this.isDragging = !1, setTimeout((function() {
                        delete this.isPreventingClicks
                    }).bind(this)), this.dragEnd(e, t)
                }, s.dragEnd = function(e, t) {
                    this.emitEvent("dragEnd", [e, t])
                }, s.onclick = function(e) {
                    this.isPreventingClicks && e.preventDefault()
                }, s._staticClick = function(e, t) {
                    (!this.isIgnoringMouseUp || "mouseup" != e.type) && (this.staticClick(e, t), "mouseup" != e.type && (this.isIgnoringMouseUp = !0, setTimeout((function() {
                        delete this.isIgnoringMouseUp
                    }).bind(this), 400)))
                }, s.staticClick = function(e, t) {
                    this.emitEvent("staticClick", [e, t])
                }, n.getPointerPoint = i.getPointerPoint, n
            }, e.exports ? e.exports = i(t, j) : t.Unidragger = i(t, t.Unipointer)
        }),
        Y = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n, s) {
                s.extend(i.defaults, {
                    draggable: ">1",
                    dragThreshold: 3
                }), i.createMethods.push("_createDrag");
                var o = i.prototype;
                s.extend(o, n.prototype), o._touchActionValue = "pan-y";
                var a = "createTouch" in document,
                    r = !1;
                o._createDrag = function() {
                    this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable), a && !r && (t.addEventListener("touchmove", function() {}), r = !0)
                }, o.onActivateDrag = function() {
                    this.handles = [this.viewport], this.bindHandles(), this.updateDraggable()
                }, o.onDeactivateDrag = function() {
                    this.unbindHandles(), this.element.classList.remove("is-draggable")
                }, o.updateDraggable = function() {
                    ">1" == this.options.draggable ? this.isDraggable = this.slides.length > 1 : this.isDraggable = this.options.draggable, this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable")
                }, o.bindDrag = function() {
                    this.options.draggable = !0, this.updateDraggable()
                }, o.unbindDrag = function() {
                    this.options.draggable = !1, this.updateDraggable()
                }, o._uiChangeDrag = function() {
                    delete this.isFreeScrolling
                }, o.pointerDown = function(e, i) {
                    if (!this.isDraggable) {
                        this._pointerDownDefault(e, i);
                        return
                    }
                    this.okayPointerDown(e) && (this._pointerDownPreventDefault(e), this.pointerDownFocus(e), document.activeElement != this.element && this.pointerDownBlur(), this.dragX = this.x, this.viewport.classList.add("is-pointer-down"), this.pointerDownScroll = c(), t.addEventListener("scroll", this), this._pointerDownDefault(e, i))
                }, o._pointerDownDefault = function(e, t) {
                    this.pointerDownPointer = {
                        pageX: t.pageX,
                        pageY: t.pageY
                    }, this._bindPostStartEvents(e), this.dispatchEvent("pointerDown", e, [t])
                };
                var l = {
                    INPUT: !0,
                    TEXTAREA: !0,
                    SELECT: !0
                };

                function c() {
                    return {
                        x: t.pageXOffset,
                        y: t.pageYOffset
                    }
                }
                return o.pointerDownFocus = function(e) {
                    l[e.target.nodeName] || this.focus()
                }, o._pointerDownPreventDefault = function(e) {
                    var t = "touchstart" == e.type,
                        i = "touch" == e.pointerType,
                        n = l[e.target.nodeName];
                    t || i || n || e.preventDefault()
                }, o.hasDragStarted = function(e) {
                    return Math.abs(e.x) > this.options.dragThreshold
                }, o.pointerUp = function(e, t) {
                    delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", e, [t]), this._dragPointerUp(e, t)
                }, o.pointerDone = function() {
                    t.removeEventListener("scroll", this), delete this.pointerDownScroll
                }, o.dragStart = function(e, i) {
                    this.isDraggable && (this.dragStartPosition = this.x, this.startAnimation(), t.removeEventListener("scroll", this), this.dispatchEvent("dragStart", e, [i]))
                }, o.pointerMove = function(e, t) {
                    var i = this._dragPointerMove(e, t);
                    this.dispatchEvent("pointerMove", e, [t, i]), this._dragMove(e, t, i)
                }, o.dragMove = function(e, t, i) {
                    if (this.isDraggable) {
                        e.preventDefault(), this.previousDragX = this.dragX;
                        var n = this.options.rightToLeft ? -1 : 1;
                        this.options.wrapAround && (i.x = i.x % this.slideableWidth);
                        var s = this.dragStartPosition + i.x * n;
                        if (!this.options.wrapAround && this.slides.length) {
                            var o = Math.max(-this.slides[0].target, this.dragStartPosition);
                            s = s > o ? (s + o) * .5 : s;
                            var a = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                            s = s < a ? (s + a) * .5 : s
                        }
                        this.dragX = s, this.dragMoveTime = new Date, this.dispatchEvent("dragMove", e, [t, i])
                    }
                }, o.dragEnd = function(e, t) {
                    if (this.isDraggable) {
                        this.options.freeScroll && (this.isFreeScrolling = !0);
                        var i = this.dragEndRestingSelect();
                        if (this.options.freeScroll && !this.options.wrapAround) {
                            var n = this.getRestingPosition();
                            this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target
                        } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                        delete this.previousDragX, this.isDragSelect = this.options.wrapAround, this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", e, [t])
                    }
                }, o.dragEndRestingSelect = function() {
                    var e = this.getRestingPosition(),
                        t = Math.abs(this.getSlideDistance(-e, this.selectedIndex)),
                        i = this._getClosestResting(e, t, 1),
                        n = this._getClosestResting(e, t, -1);
                    return i.distance < n.distance ? i.index : n.index
                }, o._getClosestResting = function(e, t, i) {
                    for (var n = this.selectedIndex, s = 1 / 0, o = this.options.contain && !this.options.wrapAround ? function(e, t) {
                            return e <= t
                        } : function(e, t) {
                            return e < t
                        }; o(t, s) && (n += i, s = t, null !== (t = this.getSlideDistance(-e, n)));) t = Math.abs(t);
                    return {
                        distance: s,
                        index: n - i
                    }
                }, o.getSlideDistance = function(e, t) {
                    var i = this.slides.length,
                        n = this.options.wrapAround && i > 1,
                        o = n ? s.modulo(t, i) : t,
                        a = this.slides[o];
                    if (!a) return null;
                    var r = n ? this.slideableWidth * Math.floor(t / i) : 0;
                    return e - (a.target + r)
                }, o.dragEndBoostSelect = function() {
                    if (void 0 === this.previousDragX || !this.dragMoveTime || new Date - this.dragMoveTime > 100) return 0;
                    var e = this.getSlideDistance(-this.dragX, this.selectedIndex),
                        t = this.previousDragX - this.dragX;
                    return e > 0 && t > 0 ? 1 : e < 0 && t < 0 ? -1 : 0
                }, o.staticClick = function(e, t) {
                    var i = this.getParentCell(e.target),
                        n = i && i.element,
                        s = i && this.cells.indexOf(i);
                    this.dispatchEvent("staticClick", e, [t, n, s])
                }, o.onscroll = function() {
                    var e = c(),
                        t = this.pointerDownScroll.x - e.x,
                        i = this.pointerDownScroll.y - e.y;
                    (Math.abs(t) > 3 || Math.abs(i) > 3) && this._pointerDone()
                }, i
            }, e.exports ? e.exports = i(t, X, Z, N) : t.Flickity = i(t, t.Flickity, t.Unidragger, t.fizzyUIUtils)
        }),
        G = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n, s) {
                function o(e, t) {
                    this.direction = e, this.parent = t, this._create()
                }

                function a(e) {
                    return "string" == typeof e ? e : "M " + e.x0 + ",50 L " + e.x1 + "," + (e.y1 + 50) + " L " + e.x2 + "," + (e.y2 + 50) + " L " + e.x3 + ",50  L " + e.x2 + "," + (50 - e.y2) + " L " + e.x1 + "," + (50 - e.y1) + " Z"
                }
                o.prototype = Object.create(n.prototype), o.prototype._create = function() {
                    this.isEnabled = !0, this.isPrevious = -1 == this.direction;
                    var e = this.parent.options.rightToLeft ? 1 : -1;
                    this.isLeft = this.direction == e;
                    var t = this.element = document.createElement("button");
                    t.className = "flickity-button flickity-prev-next-button", t.className += this.isPrevious ? " previous" : " next", t.setAttribute("type", "button"), this.disable(), t.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                    var i = this.createSVG();
                    t.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, o.prototype.activate = function() {
                    this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element)
                }, o.prototype.deactivate = function() {
                    this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this)
                }, o.prototype.createSVG = function() {
                    var e = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    return e.setAttribute("class", "flickity-button-icon"), e.setAttribute("viewBox", "0 0 22 12"), e.setAttribute("width", "22"), e.setAttribute("height", "12"), e.innerHTML = `
				<path d="M0.823357 5.13044C0.533243 5.42055 0.533243 5.89092 0.823357 6.18103L5.551 10.9087C5.84112 11.1988 6.31148 11.1988 6.60159 10.9087C6.8917 10.6186 6.8917 10.1482 6.60159 9.85809L2.39924 5.65573L6.60159 1.45338C6.8917 1.16327 6.8917 0.692902 6.60159 0.40279C6.31148 0.112678 5.84112 0.112678 5.551 0.40279L0.823357 5.13044ZM21.3164 4.91285L1.34865 4.91285L1.34865 6.39861L21.3164 6.39861L21.3164 4.91285Z"/>
				<path stroke="currentColor" stroke-width="2" d="M6 10L2 6l4-4" fill="none" stroke-linecap="square"></path>`, e
                }, o.prototype.handleEvent = s.handleEvent, o.prototype.onclick = function() {
                    if (this.isEnabled) {
                        this.parent.uiChange();
                        var e = this.isPrevious ? "previous" : "next";
                        this.parent[e]()
                    }
                }, o.prototype.enable = function() {
                    !this.isEnabled && (this.element.disabled = !1, this.isEnabled = !0)
                }, o.prototype.disable = function() {
                    this.isEnabled && (this.element.disabled = !0, this.isEnabled = !1)
                }, o.prototype.update = function() {
                    var e = this.parent.slides;
                    if (this.parent.options.wrapAround && e.length > 1) {
                        this.enable();
                        return
                    }
                    var t = e.length ? e.length - 1 : 0,
                        i = this.isPrevious ? 0 : t;
                    this[this.parent.selectedIndex == i ? "disable" : "enable"]()
                }, o.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, s.extend(i.defaults, {
                    prevNextButtons: !0,
                    arrowShape: {
                        x0: 10,
                        x1: 60,
                        y1: 50,
                        x2: 70,
                        y2: 40,
                        x3: 30
                    }
                }), i.createMethods.push("_createPrevNextButtons");
                var r = i.prototype;
                return r._createPrevNextButtons = function() {
                    this.options.prevNextButtons && (this.prevButton = new o(-1, this), this.nextButton = new o(1, this), this.on("activate", this.activatePrevNextButtons))
                }, r.activatePrevNextButtons = function() {
                    this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons)
                }, r.deactivatePrevNextButtons = function() {
                    this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons)
                }, i.PrevNextButton = o, i
            }, e.exports ? e.exports = i(t, X, j, N) : i(t, t.Flickity, t.Unipointer, t.fizzyUIUtils)
        }),
        Q = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n, s) {
                function o(e) {
                    this.parent = e, this._create()
                }
                o.prototype = Object.create(n.prototype), o.prototype._create = function() {
                    this.holder = document.createElement("ol"), this.holder.className = "flickity-page-dots", this.dots = [], this.handleClick = this.onClick.bind(this), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent))
                }, o.prototype.activate = function() {
                    this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder)
                }, o.prototype.deactivate = function() {
                    this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder)
                }, o.prototype.setDots = function() {
                    var e = this.parent.slides.length - this.dots.length;
                    e > 0 ? this.addDots(e) : e < 0 && this.removeDots(-e)
                }, o.prototype.addDots = function(e) {
                    for (var t = document.createDocumentFragment(), i = [], n = this.dots.length, s = n + e, o = n; o < s; o++) {
                        var a = document.createElement("li");
                        a.className = "dot", a.setAttribute("aria-label", "Page dot " + (o + 1)), t.appendChild(a), i.push(a)
                    }
                    this.holder.appendChild(t), this.dots = this.dots.concat(i)
                }, o.prototype.removeDots = function(e) {
                    this.dots.splice(this.dots.length - e, e).forEach(function(e) {
                        this.holder.removeChild(e)
                    }, this)
                }, o.prototype.updateSelected = function() {
                    this.selectedDot && (this.selectedDot.className = "dot", this.selectedDot.removeAttribute("aria-current")), this.dots.length && (this.selectedDot = this.dots[this.parent.selectedIndex], this.selectedDot.className = "dot is-selected", this.selectedDot.setAttribute("aria-current", "step"))
                }, o.prototype.onTap = o.prototype.onClick = function(e) {
                    var t = e.target;
                    if ("LI" == t.nodeName) {
                        this.parent.uiChange();
                        var i = this.dots.indexOf(t);
                        this.parent.select(i)
                    }
                }, o.prototype.destroy = function() {
                    this.deactivate(), this.allOff()
                }, i.PageDots = o, s.extend(i.defaults, {
                    pageDots: !0
                }), i.createMethods.push("_createPageDots");
                var a = i.prototype;
                return a._createPageDots = function() {
                    this.options.pageDots && (this.pageDots = new o(this), this.on("activate", this.activatePageDots), this.on("select", this.updateSelectedPageDots), this.on("cellChange", this.updatePageDots), this.on("resize", this.updatePageDots), this.on("deactivate", this.deactivatePageDots))
                }, a.activatePageDots = function() {
                    this.pageDots.activate()
                }, a.updateSelectedPageDots = function() {
                    this.pageDots.updateSelected()
                }, a.updatePageDots = function() {
                    this.pageDots.setDots()
                }, a.deactivatePageDots = function() {
                    this.pageDots.deactivate()
                }, i.PageDots = o, i
            }, e.exports ? e.exports = i(t, X, j, N) : i(t, t.Flickity, t.Unipointer, t.fizzyUIUtils)
        }),
        K = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n) {
                function s(e) {
                    this.parent = e, this.state = "stopped", this.onVisibilityChange = this.visibilityChange.bind(this), this.onVisibilityPlay = this.visibilityPlay.bind(this)
                }
                s.prototype = Object.create(t.prototype), s.prototype.play = function() {
                    if ("playing" != this.state) {
                        if (document.hidden) {
                            document.addEventListener("visibilitychange", this.onVisibilityPlay);
                            return
                        }
                        this.state = "playing", document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()
                    }
                }, s.prototype.tick = function() {
                    if ("playing" == this.state) {
                        var e = this.parent.options.autoPlay;
                        e = "number" == typeof e ? e : 3e3;
                        var t = this;
                        this.clear(), this.timeout = setTimeout(function() {
                            t.parent.next(!0), t.tick()
                        }, e)
                    }
                }, s.prototype.stop = function() {
                    this.state = "stopped", this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange)
                }, s.prototype.clear = function() {
                    clearTimeout(this.timeout)
                }, s.prototype.pause = function() {
                    "playing" == this.state && (this.state = "paused", this.clear())
                }, s.prototype.unpause = function() {
                    "paused" == this.state && this.play()
                }, s.prototype.visibilityChange = function() {
                    this[document.hidden ? "pause" : "unpause"]()
                }, s.prototype.visibilityPlay = function() {
                    this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay)
                }, i.extend(n.defaults, {
                    pauseAutoPlayOnHover: !0
                }), n.createMethods.push("_createPlayer");
                var o = n.prototype;
                return o._createPlayer = function() {
                    this.player = new s(this), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer)
                }, o.activatePlayer = function() {
                    this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this))
                }, o.playPlayer = function() {
                    this.player.play()
                }, o.stopPlayer = function() {
                    this.player.stop()
                }, o.pausePlayer = function() {
                    this.player.pause()
                }, o.unpausePlayer = function() {
                    this.player.unpause()
                }, o.deactivatePlayer = function() {
                    this.player.stop(), this.element.removeEventListener("mouseenter", this)
                }, o.onmouseenter = function() {
                    this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this))
                }, o.onmouseleave = function() {
                    this.player.unpause(), this.element.removeEventListener("mouseleave", this)
                }, n.Player = s, n
            }, e.exports ? e.exports = i(H, N, X) : i(t.EvEmitter, t.fizzyUIUtils, t.Flickity)
        }),
        J = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n) {
                var s = i.prototype;
                return s.insert = function(e, t) {
                    var i = this._makeCells(e);
                    if (i && i.length) {
                        var n, s, o = this.cells.length;
                        t = void 0 === t ? o : t;
                        var a = (n = i, s = document.createDocumentFragment(), n.forEach(function(e) {
                                s.appendChild(e.element)
                            }), s),
                            r = t == o;
                        if (r) this.slider.appendChild(a);
                        else {
                            var l = this.cells[t].element;
                            this.slider.insertBefore(a, l)
                        }
                        if (0 === t) this.cells = i.concat(this.cells);
                        else if (r) this.cells = this.cells.concat(i);
                        else {
                            var c = this.cells.splice(t, o - t);
                            this.cells = this.cells.concat(i).concat(c)
                        }
                        this._sizeCells(i), this.cellChange(t, !0)
                    }
                }, s.append = function(e) {
                    this.insert(e, this.cells.length)
                }, s.prepend = function(e) {
                    this.insert(e, 0)
                }, s.remove = function(e) {
                    var t = this.getCells(e);
                    if (t && t.length) {
                        var i = this.cells.length - 1;
                        t.forEach(function(e) {
                            e.remove(), i = Math.min(this.cells.indexOf(e), i), n.removeFrom(this.cells, e)
                        }, this), this.cellChange(i, !0)
                    }
                }, s.cellSizeChange = function(e) {
                    var t = this.getCell(e);
                    if (t) {
                        t.getSize();
                        var i = this.cells.indexOf(t);
                        this.cellChange(i)
                    }
                }, s.cellChange = function(e, t) {
                    var i = this.selectedElement;
                    this._positionCells(e), this._getWrapShiftCells(), this.setGallerySize();
                    var n = this.getCell(i);
                    n && (this.selectedIndex = this.getCellSlideIndex(n)), this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex), this.emitEvent("cellChange", [e]), this.select(this.selectedIndex), t && this.positionSliderAtSelected()
                }, i
            }, e.exports ? e.exports = i(t, X, N) : i(t, t.Flickity, t.fizzyUIUtils)
        }),
        ee = f(function(e) {
            var t, i;
            t = window, i = function e(t, i, n) {
                i.createMethods.push("_createLazyload");
                var s = i.prototype;

                function o(e, t) {
                    this.img = e, this.flickity = t, this.load()
                }
                return s._createLazyload = function() {
                    this.on("select", this.lazyLoad)
                }, s.lazyLoad = function() {
                    var e = this.options.lazyLoad;
                    if (e) {
                        var t = this.getAdjacentCellElements("number" == typeof e ? e : 0),
                            i = [];
                        t.forEach(function(e) {
                            var t = function e(t) {
                                if ("IMG" == t.nodeName) {
                                    var i = t.getAttribute("data-flickity-lazyload"),
                                        s = t.getAttribute("data-flickity-lazyload-src"),
                                        o = t.getAttribute("data-flickity-lazyload-srcset");
                                    if (i || s || o) return [t]
                                }
                                var a = t.querySelectorAll("img[data-flickity-lazyload], img[data-flickity-lazyload-src], img[data-flickity-lazyload-srcset]");
                                return n.makeArray(a)
                            }(e);
                            i = i.concat(t)
                        }), i.forEach(function(e) {
                            new o(e, this)
                        }, this)
                    }
                }, o.prototype.handleEvent = n.handleEvent, o.prototype.load = function() {
                    this.img.addEventListener("load", this), this.img.addEventListener("error", this);
                    var e = this.img.getAttribute("data-flickity-lazyload") || this.img.getAttribute("data-flickity-lazyload-src"),
                        t = this.img.getAttribute("data-flickity-lazyload-srcset");
                    this.img.src = e, t && this.img.setAttribute("srcset", t), this.img.removeAttribute("data-flickity-lazyload"), this.img.removeAttribute("data-flickity-lazyload-src"), this.img.removeAttribute("data-flickity-lazyload-srcset")
                }, o.prototype.onload = function(e) {
                    this.complete(e, "flickity-lazyloaded")
                }, o.prototype.onerror = function(e) {
                    this.complete(e, "flickity-lazyerror")
                }, o.prototype.complete = function(e, t) {
                    this.img.removeEventListener("load", this), this.img.removeEventListener("error", this);
                    var i = this.flickity.getParentCell(this.img),
                        n = i && i.element;
                    this.flickity.cellSizeChange(n), this.img.classList.add(t), this.flickity.dispatchEvent("lazyLoad", e, n)
                }, i.LazyLoader = o, i
            }, e.exports ? e.exports = i(t, X, N) : i(t, t.Flickity, t.fizzyUIUtils)
        }),
        et = f(function(e) {
            var t, i;
            window, i = function e(t) {
                return t
            }, e.exports && (e.exports = i(X, Y, G, Q, K, J, ee))
        }),
        ei = f(function(e) {
            var t, i;
            t = p, i = function e(t, i) {
                var n = t.Slide,
                    s = n.prototype.updateTarget;
                n.prototype.updateTarget = function() {
                    if (s.apply(this, arguments), this.parent.options.fade) {
                        var e = this.target - this.x,
                            t = this.cells[0].x;
                        this.cells.forEach(function(i) {
                            var n = i.x - t - e;
                            i.renderPosition(n)
                        })
                    }
                }, n.prototype.setOpacity = function(e) {
                    this.cells.forEach(function(t) {
                        t.element.style.opacity = e
                    })
                };
                var o = t.prototype;
                t.createMethods.push("_createFade"), o._createFade = function() {
                    this.fadeIndex = this.selectedIndex, this.prevSelectedIndex = this.selectedIndex, this.on("select", this.onSelectFade), this.on("dragEnd", this.onDragEndFade), this.on("settle", this.onSettleFade), this.on("activate", this.onActivateFade), this.on("deactivate", this.onDeactivateFade)
                };
                var a = o.updateSlides;
                o.updateSlides = function() {
                    a.apply(this, arguments), this.options.fade && this.slides.forEach(function(e, t) {
                        var i = t == this.selectedIndex ? 1 : 0;
                        e.setOpacity(i)
                    }, this)
                }, o.onSelectFade = function() {
                    this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1), this.prevSelectedIndex = this.selectedIndex
                }, o.onSettleFade = function() {
                    delete this.didDragEnd, this.options.fade && (this.selectedSlide.setOpacity(1), this.slides[this.fadeIndex] && this.fadeIndex != this.selectedIndex && this.slides[this.fadeIndex].setOpacity(0))
                }, o.onDragEndFade = function() {
                    this.didDragEnd = !0
                }, o.onActivateFade = function() {
                    this.options.fade && this.element.classList.add("is-fade")
                }, o.onDeactivateFade = function() {
                    this.options.fade && (this.element.classList.remove("is-fade"), this.slides.forEach(function(e) {
                        e.setOpacity("")
                    }))
                };
                var r = o.positionSlider;
                o.positionSlider = function() {
                    if (!this.options.fade) {
                        r.apply(this, arguments);
                        return
                    }
                    this.fadeSlides(), this.dispatchScrollEvent()
                };
                var l = o.positionSliderAtSelected;
                o.positionSliderAtSelected = function() {
                    this.options.fade && this.setTranslateX(0), l.apply(this, arguments)
                }, o.fadeSlides = function() {
                    if (!(this.slides.length < 2)) {
                        var e = this.getFadeIndexes(),
                            t = this.slides[e.a],
                            i = this.slides[e.b],
                            n = this.wrapDifference(t.target, i.target),
                            s = this.wrapDifference(t.target, -this.x);
                        s /= n, t.setOpacity(1 - s), i.setOpacity(s);
                        var o = e.a;
                        this.isDragging && (o = s > .5 ? e.a : e.b), void 0 != this.fadeHideIndex && this.fadeHideIndex != o && this.fadeHideIndex != e.a && this.fadeHideIndex != e.b && this.slides[this.fadeHideIndex].setOpacity(0), this.fadeHideIndex = o
                    }
                }, o.getFadeIndexes = function() {
                    return this.isDragging || this.didDragEnd ? this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes() : {
                        a: this.fadeIndex,
                        b: this.selectedIndex
                    }
                }, o.getFadeDragWrapIndexes = function() {
                    var e = this.slides.map(function(e, t) {
                            return this.getSlideDistance(-this.x, t)
                        }, this),
                        t = e.map(function(e) {
                            return Math.abs(e)
                        }),
                        n = Math.min.apply(Math, t),
                        s = t.indexOf(n),
                        o = e[s],
                        a = this.slides.length;
                    return {
                        a: s,
                        b: i.modulo(s + (o >= 0 ? 1 : -1), a)
                    }
                }, o.getFadeDragLimitIndexes = function() {
                    for (var e = 0, t = 0; t < this.slides.length - 1; t++) {
                        var i = this.slides[t];
                        if (-this.x < i.target) break;
                        e = t
                    }
                    return {
                        a: e,
                        b: e + 1
                    }
                }, o.wrapDifference = function(e, t) {
                    var i = t - e;
                    if (!this.options.wrapAround) return i;
                    var n = i + this.slideableWidth,
                        s = i - this.slideableWidth;
                    return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(s) < Math.abs(i) && (i = s), i
                };
                var c = o._getWrapShiftCells;
                o._getWrapShiftCells = function() {
                    this.options.fade || c.apply(this, arguments)
                };
                var h = o.shiftWrapCells;
                return o.shiftWrapCells = function() {
                    this.options.fade || h.apply(this, arguments)
                }, t
            }, e.exports ? e.exports = i(et, N) : i(t.Flickity, t.fizzyUIUtils)
        }),
        en = f(function(t, i) {
            var n, s;
            s = function() {
                return function t(i, n, s, o) {
                    var a = {
                        features: null,
                        bind: function e(t, i, n, s) {
                            var o = (s ? "remove" : "add") + "EventListener";
                            i = i.split(" ");
                            for (var a = 0; a < i.length; a++) i[a] && t[o](i[a], n, !1)
                        },
                        isArray: function e(t) {
                            return t instanceof Array
                        },
                        createEl: function e(t, i) {
                            var n = document.createElement(i || "div");
                            return t && (n.className = t), n
                        },
                        getScrollY: function e() {
                            var t = window.pageYOffset;
                            return void 0 !== t ? t : document.documentElement.scrollTop
                        },
                        unbind: function e(t, i, n) {
                            a.bind(t, i, n, !0)
                        },
                        removeClass: function e(t, i) {
                            var n = RegExp("(\\s|^)" + i + "(\\s|$)");
                            t.className = t.className.replace(n, " ").replace(/^\s\s*/, "").replace(/\s\s*$/, "")
                        },
                        addClass: function e(t, i) {
                            a.hasClass(t, i) || (t.className += (t.className ? " " : "") + i)
                        },
                        hasClass: function e(t, i) {
                            return t.className && RegExp("(^|\\s)" + i + "(\\s|$)").test(t.className)
                        },
                        getChildByClass: function e(t, i) {
                            for (var n = t.firstChild; n;) {
                                if (a.hasClass(n, i)) return n;
                                n = n.nextSibling
                            }
                        },
                        arraySearch: function e(t, i, n) {
                            for (var s = t.length; s--;)
                                if (t[s][n] === i) return s;
                            return -1
                        },
                        extend: function e(t, i, n) {
                            for (var s in i)
                                if (i.hasOwnProperty(s)) {
                                    if (n && t.hasOwnProperty(s)) continue;
                                    t[s] = i[s]
                                }
                        },
                        easing: {
                            sine: {
                                out: function e(t) {
                                    return Math.sin(t * (Math.PI / 2))
                                },
                                inOut: function e(t) {
                                    return -(Math.cos(Math.PI * t) - 1) / 2
                                }
                            },
                            cubic: {
                                out: function e(t) {
                                    return --t * t * t + 1
                                }
                            }
                        },
                        detectFeatures: function e() {
                            if (a.features) return a.features;
                            var t = a.createEl().style,
                                i = "",
                                n = {};
                            if (n.oldIE = document.all && !document.addEventListener, n.touch = "ontouchstart" in window, window.requestAnimationFrame && (n.raf = window.requestAnimationFrame, n.caf = window.cancelAnimationFrame), n.pointerEvent = !!window.PointerEvent || navigator.msPointerEnabled, !n.pointerEvent) {
                                var s = navigator.userAgent;
                                if (/iP(hone|od)/.test(navigator.platform)) {
                                    var o = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
                                    o && o.length > 0 && (o = parseInt(o[1], 10)) >= 1 && o < 8 && (n.isOldIOSPhone = !0)
                                }
                                var r = s.match(/Android\s([0-9\.]*)/),
                                    l = r ? r[1] : 0;
                                (l = parseFloat(l)) >= 1 && (l < 4.4 && (n.isOldAndroid = !0), n.androidVersion = l), n.isMobileOpera = /opera mini|opera mobi/i.test(s)
                            }
                            for (var c, h, u = ["transform", "perspective", "animationName"], d = ["", "webkit", "Moz", "ms", "O"], p = 0; p < 4; p++) {
                                i = d[p];
                                for (var f = 0; f < 3; f++) c = u[f], h = i + (i ? c.charAt(0).toUpperCase() + c.slice(1) : c), !n[c] && h in t && (n[c] = h);
                                i && !n.raf && (i = i.toLowerCase(), n.raf = window[i + "RequestAnimationFrame"], n.raf && (n.caf = window[i + "CancelAnimationFrame"] || window[i + "CancelRequestAnimationFrame"]))
                            }
                            if (!n.raf) {
                                var m = 0;
                                n.raf = function(e) {
                                    var t = new Date().getTime(),
                                        i = Math.max(0, 16 - (t - m)),
                                        n = window.setTimeout(function() {
                                            e(t + i)
                                        }, i);
                                    return m = t + i, n
                                }, n.caf = function(e) {
                                    clearTimeout(e)
                                }
                            }
                            return n.svg = !!document.createElementNS && !!document.createElementNS("http://www.w3.org/2000/svg", "svg").createSVGRect, a.features = n, n
                        }
                    };
                    a.detectFeatures(), a.features.oldIE && (a.bind = function(t, i, n, s) {
                        i = i.split(" ");
                        for (var o, a = (s ? "detach" : "attach") + "Event", r = function e() {
                                n.handleEvent.call(n)
                            }, l = 0; l < i.length; l++)
                            if (o = i[l]) {
                                if ("object" === e(n) && n.handleEvent) {
                                    if (s) {
                                        if (!n["oldIE" + o]) return !1
                                    } else n["oldIE" + o] = r;
                                    t[a]("on" + o, n["oldIE" + o])
                                } else t[a]("on" + o, n)
                            }
                    });
                    var r = this,
                        l = {
                            allowPanToNext: !0,
                            spacing: .12,
                            bgOpacity: 1,
                            mouseUsed: !1,
                            loop: !0,
                            pinchToClose: !0,
                            closeOnScroll: !0,
                            closeOnVerticalDrag: !0,
                            verticalDragRange: .75,
                            hideAnimationDuration: 333,
                            showAnimationDuration: 333,
                            showHideOpacity: !1,
                            focus: !0,
                            escKey: !0,
                            arrowKeys: !0,
                            mainScrollEndFriction: .35,
                            panEndFriction: .35,
                            isClickableElement: function e(t) {
                                return "A" === t.tagName
                            },
                            getDoubleTapZoom: function e(t, i) {
                                return t ? 1 : i.initialZoomLevel < .7 ? 1 : 1.33
                            },
                            maxSpreadZoom: 1.33,
                            modal: !0,
                            scaleMode: "fit"
                        };
                    a.extend(l, o);
                    var c, h, u, d, p, f, m, v, g, y, b, $, w, E, k, S, x, _, C, L, A, P, I, z, D, T, M, q, O, B, H, R, F, N, U, W, V, X, j, Z, Y, G, Q, K, J, ee, et, ei, en, es, eo, ea, er, el, ec, eh, eu, ed = function e() {
                            return {
                                x: 0,
                                y: 0
                            }
                        },
                        ep = ed(),
                        ef = ed(),
                        em = ed(),
                        ev = {},
                        eg = 0,
                        ey = {},
                        eb = ed(),
                        e8 = 0,
                        e$ = !0,
                        ew = [],
                        eE = {},
                        ek = !1,
                        eS = function e(t, i) {
                            a.extend(r, i.publicMethods), ew.push(t)
                        },
                        ex = function e(t) {
                            var i = tq();
                            return t > i - 1 ? t - i : t < 0 ? i + t : t
                        },
                        e_ = {},
                        eC = function e(t, i) {
                            return e_[t] || (e_[t] = []), e_[t].push(i)
                        },
                        eL = function e(t) {
                            var i = e_[t];
                            if (i) {
                                var n = Array.prototype.slice.call(arguments);
                                n.shift();
                                for (var s = 0; s < i.length; s++) i[s].apply(r, n)
                            }
                        },
                        eA = function e() {
                            return new Date().getTime()
                        },
                        eP = function e(t) {
                            ec = t, r.bg.style.opacity = t * l.bgOpacity
                        },
                        eI = function e(t, i, n, s, o) {
                            (!ek || o && o !== r.currItem) && (s /= o ? o.fitRatio : r.currItem.fitRatio), t[P] = $ + i + "px, " + n + "px" + w + " scale(" + s + ")"
                        },
                        ez = function e(t) {
                            es && (t && (y > r.currItem.fitRatio ? ek || (t4(r.currItem, !1, !0), ek = !0) : ek && (t4(r.currItem), ek = !1)), eI(es, em.x, em.y, y))
                        },
                        eD = function e(t) {
                            t.container && eI(t.container.style, t.initialPosition.x, t.initialPosition.y, t.initialZoomLevel, t)
                        },
                        eT = function e(t, i) {
                            i[P] = $ + t + "px, 0px" + w
                        },
                        eM = function e(t, i) {
                            if (!l.loop && i) {
                                var n = d + (eb.x * eg - t) / eb.x,
                                    s = Math.round(t - ta.x);
                                (n < 0 && s > 0 || n >= tq() - 1 && s < 0) && (t = ta.x + s * l.mainScrollEndFriction)
                            }
                            ta.x = t, eT(t, p)
                        },
                        eq = function e(t, i) {
                            var n = tr[t] - ey[t];
                            return ef[t] + ep[t] + n - n * (i / b)
                        },
                        eO = function e(t, i) {
                            t.x = i.x, t.y = i.y, i.id && (t.id = i.id)
                        },
                        eB = function e(t) {
                            t.x = Math.round(t.x), t.y = Math.round(t.y)
                        },
                        eH = null,
                        eR = function e() {
                            eH && (a.unbind(document, "mousemove", e), a.addClass(i, "pswp--has_mouse"), l.mouseUsed = !0, eL("mouseUsed")), eH = setTimeout(function() {
                                eH = null
                            }, 100)
                        },
                        e0 = function e() {
                            a.bind(document, "keydown", r), H.transform && a.bind(r.scrollWrap, "click", r), l.mouseUsed || a.bind(document, "mousemove", eR), a.bind(window, "resize scroll orientationchange", r), eL("bindEvents")
                        },
                        eF = function e() {
                            a.unbind(window, "resize scroll orientationchange", r), a.unbind(window, "scroll", g.scroll), a.unbind(document, "keydown", r), a.unbind(document, "mousemove", eR), H.transform && a.unbind(r.scrollWrap, "click", r), j && a.unbind(window, m, r), clearTimeout(R), eL("unbindEvents")
                        },
                        e1 = function e(t, i) {
                            var n = t1(r.currItem, ev, t);
                            return i && (en = n), n
                        },
                        eN = function e(t) {
                            return t || (t = r.currItem), t.initialZoomLevel
                        },
                        eU = function e(t) {
                            return t || (t = r.currItem), t.w > 0 ? l.maxSpreadZoom : 1
                        },
                        eW = function e(t, i, n, s) {
                            return s === r.currItem.initialZoomLevel ? (n[t] = r.currItem.initialPosition[t], !0) : (n[t] = eq(t, s), n[t] > i.min[t]) ? (n[t] = i.min[t], !0) : !!(n[t] < i.max[t]) && (n[t] = i.max[t], !0)
                        },
                        e4 = function e() {
                            if (P) {
                                $ = "translate" + (H.perspective && !z ? "3d(" : "("), w = H.perspective ? ", 0px)" : ")";
                                return
                            }
                            P = "left", a.addClass(i, "pswp--ie"), eT = function e(t, i) {
                                i.left = t + "px"
                            }, eD = function e(t) {
                                var i = t.fitRatio > 1 ? 1 : t.fitRatio,
                                    n = t.container.style,
                                    s = i * t.w,
                                    o = i * t.h;
                                n.width = s + "px", n.height = o + "px", n.left = t.initialPosition.x + "px", n.top = t.initialPosition.y + "px"
                            }, ez = function e() {
                                if (es) {
                                    var t = es,
                                        i = r.currItem,
                                        n = i.fitRatio > 1 ? 1 : i.fitRatio,
                                        s = n * i.w,
                                        o = n * i.h;
                                    t.width = s + "px", t.height = o + "px", t.left = em.x + "px", t.top = em.y + "px"
                                }
                            }
                        },
                        eV = function e(t) {
                            var i = "";
                            l.escKey && 27 === t.keyCode ? i = "close" : l.arrowKeys && (37 === t.keyCode ? i = "prev" : 39 === t.keyCode && (i = "next")), !i || t.ctrlKey || t.altKey || t.shiftKey || t.metaKey || (t.preventDefault ? t.preventDefault() : t.returnValue = !1, r[i]())
                        },
                        e3 = function e(t) {
                            t && (G || Y || eo || V) && (t.preventDefault(), t.stopPropagation())
                        },
                        e6 = function e() {
                            r.setScrollOffset(0, a.getScrollY())
                        },
                        e2 = {},
                        eX = 0,
                        e7 = function e(t) {
                            e2[t] && (e2[t].raf && T(e2[t].raf), eX--, delete e2[t])
                        },
                        ej = function e(t) {
                            e2[t] && e7(t), e2[t] || (eX++, e2[t] = {})
                        },
                        eZ = function e() {
                            for (var t in e2) e2.hasOwnProperty(t) && e7(t)
                        },
                        eY = function e(t, i, n, s, o, a, r) {
                            var l, c = eA();
                            ej(t), ! function e() {
                                if (e2[t]) {
                                    if ((l = eA() - c) >= s) {
                                        e7(t), a(n), r && r();
                                        return
                                    }
                                    a((n - i) * o(l / s) + i), e2[t].raf = D(e)
                                }
                            }()
                        },
                        e5 = {},
                        eG = {},
                        eQ = {},
                        eK = {},
                        e9 = {},
                        eJ = [],
                        te = {},
                        tt = [],
                        ti = {},
                        tn = 0,
                        ts = ed(),
                        to = 0,
                        ta = ed(),
                        tr = ed(),
                        tl = ed(),
                        tc = function e(t, i) {
                            return ti.x = Math.abs(t.x - i.x), ti.y = Math.abs(t.y - i.y), Math.sqrt(ti.x * ti.x + ti.y * ti.y)
                        },
                        th = function e() {
                            Q && (T(Q), Q = null)
                        },
                        tu = function e() {
                            j && (Q = D(e), tS())
                        },
                        td = {},
                        tp = function e(t, i) {
                            return td.prevent = ! function e(t, i) {
                                return !(!t || t === document || t.getAttribute("class") && t.getAttribute("class").indexOf("pswp__scroll-wrap") > -1) && (i(t) ? t : e(t.parentNode, i))
                            }(t.target, l.isClickableElement), eL("preventDragEvent", t, i, td), td.prevent
                        },
                        tf = function e(t, i) {
                            return i.x = t.pageX, i.y = t.pageY, i.id = t.identifier, i
                        },
                        tm = function e(t, i, n) {
                            n.x = (t.x + i.x) * .5, n.y = (t.y + i.y) * .5
                        },
                        tv = function e(t, i, n) {
                            if (t - N > 50) {
                                var s = tt.length > 2 ? tt.shift() : {};
                                s.x = i, s.y = n, tt.push(s), N = t
                            }
                        },
                        tg = function e() {
                            return 1 - Math.abs((em.y - r.currItem.initialPosition.y) / (ev.y / 2))
                        },
                        ty = {},
                        tb = {},
                        t8 = [],
                        t$ = function e(t) {
                            for (; t8.length > 0;) t8.pop();
                            return I ? (eu = 0, eJ.forEach(function(e) {
                                0 === eu ? t8[0] = e : 1 === eu && (t8[1] = e), eu++
                            })) : t.type.indexOf("touch") > -1 ? t.touches && t.touches.length > 0 && (t8[0] = tf(t.touches[0], ty), t.touches.length > 1 && (t8[1] = tf(t.touches[1], tb))) : (ty.x = t.pageX, ty.y = t.pageY, ty.id = "", t8[0] = ty), t8
                        },
                        tw = function e(t, i) {
                            var n, s, o, a, c = 0,
                                h = em[t] + i[t],
                                u = i[t] > 0,
                                d = ta.x + i.x,
                                p = ta.x - te.x;
                            if (n = h > en.min[t] || h < en.max[t] ? l.panEndFriction : 1, h = em[t] + i[t] * n, (l.allowPanToNext || y === r.currItem.initialZoomLevel) && (es ? "h" === ea && "x" === t && !Y && (u ? (h > en.min[t] && (n = l.panEndFriction, c = en.min[t] - h, s = en.min[t] - ef[t]), (s <= 0 || p < 0) && tq() > 1 ? (a = d, p < 0 && d > te.x && (a = te.x)) : en.min.x !== en.max.x && (o = h)) : (h < en.max[t] && (n = l.panEndFriction, c = h - en.max[t], s = ef[t] - en.max[t]), (s <= 0 || p > 0) && tq() > 1 ? (a = d, p > 0 && d < te.x && (a = te.x)) : en.min.x !== en.max.x && (o = h))) : a = d, "x" === t)) return void 0 !== a && (eM(a, !0), K = a !== te.x), en.min.x === en.max.x || (void 0 !== o ? em.x = o : K || (em.x += i.x * n)), void 0 !== a;
                            eo || K || !(y > r.currItem.fitRatio) || (em[t] += i[t] * n)
                        },
                        tE = function e(t) {
                            if ("mousedown" !== t.type || !(t.button > 0)) {
                                if (tT) {
                                    t.preventDefault();
                                    return
                                }
                                if (!X || "mousedown" !== t.type) {
                                    if (tp(t, !0) && t.preventDefault(), eL("pointerDown"), I) {
                                        var i = a.arraySearch(eJ, t.pointerId, "id");
                                        i < 0 && (i = eJ.length), eJ[i] = {
                                            x: t.pageX,
                                            y: t.pageY,
                                            id: t.pointerId
                                        }
                                    }
                                    var n = t$(t),
                                        s = n.length;
                                    J = null, eZ(), j && 1 !== s || (j = er = !0, a.bind(window, m, r), W = eh = el = V = K = G = Z = Y = !1, ea = null, eL("firstTouchStart", n), eO(ef, em), ep.x = ep.y = 0, eO(eK, n[0]), eO(e9, eK), te.x = eb.x * eg, tt = [{
                                        x: eK.x,
                                        y: eK.y
                                    }, ], N = F = eA(), e1(y, !0), th(), tu()), ee || !(s > 1) || eo || K || (b = y, Y = !1, ee = Z = !0, ep.y = ep.x = 0, eO(ef, em), eO(e5, n[0]), eO(eG, n[1]), tm(e5, eG, tl), tr.x = Math.abs(tl.x) - em.x, tr.y = Math.abs(tl.y) - em.y, et = ei = tc(e5, eG))
                                }
                            }
                        },
                        tk = function e(t) {
                            if (t.preventDefault(), I) {
                                var i = a.arraySearch(eJ, t.pointerId, "id");
                                if (i > -1) {
                                    var n = eJ[i];
                                    n.x = t.pageX, n.y = t.pageY
                                }
                            }
                            if (j) {
                                var s = t$(t);
                                if (ea || G || ee) J = s;
                                else if (ta.x !== eb.x * eg) ea = "h";
                                else {
                                    var o = Math.abs(s[0].x - eK.x) - Math.abs(s[0].y - eK.y);
                                    Math.abs(o) >= 10 && (ea = o > 0 ? "h" : "v", J = s)
                                }
                            }
                        },
                        tS = function e() {
                            if (J) {
                                var t = J.length;
                                if (0 !== t) {
                                    if (eO(e5, J[0]), eQ.x = e5.x - eK.x, eQ.y = e5.y - eK.y, ee && t > 1) {
                                        if (eK.x = e5.x, eK.y = e5.y, !eQ.x && !eQ.y && (c = J[1], h = eG, c.x === h.x && c.y === h.y)) return;
                                        eO(eG, J[1]), Y || (Y = !0, eL("zoomGestureStarted"));
                                        var i = tc(e5, eG),
                                            n = tA(i);
                                        n > r.currItem.initialZoomLevel + r.currItem.initialZoomLevel / 15 && (eh = !0);
                                        var s = 1,
                                            o = eN(),
                                            a = eU();
                                        if (n < o) {
                                            if (l.pinchToClose && !eh && b <= r.currItem.initialZoomLevel) {
                                                var c, h, u = 1 - (o - n) / (o / 1.2);
                                                eP(u), eL("onPinchClose", u), el = !0
                                            } else(s = (o - n) / o) > 1 && (s = 1), n = o - s * (o / 3)
                                        } else n > a && ((s = (n - a) / (6 * o)) > 1 && (s = 1), n = a + s * o);
                                        s < 0 && (s = 0), et = i, tm(e5, eG, ts), ep.x += ts.x - tl.x, ep.y += ts.y - tl.y, eO(tl, ts), em.x = eq("x", n), em.y = eq("y", n), W = n > y, y = n, ez()
                                    } else {
                                        if (!ea || (er && (er = !1, Math.abs(eQ.x) >= 10 && (eQ.x -= J[0].x - e9.x), Math.abs(eQ.y) >= 10 && (eQ.y -= J[0].y - e9.y)), eK.x = e5.x, eK.y = e5.y, 0 === eQ.x && 0 === eQ.y)) return;
                                        if ("v" === ea && l.closeOnVerticalDrag && "fit" === l.scaleMode && y === r.currItem.initialZoomLevel) {
                                            ep.y += eQ.y, em.y += eQ.y;
                                            var d = tg();
                                            V = !0, eL("onVerticalDrag", d), eP(d), ez();
                                            return
                                        }
                                        tv(eA(), e5.x, e5.y), G = !0, en = r.currItem.bounds, tw("x", eQ) || (tw("y", eQ), eB(em), ez())
                                    }
                                }
                            }
                        },
                        tx = function e(t) {
                            if (H.isOldAndroid) {
                                if (X && "mouseup" === t.type) return;
                                t.type.indexOf("touch") > -1 && (clearTimeout(X), X = setTimeout(function() {
                                    X = 0
                                }, 600))
                            }
                            if (eL("pointerUp"), tp(t, !1) && t.preventDefault(), I) {
                                var i = a.arraySearch(eJ, t.pointerId, "id");
                                i > -1 && (n = eJ.splice(i, 1)[0], navigator.msPointerEnabled ? (n.type = ({
                                    4: "mouse",
                                    2: "touch",
                                    3: "pen"
                                })[t.pointerType], n.type || (n.type = t.pointerType || "mouse")) : n.type = t.pointerType || "mouse")
                            }
                            var n, s, o = t$(t),
                                c = o.length;
                            if ("mouseup" === t.type && (c = 0), 2 === c) return J = null, !0;
                            1 === c && eO(e9, o[0]), 0 !== c || ea || eo || (!n && ("mouseup" === t.type ? n = {
                                x: t.pageX,
                                y: t.pageY,
                                type: "mouse"
                            } : t.changedTouches && t.changedTouches[0] && (n = {
                                x: t.changedTouches[0].pageX,
                                y: t.changedTouches[0].pageY,
                                type: "touch"
                            })), eL("touchRelease", t, n));
                            var h = -1;
                            if (0 === c && (j = !1, a.unbind(window, m, r), th(), ee ? h = 0 : -1 !== to && (h = eA() - to)), to = 1 === c ? eA() : -1, s = -1 !== h && h < 150 ? "zoom" : "swipe", ee && c < 2 && (ee = !1, 1 === c && (s = "zoomPointerUp"), eL("zoomGestureEnded")), J = null, G || Y || eo || V) {
                                if (eZ(), U || (U = t_()), U.calculateSwipeSpeed("x"), V) {
                                    if (tg() < l.verticalDragRange) r.close();
                                    else {
                                        var u = em.y,
                                            d = ec;
                                        eY("verticalDrag", 0, 1, 300, a.easing.cubic.out, function(e) {
                                            em.y = (r.currItem.initialPosition.y - u) * e + u, eP((1 - d) * e + d), ez()
                                        }), eL("onVerticalDrag", 1)
                                    }
                                    return
                                }
                                if ((K || eo) && 0 === c) {
                                    if (tL(s, U)) return;
                                    s = "zoomPointerUp"
                                }
                                if (!eo) {
                                    if ("swipe" !== s) {
                                        tP();
                                        return
                                    }!K && y > r.currItem.fitRatio && tC(U)
                                }
                            }
                        },
                        t_ = function e() {
                            var t, i, n = {
                                lastFlickOffset: {},
                                lastFlickDist: {},
                                lastFlickSpeed: {},
                                slowDownRatio: {},
                                slowDownRatioReverse: {},
                                speedDecelerationRatio: {},
                                speedDecelerationRatioAbs: {},
                                distanceOffset: {},
                                backAnimDestination: {},
                                backAnimStarted: {},
                                calculateSwipeSpeed: function e(s) {
                                    tt.length > 1 ? (t = eA() - N + 50, i = tt[tt.length - 2][s]) : (t = eA() - F, i = e9[s]), n.lastFlickOffset[s] = eK[s] - i, n.lastFlickDist[s] = Math.abs(n.lastFlickOffset[s]), n.lastFlickDist[s] > 20 ? n.lastFlickSpeed[s] = n.lastFlickOffset[s] / t : n.lastFlickSpeed[s] = 0, .1 > Math.abs(n.lastFlickSpeed[s]) && (n.lastFlickSpeed[s] = 0), n.slowDownRatio[s] = .95, n.slowDownRatioReverse[s] = 1 - n.slowDownRatio[s], n.speedDecelerationRatio[s] = 1
                                },
                                calculateOverBoundsAnimOffset: function e(t, i) {
                                    !n.backAnimStarted[t] && (em[t] > en.min[t] ? n.backAnimDestination[t] = en.min[t] : em[t] < en.max[t] && (n.backAnimDestination[t] = en.max[t]), void 0 !== n.backAnimDestination[t] && (n.slowDownRatio[t] = .7, n.slowDownRatioReverse[t] = 1 - n.slowDownRatio[t], n.speedDecelerationRatioAbs[t] < .05 && (n.lastFlickSpeed[t] = 0, n.backAnimStarted[t] = !0, eY("bounceZoomPan" + t, em[t], n.backAnimDestination[t], i || 300, a.easing.sine.out, function(e) {
                                        em[t] = e, ez()
                                    }))))
                                },
                                calculateAnimOffset: function e(t) {
                                    n.backAnimStarted[t] || (n.speedDecelerationRatio[t] = n.speedDecelerationRatio[t] * (n.slowDownRatio[t] + n.slowDownRatioReverse[t] - n.slowDownRatioReverse[t] * n.timeDiff / 10), n.speedDecelerationRatioAbs[t] = Math.abs(n.lastFlickSpeed[t] * n.speedDecelerationRatio[t]), n.distanceOffset[t] = n.lastFlickSpeed[t] * n.speedDecelerationRatio[t] * n.timeDiff, em[t] += n.distanceOffset[t])
                                },
                                panAnimLoop: function e() {
                                    if (e2.zoomPan && (e2.zoomPan.raf = D(n.panAnimLoop), n.now = eA(), n.timeDiff = n.now - n.lastNow, n.lastNow = n.now, n.calculateAnimOffset("x"), n.calculateAnimOffset("y"), ez(), n.calculateOverBoundsAnimOffset("x"), n.calculateOverBoundsAnimOffset("y"), n.speedDecelerationRatioAbs.x < .05 && n.speedDecelerationRatioAbs.y < .05)) {
                                        em.x = Math.round(em.x), em.y = Math.round(em.y), ez(), e7("zoomPan");
                                        return
                                    }
                                }
                            };
                            return n
                        },
                        tC = function e(t) {
                            if (t.calculateSwipeSpeed("y"), en = r.currItem.bounds, t.backAnimDestination = {}, t.backAnimStarted = {}, .05 >= Math.abs(t.lastFlickSpeed.x) && .05 >= Math.abs(t.lastFlickSpeed.y)) return t.speedDecelerationRatioAbs.x = t.speedDecelerationRatioAbs.y = 0, t.calculateOverBoundsAnimOffset("x"), t.calculateOverBoundsAnimOffset("y"), !0;
                            ej("zoomPan"), t.lastNow = eA(), t.panAnimLoop()
                        },
                        tL = function e(t, i) {
                            if (eo || (tn = d), "swipe" === t) {
                                var n, s, o, c, h = eK.x - e9.x,
                                    u = i.lastFlickDist.x < 10;
                                h > 30 && (u || i.lastFlickOffset.x > 20) ? s = -1 : h < -30 && (u || i.lastFlickOffset.x < -20) && (s = 1)
                            }
                            s && ((d += s) < 0 ? (d = l.loop ? tq() - 1 : 0, o = !0) : d >= tq() && (d = l.loop ? 0 : tq() - 1, o = !0), (!o || l.loop) && (e8 += s, eg -= s, n = !0));
                            var p = eb.x * eg,
                                f = Math.abs(p - ta.x);
                            return c = n || p > ta.x == i.lastFlickSpeed.x > 0 ? Math.max(c = Math.min(c = Math.abs(i.lastFlickSpeed.x) > 0 ? f / Math.abs(i.lastFlickSpeed.x) : 333, 400), 250) : 333, tn === d && (n = !1), eo = !0, eL("mainScrollAnimStart"), eY("mainScroll", ta.x, p, c, a.easing.cubic.out, eM, function() {
                                eZ(), eo = !1, tn = -1, (n || tn !== d) && r.updateCurrItem(), eL("mainScrollAnimComplete")
                            }), n && r.updateCurrItem(!0), n
                        },
                        tA = function e(t) {
                            return 1 / ei * t * b
                        },
                        tP = function e() {
                            var t = y,
                                i = eN(),
                                n = eU();
                            y < i ? t = i : y > n && (t = n);
                            var s, o = ec;
                            return el && !W && !eh && y < i ? (r.close(), !0) : (el && (s = function e(t) {
                                eP((1 - o) * t + o)
                            }), r.zoomTo(t, 0, 200, a.easing.cubic.out, s), !0)
                        };
                    eS("Gestures", {
                        publicMethods: {
                            initGestures: function e() {
                                var t = function e(t, i, n, s, o) {
                                    _ = t + i, C = t + n, L = t + s, A = o ? t + o : ""
                                };
                                (I = H.pointerEvent) && H.touch && (H.touch = !1), I ? navigator.msPointerEnabled ? t("MSPointer", "Down", "Move", "Up", "Cancel") : t("pointer", "down", "move", "up", "cancel") : H.touch ? (t("touch", "start", "move", "end", "cancel"), z = !0) : t("mouse", "down", "move", "up"), m = C + " " + L + " " + A, v = _, I && !z && (z = navigator.maxTouchPoints > 1 || navigator.msMaxTouchPoints > 1), r.likelyTouchDevice = z, g[_] = tE, g[C] = tk, g[L] = tx, A && (g[A] = g[L]), H.touch && (v += " mousedown", m += " mousemove mouseup", g.mousedown = g[_], g.mousemove = g[C], g.mouseup = g[L]), z || (l.allowPanToNext = !1)
                            }
                        }
                    });
                    var tI, tz, tD, tT, tM, tq, tO = function e(t, n, s, o) {
                            tI && clearTimeout(tI), tT = !0, tD = !0, t.initialLayout ? (p = t.initialLayout, t.initialLayout = null) : p = l.getThumbBoundsFn && l.getThumbBoundsFn(d);
                            var c, h, p, f = s ? l.hideAnimationDuration : l.showAnimationDuration,
                                m = function e() {
                                    e7("initialZoom"), s ? (r.template.removeAttribute("style"), r.bg.removeAttribute("style")) : (eP(1), n && (n.style.display = "block"), a.addClass(i, "pswp--animated-in"), eL("initialZoom" + (s ? "OutEnd" : "InEnd"))), o && o(), tT = !1
                                };
                            if (!f || !p || void 0 === p.x) {
                                eL("initialZoom" + (s ? "Out" : "In")), y = t.initialZoomLevel, eO(em, t.initialPosition), ez(), i.style.opacity = s ? 0 : 1, eP(1), f ? setTimeout(function() {
                                    m()
                                }, f) : m();
                                return
                            }
                            c = u, h = !r.currItem.src || r.currItem.loadError || l.showHideOpacity, t.miniImg && (t.miniImg.style.webkitBackfaceVisibility = "hidden"), s || (y = p.w / t.w, em.x = p.x, em.y = p.y - q, r[h ? "template" : "bg"].style.opacity = .001, ez()), ej("initialZoom"), s && !c && a.removeClass(i, "pswp--animated-in"), h && (s ? a[(c ? "remove" : "add") + "Class"](i, "pswp--animate_opacity") : setTimeout(function() {
                                a.addClass(i, "pswp--animate_opacity")
                            }, 30)), tI = setTimeout(function() {
                                if (eL("initialZoom" + (s ? "Out" : "In")), s) {
                                    var e = p.w / t.w,
                                        n = {
                                            x: em.x,
                                            y: em.y
                                        },
                                        o = y,
                                        r = ec,
                                        l = function t(s) {
                                            1 === s ? (y = e, em.x = p.x, em.y = p.y - B) : (y = (e - o) * s + o, em.x = (p.x - n.x) * s + n.x, em.y = (p.y - B - n.y) * s + n.y), ez(), h ? i.style.opacity = 1 - s : eP(r - s * r)
                                        };
                                    c ? eY("initialZoom", 0, 1, f, a.easing.cubic.out, l, m) : (l(1), tI = setTimeout(m, f + 20))
                                } else y = t.initialZoomLevel, eO(em, t.initialPosition), ez(), eP(1), h ? i.style.opacity = 1 : eP(1), tI = setTimeout(m, f + 20)
                            }, s ? 25 : 90)
                        },
                        tB = {},
                        tH = [],
                        tR = {
                            index: 0,
                            errorMsg: '<div class="pswp__error-msg"><a href="%url%" target="_blank">The image</a> could not be loaded.</div>',
                            forceProgressiveLoading: !1,
                            preload: [1, 1],
                            getNumItemsFn: function e() {
                                return tz.length
                            }
                        },
                        t0 = function e() {
                            return {
                                center: {
                                    x: 0,
                                    y: 0
                                },
                                max: {
                                    x: 0,
                                    y: 0
                                },
                                min: {
                                    x: 0,
                                    y: 0
                                }
                            }
                        },
                        tF = function e(t, i, n) {
                            var s = t.bounds;
                            s.center.x = Math.round((tB.x - i) / 2), s.center.y = Math.round((tB.y - n) / 2) + t.vGap.top, s.max.x = i > tB.x ? Math.round(tB.x - i) : s.center.x, s.max.y = n > tB.y ? Math.round(tB.y - n) + t.vGap.top : s.center.y, s.min.x = i > tB.x ? 0 : s.center.x, s.min.y = n > tB.y ? t.vGap.top : s.center.y
                        },
                        t1 = function e(t, i, n) {
                            if (!t.src || t.loadError) return t.w = t.h = 0, t.initialZoomLevel = t.fitRatio = 1, t.bounds = t0(), t.initialPosition = t.bounds.center, t.bounds;
                            var s = !n;
                            if (s && (t.vGap || (t.vGap = {
                                    top: 0,
                                    bottom: 0
                                }), eL("parseVerticalMargin", t)), tB.x = i.x, tB.y = i.y - t.vGap.top - t.vGap.bottom, s) {
                                var o = tB.x / t.w,
                                    a = tB.y / t.h;
                                t.fitRatio = o < a ? o : a;
                                var r = l.scaleMode;
                                "orig" === r ? n = 1 : "fit" === r && (n = t.fitRatio), n > 1 && (n = 1), t.initialZoomLevel = n, t.bounds || (t.bounds = t0())
                            }
                            if (n) return tF(t, t.w * n, t.h * n), s && n === t.initialZoomLevel && (t.initialPosition = t.bounds.center), t.bounds
                        },
                        tN = function e(t, i, n, s, o, a) {
                            !i.loadError && s && (i.imageAppended = !0, t4(i, s, i === r.currItem && ek), n.appendChild(s), a && setTimeout(function() {
                                i && i.loaded && i.placeholder && (i.placeholder.style.display = "none", i.placeholder = null)
                            }, 500))
                        },
                        tU = function e(t) {
                            t.loading = !0, t.loaded = !1;
                            var i = t.img = a.createEl("pswp__img", "img"),
                                n = function e() {
                                    t.loading = !1, t.loaded = !0, t.loadComplete ? t.loadComplete(t) : t.img = null, i.onload = i.onerror = null, i = null
                                };
                            return i.onload = n, i.onerror = function() {
                                t.loadError = !0, n()
                            }, i.src = t.src, i
                        },
                        tW = function e(t, i) {
                            if (t.src && t.loadError && t.container) return i && (t.container.innerHTML = ""), t.container.innerHTML = l.errorMsg.replace("%url%", t.src), !0
                        },
                        t4 = function e(t, i, n) {
                            if (t.src) {
                                i || (i = t.container.lastChild);
                                var s = n ? t.w : Math.round(t.w * t.fitRatio),
                                    o = n ? t.h : Math.round(t.h * t.fitRatio);
                                t.placeholder && !t.loaded && (t.placeholder.style.width = s + "px", t.placeholder.style.height = o + "px"), i.style.width = s + "px", i.style.height = o + "px"
                            }
                        },
                        tV = function e() {
                            if (tH.length) {
                                for (var t, i = 0; i < tH.length; i++)(t = tH[i]).holder.index === t.index && tN(t.index, t.item, t.baseDiv, t.img, !1, t.clearPlaceholder);
                                tH = []
                            }
                        };
                    eS("Controller", {
                        publicMethods: {
                            lazyLoadItem: function e(t) {
                                t = ex(t);
                                var i = tM(t);
                                if (i && (!i.loaded && !i.loading || k)) eL("gettingData", t, i), i.src && tU(i)
                            },
                            initController: function e() {
                                a.extend(l, tR, !0), r.items = tz = s, tM = r.getItemAt, 3 > (tq = l.getNumItemsFn)() && (l.loop = !1), eC("beforeChange", function(e) {
                                    var t, i = l.preload,
                                        n = null === e || e >= 0,
                                        s = Math.min(i[0], tq()),
                                        o = Math.min(i[1], tq());
                                    for (t = 1; t <= (n ? o : s); t++) r.lazyLoadItem(d + t);
                                    for (t = 1; t <= (n ? s : o); t++) r.lazyLoadItem(d - t)
                                }), eC("initialLayout", function() {
                                    r.currItem.initialLayout = l.getThumbBoundsFn && l.getThumbBoundsFn(d)
                                }), eC("mainScrollAnimComplete", tV), eC("initialZoomInEnd", tV), eC("destroy", function() {
                                    for (var e, t = 0; t < tz.length; t++)(e = tz[t]).container && (e.container = null), e.placeholder && (e.placeholder = null), e.img && (e.img = null), e.preloader && (e.preloader = null), e.loadError && (e.loaded = e.loadError = !1);
                                    tH = null
                                })
                            },
                            getItemAt: function e(t) {
                                return t >= 0 && void 0 !== tz[t] && tz[t]
                            },
                            allowProgressiveImg: function e() {
                                return l.forceProgressiveLoading || !z || l.mouseUsed || screen.width > 1200
                            },
                            setContent: function e(t, i) {
                                l.loop && (i = ex(i));
                                var n = r.getItemAt(t.index);
                                n && (n.container = null);
                                var s, o = r.getItemAt(i);
                                if (!o) {
                                    t.el.innerHTML = "";
                                    return
                                }
                                eL("gettingData", i, o), t.index = i, t.item = o;
                                var h = o.container = a.createEl("pswp__zoom-wrap");
                                if (!o.src && o.html && (o.html.tagName ? h.appendChild(o.html) : h.innerHTML = o.html), tW(o), t1(o, ev), !o.src || o.loadError || o.loaded) o.src && !o.loadError && ((s = a.createEl("pswp__img", "img")).style.opacity = 1, s.src = o.src, t4(o, s), tN(i, o, h, s));
                                else {
                                    if (o.loadComplete = function(e) {
                                            if (c) {
                                                if (t && t.index === i) {
                                                    if (tW(e, !0)) {
                                                        e.loadComplete = e.img = null, t1(e, ev), eD(e), t.index === d && r.updateCurrZoomItem();
                                                        return
                                                    }
                                                    e.imageAppended ? !tT && e.placeholder && (e.placeholder.style.display = "none", e.placeholder = null) : H.transform && (eo || tT) ? tH.push({
                                                        item: e,
                                                        baseDiv: h,
                                                        img: e.img,
                                                        index: i,
                                                        holder: t,
                                                        clearPlaceholder: !0
                                                    }) : tN(i, e, h, e.img, eo || tT, !0)
                                                }
                                                e.loadComplete = null, e.img = null, eL("imageLoadComplete", i, e)
                                            }
                                        }, a.features.transform) {
                                        var u = "pswp__img pswp__img--placeholder";
                                        u += o.msrc ? "" : " pswp__img--placeholder--blank";
                                        var p = a.createEl(u, o.msrc ? "img" : "");
                                        o.msrc && (p.src = o.msrc), t4(o, p), h.appendChild(p), o.placeholder = p
                                    }
                                    o.loading || tU(o), r.allowProgressiveImg() && (!tD && H.transform ? tH.push({
                                        item: o,
                                        baseDiv: h,
                                        img: o.img,
                                        index: i,
                                        holder: t
                                    }) : tN(i, o, h, o.img, !0, !0))
                                }
                                tD || i !== d ? eD(o) : (es = h.style, tO(o, s || o.img)), t.el.innerHTML = "", t.el.appendChild(h)
                            },
                            cleanSlide: function e(t) {
                                t.img && (t.img.onload = t.img.onerror = null), t.loaded = t.loading = t.img = t.imageAppended = !1
                            }
                        }
                    });
                    var t3, t6 = {},
                        t2 = function e(t, i, n) {
                            var s = document.createEvent("CustomEvent"),
                                o = {
                                    origEvent: t,
                                    target: t.target,
                                    releasePoint: i,
                                    pointerType: n || "touch"
                                };
                            s.initCustomEvent("pswpTap", !0, !0, o), t.target.dispatchEvent(s)
                        };
                    eS("Tap", {
                        publicMethods: {
                            initTap: function e() {
                                eC("firstTouchStart", r.onTapStart), eC("touchRelease", r.onTapRelease), eC("destroy", function() {
                                    t6 = {}, t3 = null
                                })
                            },
                            onTapStart: function e(t) {
                                t.length > 1 && (clearTimeout(t3), t3 = null)
                            },
                            onTapRelease: function e(t, i) {
                                if (i && !G && !Z && !eX) {
                                    var n, s, o = i;
                                    if (t3 && (clearTimeout(t3), t3 = null, n = o, s = t6, 25 > Math.abs(n.x - s.x) && 25 > Math.abs(n.y - s.y))) {
                                        eL("doubleTap", o);
                                        return
                                    }
                                    if ("mouse" === i.type) {
                                        t2(t, i, "mouse");
                                        return
                                    }
                                    if ("BUTTON" === t.target.tagName.toUpperCase() || a.hasClass(t.target, "pswp__single-tap")) {
                                        t2(t, i);
                                        return
                                    }
                                    eO(t6, o), t3 = setTimeout(function() {
                                        t2(t, i), t3 = null
                                    }, 300)
                                }
                            }
                        }
                    }), eS("DesktopZoom", {
                        publicMethods: {
                            initDesktopZoom: function e() {
                                !O && (z ? eC("mouseUsed", function() {
                                    r.setupDesktopZoom()
                                }) : r.setupDesktopZoom(!0))
                            },
                            setupDesktopZoom: function e(t) {
                                tX = {};
                                var n = "wheel mousewheel DOMMouseScroll";
                                eC("bindEvents", function() {
                                    a.bind(i, n, r.handleMouseWheel)
                                }), eC("unbindEvents", function() {
                                    tX && a.unbind(i, n, r.handleMouseWheel)
                                }), r.mouseZoomedIn = !1;
                                var s, o = function e() {
                                        r.mouseZoomedIn && (a.removeClass(i, "pswp--zoomed-in"), r.mouseZoomedIn = !1), y < 1 ? a.addClass(i, "pswp--zoom-allowed") : a.removeClass(i, "pswp--zoom-allowed"), l()
                                    },
                                    l = function e() {
                                        s && (a.removeClass(i, "pswp--dragging"), s = !1)
                                    };
                                eC("resize", o), eC("afterChange", o), eC("pointerDown", function() {
                                    r.mouseZoomedIn && (s = !0, a.addClass(i, "pswp--dragging"))
                                }), eC("pointerUp", l), t || o()
                            },
                            handleMouseWheel: function e(t) {
                                if (y <= r.currItem.fitRatio) return l.modal && (!l.closeOnScroll || eX || j ? t.preventDefault() : P && Math.abs(t.deltaY) > 2 && (u = !0, r.close())), !0;
                                if (t.stopPropagation(), tX.x = 0, "deltaX" in t) 1 === t.deltaMode ? (tX.x = 18 * t.deltaX, tX.y = 18 * t.deltaY) : (tX.x = t.deltaX, tX.y = t.deltaY);
                                else if ("wheelDelta" in t) t.wheelDeltaX && (tX.x = -.16 * t.wheelDeltaX), t.wheelDeltaY ? tX.y = -.16 * t.wheelDeltaY : tX.y = -.16 * t.wheelDelta;
                                else {
                                    if (!("detail" in t)) return;
                                    tX.y = t.detail
                                }
                                e1(y, !0);
                                var i = em.x - tX.x,
                                    n = em.y - tX.y;
                                (l.modal || i <= en.min.x && i >= en.max.x && n <= en.min.y && n >= en.max.y) && t.preventDefault(), r.panTo(i, n)
                            },
                            toggleDesktopZoom: function e(t) {
                                t = t || {
                                    x: ev.x / 2 + ey.x,
                                    y: ev.y / 2 + ey.y
                                };
                                var n = l.getDoubleTapZoom(!0, r.currItem),
                                    s = y === n;
                                r.mouseZoomedIn = !s, r.zoomTo(s ? r.currItem.initialZoomLevel : n, t, 333), a[(s ? "remove" : "add") + "Class"](i, "pswp--zoomed-in")
                            }
                        }
                    });
                    var tX, t7, tj, tZ, tY, t5, tG, tQ, tK, t9, tJ, ie, it, ii = {
                            history: !0,
                            galleryUID: 1
                        },
                        is = function e() {
                            return ie.hash.substring(1)
                        },
                        io = function e() {
                            t7 && clearTimeout(t7), tZ && clearTimeout(tZ)
                        },
                        ia = function e() {
                            var t = is(),
                                i = {};
                            if (t.length < 5) return i;
                            var n, s = t.split("&");
                            for (n = 0; n < s.length; n++) {
                                if (s[n]) {
                                    var o = s[n].split("=");
                                    !(o.length < 2) && (i[o[0]] = o[1])
                                }
                            }
                            if (l.galleryPIDs) {
                                var a = i.pid;
                                for (n = 0, i.pid = 0; n < tz.length; n++)
                                    if (tz[n].pid === a) {
                                        i.pid = n;
                                        break
                                    }
                            } else i.pid = parseInt(i.pid, 10) - 1;
                            return i.pid < 0 && (i.pid = 0), i
                        },
                        ir = function e() {
                            if (tZ && clearTimeout(tZ), eX || j) {
                                tZ = setTimeout(e, 500);
                                return
                            }
                            tY ? clearTimeout(tj) : tY = !0;
                            var t = d + 1,
                                i = tM(d);
                            i.hasOwnProperty("pid") && (t = i.pid);
                            var n = tQ + "&gid=" + l.galleryUID + "&pid=" + t;
                            tK || -1 !== ie.hash.indexOf(n) || (tJ = !0);
                            var s = ie.href.split("#")[0] + "#" + n;
                            it ? "#" + n !== window.location.hash && history[tK ? "replaceState" : "pushState"]("", document.title, s) : tK ? ie.replace(s) : ie.hash = n, tK = !0, tj = setTimeout(function() {
                                tY = !1
                            }, 60)
                        };
                    eS("History", {
                        publicMethods: {
                            initHistory: function e() {
                                if (a.extend(l, ii, !0), l.history) {
                                    ie = window.location, tJ = !1, t9 = !1, tK = !1, tQ = is(), it = "pushState" in history, tQ.indexOf("gid=") > -1 && (tQ = (tQ = tQ.split("&gid=")[0]).split("?gid=")[0]), eC("afterChange", r.updateURL), eC("unbindEvents", function() {
                                        a.unbind(window, "hashchange", r.onHashChange)
                                    });
                                    var t = function e() {
                                        tG = !0, t9 || (tJ ? history.back() : tQ ? ie.hash = tQ : it ? history.pushState("", document.title, ie.pathname + ie.search) : ie.hash = ""), io()
                                    };
                                    eC("unbindEvents", function() {
                                        u && t()
                                    }), eC("destroy", function() {
                                        tG || t()
                                    }), eC("firstUpdate", function() {
                                        d = ia().pid
                                    });
                                    var i = tQ.indexOf("pid=");
                                    i > -1 && "&" === (tQ = tQ.substring(0, i)).slice(-1) && (tQ = tQ.slice(0, -1)), setTimeout(function() {
                                        c && a.bind(window, "hashchange", r.onHashChange)
                                    }, 40)
                                }
                            },
                            onHashChange: function e() {
                                if (is() === tQ) {
                                    t9 = !0, r.close();
                                    return
                                }
                                tY || (t5 = !0, r.goTo(ia().pid), t5 = !1)
                            },
                            updateURL: function e() {
                                io(), !t5 && (tK ? t7 = setTimeout(ir, 800) : ir())
                            }
                        }
                    }), a.extend(r, {
                        shout: eL,
                        listen: eC,
                        viewportSize: ev,
                        options: l,
                        isMainScrollAnimating: function e() {
                            return eo
                        },
                        getZoomLevel: function e() {
                            return y
                        },
                        getCurrentIndex: function e() {
                            return d
                        },
                        isDragging: function e() {
                            return j
                        },
                        isZooming: function e() {
                            return ee
                        },
                        setScrollOffset: function e(t, i) {
                            ey.x = t, B = ey.y = i, eL("updateScrollOffset", ey)
                        },
                        applyZoomPan: function e(t, i, n, s) {
                            em.x = i, em.y = n, y = t, ez(s)
                        },
                        init: function e() {
                            if (!c && !h) {
                                r.framework = a, r.template = i, r.bg = a.getChildByClass(i, "pswp__bg"), M = i.className, c = !0, D = (H = a.detectFeatures()).raf, T = H.caf, P = H.transform, O = H.oldIE, r.scrollWrap = a.getChildByClass(i, "pswp__scroll-wrap"), r.container = a.getChildByClass(r.scrollWrap, "pswp__container"), p = r.container.style, r.itemHolders = S = [{
                                    el: r.container.children[0],
                                    wrap: 0,
                                    index: -1
                                }, {
                                    el: r.container.children[1],
                                    wrap: 0,
                                    index: -1
                                }, {
                                    el: r.container.children[2],
                                    wrap: 0,
                                    index: -1
                                }, ], S[0].el.style.display = S[2].el.style.display = "none", e4(), g = {
                                    resize: r.updateSize,
                                    orientationchange: function e() {
                                        clearTimeout(R), R = setTimeout(function() {
                                            ev.x !== r.scrollWrap.clientWidth && r.updateSize()
                                        }, 500)
                                    },
                                    scroll: e6,
                                    keydown: eV,
                                    click: e3
                                };
                                var t, s = H.isOldIOSPhone || H.isOldAndroid || H.isMobileOpera;
                                for (H.animationName && H.transform && !s || (l.showAnimationDuration = l.hideAnimationDuration = 0), t = 0; t < ew.length; t++) r["init" + ew[t]]();
                                n && (r.ui = new n(r, a)).init(), eL("firstUpdate"), d = d || l.index || 0, (isNaN(d) || d < 0 || d >= tq()) && (d = 0), r.currItem = tM(d), (H.isOldIOSPhone || H.isOldAndroid) && (e$ = !1), i.setAttribute("aria-hidden", "false"), l.modal && (e$ ? i.style.position = "fixed" : (i.style.position = "absolute", i.style.top = a.getScrollY() + "px")), void 0 === B && (eL("initialLayout"), B = q = a.getScrollY());
                                var o = "pswp--open ";
                                for (l.mainClass && (o += l.mainClass + " "), l.showHideOpacity && (o += "pswp--animate_opacity "), o += z ? "pswp--touch" : "pswp--notouch", o += H.animationName ? " pswp--css_animation" : "", o += H.svg ? " pswp--svg" : "", a.addClass(i, o), r.updateSize(), f = -1, e8 = null, t = 0; t < 3; t++) eT((t + f) * eb.x, S[t].el.style);
                                O || a.bind(r.scrollWrap, v, r), eC("initialZoomInEnd", function() {
                                    r.setContent(S[0], d - 1), r.setContent(S[2], d + 1), S[0].el.style.display = S[2].el.style.display = "block", l.focus && i.focus(), e0()
                                }), r.setContent(S[1], d), r.updateCurrItem(), eL("afterInit"), e$ || (E = setInterval(function() {
                                    eX || j || ee || y !== r.currItem.initialZoomLevel || r.updateSize()
                                }, 1e3)), a.addClass(i, "pswp--visible")
                            }
                        },
                        close: function e() {
                            c && (c = !1, h = !0, eL("close"), eF(), tO(r.currItem, null, !0, r.destroy))
                        },
                        destroy: function e() {
                            eL("destroy"), tI && clearTimeout(tI), i.setAttribute("aria-hidden", "true"), i.className = M, E && clearInterval(E), a.unbind(r.scrollWrap, v, r), a.unbind(window, "scroll", r), th(), eZ(), e_ = null
                        },
                        panTo: function e(t, i, n) {
                            !n && (t > en.min.x ? t = en.min.x : t < en.max.x && (t = en.max.x), i > en.min.y ? i = en.min.y : i < en.max.y && (i = en.max.y)), em.x = t, em.y = i, ez()
                        },
                        handleEvent: function e(t) {
                            g[(t = t || window.event).type] && g[t.type](t)
                        },
                        goTo: function e(t) {
                            var i = (t = ex(t)) - d;
                            e8 = i, d = t, r.currItem = tM(d), eg -= i, eM(eb.x * eg), eZ(), eo = !1, r.updateCurrItem()
                        },
                        next: function e() {
                            r.goTo(d + 1)
                        },
                        prev: function e() {
                            r.goTo(d - 1)
                        },
                        updateCurrZoomItem: function e(t) {
                            if (t && eL("beforeChange", 0), S[1].el.children.length) {
                                var i = S[1].el.children[0];
                                es = a.hasClass(i, "pswp__zoom-wrap") ? i.style : null
                            } else es = null;
                            en = r.currItem.bounds, b = y = r.currItem.initialZoomLevel, em.x = en.center.x, em.y = en.center.y, t && eL("afterChange")
                        },
                        invalidateCurrItems: function e() {
                            k = !0;
                            for (var t = 0; t < 3; t++) S[t].item && (S[t].item.needsUpdate = !0)
                        },
                        updateCurrItem: function e(t) {
                            if (0 !== e8) {
                                var i, n = Math.abs(e8);
                                if (!t || !(n < 2)) {
                                    r.currItem = tM(d), ek = !1, eL("beforeChange", e8), n >= 3 && (f += e8 + (e8 > 0 ? -3 : 3), n = 3);
                                    for (var s = 0; s < n; s++) e8 > 0 ? (i = S.shift(), S[2] = i, eT((++f + 2) * eb.x, i.el.style), r.setContent(i, d - n + s + 1 + 1)) : (i = S.pop(), S.unshift(i), eT(--f * eb.x, i.el.style), r.setContent(i, d + n - s - 1 - 1));
                                    if (es && 1 === Math.abs(e8)) {
                                        var o = tM(x);
                                        o.initialZoomLevel !== y && (t1(o, ev), t4(o), eD(o))
                                    }
                                    e8 = 0, r.updateCurrZoomItem(), x = d, eL("afterChange")
                                }
                            }
                        },
                        updateSize: function e(t) {
                            if (!e$ && l.modal) {
                                var n, s, o, c = a.getScrollY();
                                if (B !== c && (i.style.top = c + "px", B = c), !t && eE.x === window.innerWidth && eE.y === window.innerHeight) return;
                                eE.x = window.innerWidth, eE.y = window.innerHeight, i.style.height = eE.y + "px"
                            }
                            if (ev.x = r.scrollWrap.clientWidth, ev.y = r.scrollWrap.clientHeight, e6(), eb.x = ev.x + Math.round(ev.x * l.spacing), eb.y = ev.y, eM(eb.x * eg), eL("beforeResize"), void 0 !== f) {
                                for (var h = 0; h < 3; h++) n = S[h], eT((h + f) * eb.x, n.el.style), o = d + h - 1, l.loop && tq() > 2 && (o = ex(o)), (s = tM(o)) && (k || s.needsUpdate || !s.bounds) ? (r.cleanSlide(s), r.setContent(n, o), 1 === h && (r.currItem = s, r.updateCurrZoomItem(!0)), s.needsUpdate = !1) : -1 === n.index && o >= 0 && r.setContent(n, o), s && s.container && (t1(s, ev), t4(s), eD(s));
                                k = !1
                            }
                            b = y = r.currItem.initialZoomLevel, (en = r.currItem.bounds) && (em.x = en.center.x, em.y = en.center.y, ez(!0)), eL("resize")
                        },
                        zoomTo: function e(t, i, n, s, o) {
                            i && (b = y, tr.x = Math.abs(i.x) - em.x, tr.y = Math.abs(i.y) - em.y, eO(ef, em));
                            var r = e1(t, !1),
                                l = {};
                            eW("x", r, l, t), eW("y", r, l, t);
                            var c = y,
                                h = {
                                    x: em.x,
                                    y: em.y
                                };
                            eB(l);
                            var u = function e(i) {
                                1 === i ? (y = t, em.x = l.x, em.y = l.y) : (y = (t - c) * i + c, em.x = (l.x - h.x) * i + h.x, em.y = (l.y - h.y) * i + h.y), o && o(i), ez(1 === i)
                            };
                            n ? eY("customZoomTo", 0, 1, n, s || a.easing.sine.inOut, u) : u(1)
                        }
                    })
                }
            }, t.exports = s()
        });

    function es(t) {
        return (es = "function" == typeof Symbol && "symbol" === e(Symbol.iterator) ? function t(i) {
            return e(i)
        } : function t(i) {
            return i && "function" == typeof Symbol && i.constructor === Symbol && i !== Symbol.prototype ? "symbol" : e(i)
        })(t)
    }
    var eo = ("undefined" == typeof HTMLElement ? "undefined" : es(HTMLElement)) === "object";

    function ea(e) {
        return eo ? e instanceof HTMLElement : e && "object" === es(e) && null !== e && 1 === e.nodeType && "string" == typeof e.nodeName
    }

    function er(e, t) {
        t.forEach(function(t) {
            e.classList.add(t)
        })
    }

    function el(e, t) {
        t.forEach(function(t) {
            e.classList.remove(t)
        })
    }

    function ec() {
        throw Error("Missing parameter")
    }

    function eh(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
        }
    }
    var eu = function() {
        var e, t, i;

        function n(e) {
            ! function e(t, i) {
                if (!(t instanceof i)) throw TypeError("Cannot call a class as a function")
            }(this, n), this.isShowing = !1;
            var t = e.namespace,
                i = e.zoomFactor,
                s = void 0 === i ? ec() : i,
                o = e.containerEl,
                a = void 0 === o ? ec() : o;
            this.settings = {
                namespace: void 0 === t ? null : t,
                zoomFactor: s,
                containerEl: a
            }, this.openClasses = this._buildClasses("open"), this._buildElement()
        }
        return e = n, t = [{
            key: "_buildClasses",
            value: function e(t) {
                var i = ["drift-".concat(t)],
                    n = this.settings.namespace;
                return n && i.push("".concat(n, "-").concat(t)), i
            }
        }, {
            key: "_buildElement",
            value: function e() {
                this.el = document.createElement("div"), er(this.el, this._buildClasses("bounding-box"))
            }
        }, {
            key: "show",
            value: function e(t, i) {
                this.isShowing = !0, this.settings.containerEl.appendChild(this.el);
                var n = this.el.style;
                n.width = "".concat(Math.round(t / this.settings.zoomFactor), "px"), n.height = "".concat(Math.round(i / this.settings.zoomFactor), "px"), er(this.el, this.openClasses)
            }
        }, {
            key: "hide",
            value: function e() {
                this.isShowing && this.settings.containerEl.removeChild(this.el), this.isShowing = !1, el(this.el, this.openClasses)
            }
        }, {
            key: "setPosition",
            value: function e(t, i, n) {
                var s = window.pageXOffset,
                    o = window.pageYOffset,
                    a = n.left + t * n.width - this.el.clientWidth / 2 + s,
                    r = n.top + i * n.height - this.el.clientHeight / 2 + o;
                a < n.left + s ? a = n.left + s : a + this.el.clientWidth > n.left + n.width + s && (a = n.left + n.width - this.el.clientWidth + s), r < n.top + o ? r = n.top + o : r + this.el.clientHeight > n.top + n.height + o && (r = n.top + n.height - this.el.clientHeight + o), this.el.style.left = "".concat(a, "px"), this.el.style.top = "".concat(r, "px")
            }
        }, ], eh(e.prototype, t), i && eh(e, i), n
    }();

    function ed(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
        }
    }
    var ep = function() {
        var e, t, i;

        function n() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            ! function e(t, i) {
                if (!(t instanceof i)) throw TypeError("Cannot call a class as a function")
            }(this, n), this._show = this._show.bind(this), this._hide = this._hide.bind(this), this._handleEntry = this._handleEntry.bind(this), this._handleMovement = this._handleMovement.bind(this);
            var t = e.el,
                i = void 0 === t ? ec() : t,
                s = e.zoomPane,
                o = void 0 === s ? ec() : s,
                a = e.sourceAttribute,
                r = void 0 === a ? ec() : a,
                l = e.handleTouch,
                c = void 0 === l ? ec() : l,
                h = e.onShow,
                u = e.onHide,
                d = e.hoverDelay,
                p = e.touchDelay,
                f = e.hoverBoundingBox,
                m = void 0 === f ? ec() : f,
                v = e.touchBoundingBox,
                g = void 0 === v ? ec() : v,
                y = e.namespace,
                b = e.zoomFactor,
                $ = void 0 === b ? ec() : b,
                w = e.boundingBoxContainer,
                E = void 0 === w ? ec() : w;
            this.settings = {
                el: i,
                zoomPane: o,
                sourceAttribute: r,
                handleTouch: c,
                onShow: void 0 === h ? null : h,
                onHide: void 0 === u ? null : u,
                hoverDelay: void 0 === d ? 0 : d,
                touchDelay: void 0 === p ? 0 : p,
                hoverBoundingBox: m,
                touchBoundingBox: g,
                namespace: void 0 === y ? null : y,
                zoomFactor: $,
                boundingBoxContainer: E
            }, (this.settings.hoverBoundingBox || this.settings.touchBoundingBox) && (this.boundingBox = new eu({
                namespace: this.settings.namespace,
                zoomFactor: this.settings.zoomFactor,
                containerEl: this.settings.boundingBoxContainer
            })), this.enabled = !0, this._bindEvents()
        }
        return e = n, t = [{
            key: "_preventDefault",
            value: function e(t) {
                t.preventDefault()
            }
        }, {
            key: "_preventDefaultAllowTouchScroll",
            value: function e(t) {
                this.settings.touchDelay && this._isTouchEvent(t) && !this.isShowing || t.preventDefault()
            }
        }, {
            key: "_isTouchEvent",
            value: function e(t) {
                return !!t.touches
            }
        }, {
            key: "_bindEvents",
            value: function e() {
                this.settings.el.addEventListener("mouseenter", this._handleEntry, !1), this.settings.el.addEventListener("mouseleave", this._hide, !1), this.settings.el.addEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.addEventListener("touchstart", this._handleEntry, !1), this.settings.el.addEventListener("touchend", this._hide, !1), this.settings.el.addEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.addEventListener("touchstart", this._preventDefault, !1), this.settings.el.addEventListener("touchend", this._preventDefault, !1), this.settings.el.addEventListener("touchmove", this._preventDefault, !1))
            }
        }, {
            key: "_unbindEvents",
            value: function e() {
                this.settings.el.removeEventListener("mouseenter", this._handleEntry, !1), this.settings.el.removeEventListener("mouseleave", this._hide, !1), this.settings.el.removeEventListener("mousemove", this._handleMovement, !1), this.settings.handleTouch ? (this.settings.el.removeEventListener("touchstart", this._handleEntry, !1), this.settings.el.removeEventListener("touchend", this._hide, !1), this.settings.el.removeEventListener("touchmove", this._handleMovement, !1)) : (this.settings.el.removeEventListener("touchstart", this._preventDefault, !1), this.settings.el.removeEventListener("touchend", this._preventDefault, !1), this.settings.el.removeEventListener("touchmove", this._preventDefault, !1))
            }
        }, {
            key: "_handleEntry",
            value: function e(t) {
                this._preventDefaultAllowTouchScroll(t), this._lastMovement = t, "mouseenter" == t.type && this.settings.hoverDelay ? this.entryTimeout = setTimeout(this._show, this.settings.hoverDelay) : this.settings.touchDelay ? this.entryTimeout = setTimeout(this._show, this.settings.touchDelay) : this._show()
            }
        }, {
            key: "_show",
            value: function e() {
                if (this.enabled) {
                    var t = this.settings.onShow;
                    if (t && "function" == typeof t && t(), this.settings.zoomPane.show(this.settings.el.getAttribute(this.settings.sourceAttribute), this.settings.el.clientWidth, this.settings.el.clientHeight), this._lastMovement) {
                        var i = this._lastMovement.touches;
                        (i && this.settings.touchBoundingBox || !i && this.settings.hoverBoundingBox) && this.boundingBox.show(this.settings.zoomPane.el.clientWidth, this.settings.zoomPane.el.clientHeight)
                    }
                    this._handleMovement()
                }
            }
        }, {
            key: "_hide",
            value: function e(t) {
                t && this._preventDefaultAllowTouchScroll(t), this._lastMovement = null, this.entryTimeout && clearTimeout(this.entryTimeout), this.boundingBox && this.boundingBox.hide();
                var i = this.settings.onHide;
                i && "function" == typeof i && i(), this.settings.zoomPane.hide()
            }
        }, {
            key: "_handleMovement",
            value: function e(t) {
                if (t) this._preventDefaultAllowTouchScroll(t), this._lastMovement = t;
                else {
                    if (!this._lastMovement) return;
                    t = this._lastMovement
                }
                if (t.touches) {
                    var i, n, s = t.touches[0];
                    i = s.clientX, n = s.clientY
                } else i = t.clientX, n = t.clientY;
                var o = this.settings.el.getBoundingClientRect(),
                    a = i - o.left,
                    r = n - o.top,
                    l = a / this.settings.el.clientWidth,
                    c = r / this.settings.el.clientHeight;
                this.boundingBox && this.boundingBox.setPosition(l, c, o), this.settings.zoomPane.setPosition(l, c, o)
            }
        }, {
            key: "isShowing",
            get: function e() {
                return this.settings.zoomPane.isShowing
            }
        }, ], ed(e.prototype, t), i && ed(e, i), n
    }();

    function ef(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
        }
    }
    var em = document.createElement("div").style,
        ev = "undefined" != typeof document && ("animation" in em || "webkitAnimation" in em),
        eg = function() {
            var e, t, i;

            function n() {
                var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                ! function e(t, i) {
                    if (!(t instanceof i)) throw TypeError("Cannot call a class as a function")
                }(this, n), this._completeShow = this._completeShow.bind(this), this._completeHide = this._completeHide.bind(this), this._handleLoad = this._handleLoad.bind(this), this.isShowing = !1;
                var t = e.container,
                    i = e.zoomFactor,
                    s = void 0 === i ? ec() : i,
                    o = e.inline,
                    a = void 0 === o ? ec() : o,
                    r = e.namespace,
                    l = e.showWhitespaceAtEdges,
                    c = void 0 === l ? ec() : l,
                    h = e.containInline,
                    u = void 0 === h ? ec() : h,
                    d = e.inlineOffsetX,
                    p = e.inlineOffsetY,
                    f = e.inlineContainer,
                    m = void 0 === f ? document.body : f;
                this.settings = {
                    container: void 0 === t ? null : t,
                    zoomFactor: s,
                    inline: a,
                    namespace: void 0 === r ? null : r,
                    showWhitespaceAtEdges: c,
                    containInline: u,
                    inlineOffsetX: void 0 === d ? 0 : d,
                    inlineOffsetY: void 0 === p ? 0 : p,
                    inlineContainer: m
                }, this.openClasses = this._buildClasses("open"), this.openingClasses = this._buildClasses("opening"), this.closingClasses = this._buildClasses("closing"), this.inlineClasses = this._buildClasses("inline"), this.loadingClasses = this._buildClasses("loading"), this._buildElement()
            }
            return e = n, t = [{
                key: "_buildClasses",
                value: function e(t) {
                    var i = ["drift-".concat(t)],
                        n = this.settings.namespace;
                    return n && i.push("".concat(n, "-").concat(t)), i
                }
            }, {
                key: "_buildElement",
                value: function e() {
                    this.el = document.createElement("div"), er(this.el, this._buildClasses("zoom-pane"));
                    var t = document.createElement("div");
                    er(t, this._buildClasses("zoom-pane-loader")), this.el.appendChild(t), this.imgEl = document.createElement("img"), this.el.appendChild(this.imgEl)
                }
            }, {
                key: "_setImageURL",
                value: function e(t) {
                    this.imgEl.setAttribute("src", t)
                }
            }, {
                key: "_setImageSize",
                value: function e(t, i) {
                    this.imgEl.style.width = "".concat(t * this.settings.zoomFactor, "px"), this.imgEl.style.height = "".concat(i * this.settings.zoomFactor, "px")
                }
            }, {
                key: "setPosition",
                value: function e(t, i, n) {
                    var s = this.imgEl.offsetWidth,
                        o = this.imgEl.offsetHeight,
                        a = this.el.offsetWidth,
                        r = this.el.offsetHeight,
                        l = a / 2 - s * t,
                        c = r / 2 - o * i,
                        h = a - s,
                        u = r - o,
                        d = h > 0,
                        p = u > 0,
                        f = d ? h / 2 : 0,
                        m = p ? u / 2 : 0,
                        v = d ? h / 2 : h,
                        g = p ? u / 2 : u;
                    if (this.el.parentElement === this.settings.inlineContainer) {
                        var y = window.pageXOffset,
                            b = window.pageYOffset,
                            $ = n.left + t * n.width - a / 2 + this.settings.inlineOffsetX + y,
                            w = n.top + i * n.height - r / 2 + this.settings.inlineOffsetY + b;
                        this.settings.containInline && ($ < n.left + y ? $ = n.left + y : $ + a > n.left + n.width + y && ($ = n.left + n.width - a + y), w < n.top + b ? w = n.top + b : w + r > n.top + n.height + b && (w = n.top + n.height - r + b)), this.el.style.left = "".concat($, "px"), this.el.style.top = "".concat(w, "px")
                    }!this.settings.showWhitespaceAtEdges && (l > f ? l = f : l < v && (l = v), c > m ? c = m : c < g && (c = g)), this.imgEl.style.transform = "translate(".concat(l, "px, ").concat(c, "px)"), this.imgEl.style.webkitTransform = "translate(".concat(l, "px, ").concat(c, "px)")
                }
            }, {
                key: "_removeListenersAndResetClasses",
                value: function e() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), el(this.el, this.openClasses), el(this.el, this.closingClasses)
                }
            }, {
                key: "show",
                value: function e(t, i, n) {
                    this._removeListenersAndResetClasses(), this.isShowing = !0, er(this.el, this.openClasses), this.imgEl.getAttribute("src") != t && (er(this.el, this.loadingClasses), this.imgEl.addEventListener("load", this._handleLoad, !1), this._setImageURL(t)), this._setImageSize(i, n), this._isInline ? this._showInline() : this._showInContainer(), ev && (this.el.addEventListener("animationend", this._completeShow, !1), this.el.addEventListener("webkitAnimationEnd", this._completeShow, !1), er(this.el, this.openingClasses))
                }
            }, {
                key: "_showInline",
                value: function e() {
                    this.settings.inlineContainer.appendChild(this.el), er(this.el, this.inlineClasses)
                }
            }, {
                key: "_showInContainer",
                value: function e() {
                    this.settings.container.appendChild(this.el)
                }
            }, {
                key: "hide",
                value: function e() {
                    this._removeListenersAndResetClasses(), this.isShowing = !1, ev ? (this.el.addEventListener("animationend", this._completeHide, !1), this.el.addEventListener("webkitAnimationEnd", this._completeHide, !1), er(this.el, this.closingClasses)) : (el(this.el, this.openClasses), el(this.el, this.inlineClasses))
                }
            }, {
                key: "_completeShow",
                value: function e() {
                    this.el.removeEventListener("animationend", this._completeShow, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeShow, !1), el(this.el, this.openingClasses)
                }
            }, {
                key: "_completeHide",
                value: function e() {
                    this.el.removeEventListener("animationend", this._completeHide, !1), this.el.removeEventListener("webkitAnimationEnd", this._completeHide, !1), el(this.el, this.openClasses), el(this.el, this.closingClasses), el(this.el, this.inlineClasses), this.el.setAttribute("style", ""), this.el.parentElement === this.settings.container ? this.settings.container.removeChild(this.el) : this.el.parentElement === this.settings.inlineContainer && this.settings.inlineContainer.removeChild(this.el)
                }
            }, {
                key: "_handleLoad",
                value: function e() {
                    this.imgEl.removeEventListener("load", this._handleLoad, !1), el(this.el, this.loadingClasses)
                }
            }, {
                key: "_isInline",
                get: function e() {
                    var t = this.settings.inline;
                    return !0 === t || "number" == typeof t && window.innerWidth <= t
                }
            }, ], ef(e.prototype, t), i && ef(e, i), n
        }();

    function ey(e, t) {
        for (var i = 0; i < t.length; i++) {
            var n = t[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n)
        }
    }
    var eb = function() {
        var e, t, i;

        function n(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (! function e(t, i) {
                    if (!(t instanceof i)) throw TypeError("Cannot call a class as a function")
                }(this, n), this.VERSION = "1.4.0", this.triggerEl = e, this.destroy = this.destroy.bind(this), !ea(this.triggerEl)) throw TypeError("`new Drift` requires a DOM element as its first argument.");
            var i = t.namespace || null,
                s = t.showWhitespaceAtEdges || !1,
                o = t.containInline || !1,
                a = t.inlineOffsetX || 0,
                r = t.inlineOffsetY || 0,
                l = t.inlineContainer || document.body,
                c = t.sourceAttribute || "data-zoom",
                h = t.zoomFactor || 3,
                u = void 0 === t.paneContainer ? document.body : t.paneContainer,
                d = t.inlinePane || 375,
                p = !("handleTouch" in t) || !!t.handleTouch,
                f = t.onShow || null,
                m = t.onHide || null,
                v = !("injectBaseStyles" in t) || !!t.injectBaseStyles,
                g = t.hoverDelay || 0,
                y = t.touchDelay || 0,
                b = t.hoverBoundingBox || !1,
                $ = t.touchBoundingBox || !1,
                w = t.boundingBoxContainer || document.body;
            if (!0 !== d && !ea(u)) throw TypeError("`paneContainer` must be a DOM element when `inlinePane !== true`");
            if (!ea(l)) throw TypeError("`inlineContainer` must be a DOM element");
            this.settings = {
                namespace: i,
                showWhitespaceAtEdges: s,
                containInline: o,
                inlineOffsetX: a,
                inlineOffsetY: r,
                inlineContainer: l,
                sourceAttribute: c,
                zoomFactor: h,
                paneContainer: u,
                inlinePane: d,
                handleTouch: p,
                onShow: f,
                onHide: m,
                injectBaseStyles: v,
                hoverDelay: g,
                touchDelay: y,
                hoverBoundingBox: b,
                touchBoundingBox: $,
                boundingBoxContainer: w
            }, this.settings.injectBaseStyles && function e() {
                if (!document.querySelector(".drift-base-styles")) {
                    var t = document.createElement("style");
                    t.type = "text/css", t.classList.add("drift-base-styles"), t.appendChild(document.createTextNode(".drift-bounding-box,.drift-zoom-pane{position:absolute;pointer-events:none}@keyframes noop{0%{zoom:1}}@-webkit-keyframes noop{0%{zoom:1}}.drift-zoom-pane.drift-open{display:block}.drift-zoom-pane.drift-closing,.drift-zoom-pane.drift-opening{animation:noop 1ms;-webkit-animation:noop 1ms}.drift-zoom-pane{overflow:hidden;width:100%;height:100%;top:0;left:0}.drift-zoom-pane-loader{display:none}.drift-zoom-pane img{position:absolute;display:block;max-width:none;max-height:none}"));
                    var i = document.head;
                    i.insertBefore(t, i.firstChild)
                }
            }(), this._buildZoomPane(), this._buildTrigger()
        }
        return e = n, t = [{
            key: "_buildZoomPane",
            value: function e() {
                this.zoomPane = new eg({
                    container: this.settings.paneContainer,
                    zoomFactor: this.settings.zoomFactor,
                    showWhitespaceAtEdges: this.settings.showWhitespaceAtEdges,
                    containInline: this.settings.containInline,
                    inline: this.settings.inlinePane,
                    namespace: this.settings.namespace,
                    inlineOffsetX: this.settings.inlineOffsetX,
                    inlineOffsetY: this.settings.inlineOffsetY,
                    inlineContainer: this.settings.inlineContainer
                })
            }
        }, {
            key: "_buildTrigger",
            value: function e() {
                this.trigger = new ep({
                    el: this.triggerEl,
                    zoomPane: this.zoomPane,
                    handleTouch: this.settings.handleTouch,
                    onShow: this.settings.onShow,
                    onHide: this.settings.onHide,
                    sourceAttribute: this.settings.sourceAttribute,
                    hoverDelay: this.settings.hoverDelay,
                    touchDelay: this.settings.touchDelay,
                    hoverBoundingBox: this.settings.hoverBoundingBox,
                    touchBoundingBox: this.settings.touchBoundingBox,
                    namespace: this.settings.namespace,
                    zoomFactor: this.settings.zoomFactor,
                    boundingBoxContainer: this.settings.boundingBoxContainer
                })
            }
        }, {
            key: "setZoomImageURL",
            value: function e(t) {
                this.zoomPane._setImageURL(t)
            }
        }, {
            key: "disable",
            value: function e() {
                this.trigger.enabled = !1
            }
        }, {
            key: "enable",
            value: function e() {
                this.trigger.enabled = !0
            }
        }, {
            key: "destroy",
            value: function e() {
                this.trigger._hide(), this.trigger._unbindEvents()
            }
        }, {
            key: "isShowing",
            get: function e() {
                return this.zoomPane.isShowing
            }
        }, {
            key: "zoomFactor",
            get: function e() {
                return this.settings.zoomFactor
            },
            set: function e(t) {
                this.settings.zoomFactor = t, this.zoomPane.settings.zoomFactor = t, this.trigger.settings.zoomFactor = t, this.boundingBox.settings.zoomFactor = t
            }
        }, ], ey(e.prototype, t), i && ey(e, i), n
    }();
    Object.defineProperty(eb.prototype, "isShowing", {
        get: function e() {
            return this.isShowing
        }
    }), Object.defineProperty(eb.prototype, "zoomFactor", {
        get: function e() {
            return this.zoomFactor
        },
        set: function e(t) {
            this.zoomFactor = t
        }
    }), eb.prototype.setZoomImageURL = eb.prototype.setZoomImageURL, eb.prototype.disable = eb.prototype.disable, eb.prototype.enable = eb.prototype.enable, eb.prototype.destroy = eb.prototype.destroy;
    var e8 = function() {
            function e(i, n) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.viewInSpaceElement = this.element.querySelector("[data-shopify-xr]"), this.options = n, this.media = {}, this.previouslySelectedMedia = null, this._createCarousel(), this._createZoom(), this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    for (var t in this.flickityInstance && this.flickityInstance.destroy(), this.media) this.media.hasOwnProperty(t) && this.media[t].destroy()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    var t = this;
                    this.delegateElement.on("model:played", this._disableDrag.bind(this)), this.delegateElement.on("video:played", this._disableDrag.bind(this)), this.delegateElement.on("model:paused", this._enableDrag.bind(this)), this.delegateElement.on("video:paused", this._enableDrag.bind(this)), this.options.enableImageZoom && (window.addEventListener("resize", this._handleZoomForMediaQuery.bind(this)), this.delegateElement.on("click", ".product-gallery__image", this._openMobileZoom.bind(this)), this.delegateElement.on("click", ".pswp__button", this._doPswpAction.bind(this)));
                    var i = window.innerWidth;
                    window.addEventListener("resize", function() {
                        window.innerWidth !== i && t.flickityInstance && (t.flickityInstance.resize(), i = window.innerWidth)
                    })
                }
            }, {
                key: "variantHasChanged",
                value: function e(t) {
                    var i = this,
                        n = !1;
                    A.mutate(function() {
                        i.productGalleryCellsElements.forEach(function(e, s) {
                            if (e.hasAttribute("data-group-name")) {
                                var o = e.getAttribute("data-group-name");
                                i.options.productOptions.forEach(function(n, a) {
                                    n.toLowerCase() === o && (t["option".concat(a + 1)].toLowerCase() === e.getAttribute("data-group-value") || t.featured_media && t.featured_media.id === parseInt(e.getAttribute("data-media-id")) ? (e.classList.remove("is-filtered"), i.productThumbnailsCellsElements[s].classList.remove("is-filtered")) : (e.classList.add("is-filtered"), i.productThumbnailsCellsElements[s].classList.add("is-filtered")))
                                }), n = !0
                            }
                        }), n && (i.flickityInstance.deactivate(), i.flickityInstance.activate()), b.matchesBreakpoint("lap-and-up") && i.element.querySelectorAll(".product-gallery__carousel-item").forEach(function(e) {
                            e.classList.remove("product-gallery__carousel-item--hidden")
                        }), i.flickityInstance && t && t.featured_media && i.flickityInstance.selectCell('[data-media-id="'.concat(t.featured_media.id, '"]'))
                    })
                }
            }, {
                key: "_createCarousel",
                value: function e() {
                    var t = this;
                    if (this.productGalleryElement = this.element.querySelector(".product-gallery__carousel"), this.productGalleryCellsElements = this.productGalleryElement ? this.productGalleryElement.querySelectorAll(".product-gallery__carousel-item") : [], this.productGalleryElement && (this.productGalleryCellsElements.forEach(function(e) {
                            switch (e.getAttribute("data-media-type")) {
                                case "external_video":
                                case "video":
                                    t.media[e.getAttribute("data-media-id")] = new B(e, t.options.enableVideoLooping);
                                    break;
                                case "model":
                                    t.media[e.getAttribute("data-media-id")] = new O(e)
                            }
                        }), parseInt(this.productGalleryElement.getAttribute("data-media-count")) > 1)) {
                        var i = [].slice.call(this.productGalleryCellsElements).filter(function(e) {
                                return !e.classList.contains("is-filtered")
                            }),
                            n = 0;
                        i.forEach(function(e, i) {
                            e.getAttribute("data-media-id") === t.productGalleryElement.getAttribute("data-initial-media-id") && (n = i)
                        });
                        var s = i[n];
                        s.classList.add("is-selected"), this.productGalleryElement.style.height = "".concat(s.clientHeight, "px"), this.flickityInstance = new ei(this.productGalleryElement, {
                            accessibility: !1,
                            prevNextButtons: !0,
                            pageDots: !1,
                            resize: !1,
                            adaptiveHeight: !0,
                            draggable: !b.matchesBreakpoint("supports-hover"),
                            fade: "fade" === this.options.galleryTransitionEffect,
                            cellSelector: ".product-gallery__carousel-item:not(.is-filtered)",
                            initialIndex: n,
                            on: {
                                ready: function e() {
                                    setTimeout(function() {
                                        t.productGalleryElement.style.height = null
                                    }, 1e3)
                                }
                            }
                        })
                    }
                    this.productThumbnailsListElement = this.element.querySelector(".product-gallery__thumbnail-list"), this.delegateElement.on("click", ".product-gallery__thumbnail", this._onThumbnailClicked.bind(this)), this.productThumbnailsListElement && this.flickityInstance && (this.productThumbnailsCellsElements = this.productThumbnailsListElement.querySelectorAll(".product-gallery__thumbnail"), this.flickityInstance.on("select", this._onGallerySlideChanged.bind(this)), "fade" === this.options.galleryTransitionEffect ? this.flickityInstance.on("select", this._onGallerySlideSettled.bind(this)) : this.flickityInstance.on("settle", this._onGallerySlideSettled.bind(this)), this._onGallerySlideChanged(!1), this._onGallerySlideSettled())
                }
            }, {
                key: "_createZoom",
                value: function e() {
                    var t = this;
                    if (this.options.enableImageZoom && b.matchesBreakpoint("lap-and-up")) {
                        this.driftObjects = [];
                        var i = this.element.querySelector(".product__zoom-wrapper");
                        this.element.querySelectorAll(".product-gallery__image").forEach(function(e) {
                            t.driftObjects.push(new eb(e, {
                                containInline: "outside" === t.options.zoomEffect,
                                inlinePane: window.innerWidth < 1024 || "outside" !== t.options.zoomEffect,
                                hoverBoundingBox: "outside" === t.options.zoomEffect,
                                handleTouch: !1,
                                inlineOffsetY: window.innerWidth < 1024 ? -85 : 0,
                                paneContainer: i
                            }))
                        })
                    }
                }
            }, {
                key: "_openMobileZoom",
                value: function e() {
                    var t = this,
                        i = this.element.querySelector(".pswp");
                    if (i && b.matchesBreakpoint("pocket")) {
                        var n = this.element.querySelectorAll('.product-gallery__carousel-item:not(.is-filtered)[data-media-type="image"]'),
                            s = 0,
                            o = [];
                        n.forEach(function(e, t) {
                            var i = e.querySelector(".product-gallery__image");
                            o.push({
                                src: i.getAttribute("data-zoom"),
                                w: parseInt(i.getAttribute("data-zoom-width")),
                                h: parseInt(i.getAttribute("data-zoom-width")) * (i.height / i.width),
                                msrc: i.currentSrc
                            }), e.classList.contains("is-selected") && (s = t)
                        }), i.querySelector(".pswp__prev-next").style.display = o.length > 1 ? "flex" : "none", this.photoSwipeInstance = new en(i, !1, o, {
                            index: s,
                            closeOnVerticalDrag: !1,
                            closeOnScroll: !1,
                            history: !1,
                            showHideOpacity: !0,
                            pinchToClose: !1,
                            maxSpreadZoom: 1,
                            showAnimationDuration: !1,
                            allowPanToNext: !1
                        });
                        var a = this.photoSwipeInstance.updateSize,
                            r = null;
                        this.photoSwipeInstance.updateSize = function() {
                            (null === r || r !== window.innerWidth) && a(this, arguments), r = window.innerWidth
                        }, this.photoSwipeInstance.listen("destroy", function() {
                            t.photoSwipeInstance = null
                        }), this.photoSwipeInstance.listen("beforeChange", function() {
                            var e = t.element.querySelector(".pswp__pagination-current"),
                                i = t.element.querySelector(".pswp__pagination-count");
                            e.textContent = t.photoSwipeInstance.getCurrentIndex() + 1, i.textContent = t.photoSwipeInstance.options.getNumItemsFn()
                        }), this.photoSwipeInstance.init()
                    }
                }
            }, {
                key: "_doPswpAction",
                value: function e(t, i) {
                    this.photoSwipeInstance && (i.classList.contains("pswp__button--close") ? this.photoSwipeInstance.close() : i.classList.contains("pswp__button--arrow--left") ? this.photoSwipeInstance.prev() : i.classList.contains("pswp__button--arrow--right") && this.photoSwipeInstance.next())
                }
            }, {
                key: "_handleZoomForMediaQuery",
                value: function e() {
                    b.matchesBreakpoint("lap-and-up") && this.photoSwipeInstance && (this.photoSwipeInstance.close(), this.photoSwipeInstance = null)
                }
            }, {
                key: "_onGallerySlideChanged",
                value: function e() {
                    var t = this,
                        i = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0],
                        n = null,
                        s = null;
                    if (this.productThumbnailsCellsElements.forEach(function(e) {
                            e.classList.contains("is-nav-selected") && (n = e), e.getAttribute("data-media-id") === t.flickityInstance.selectedElement.getAttribute("data-media-id") && (s = e)
                        }), 
                        n.classList.remove("is-nav-selected"), s.classList.add("is-nav-selected"), b.matchesBreakpoint("pocket")) {
                        var o = s.offsetLeft - (this.productThumbnailsListElement.parentNode.clientWidth - s.clientWidth) / 2;
                        this.productThumbnailsListElement.parentNode.scrollTo({
                            left: o,
                            behavior: i ? "smooth" : "auto"
                        })
                    } else {
                        if(this.element.querySelector(".product-block-list__item--gallery[data-thumbnails='left']")){
                            var o = s.offsetTop - (this.productThumbnailsListElement.parentNode.clientHeight - s.clientHeight) / 2;
                            this.productThumbnailsListElement.scrollTo({
                                top: o,
                                behavior: i ? "smooth" : "auto"
                            })
                        } else{
                            var o = s.offsetLeft - (this.productThumbnailsListElement.parentNode.clientWidth - s.clientWidth) / 2;
                            this.productThumbnailsListElement.scrollTo({
                                left: o,
                                behavior: i ? "smooth" : "auto"
                            })
                        }

                    }
                }
            }, {
                key: "_onGallerySlideSettled",
                value: function e() {
                    this._handleMedia(this.flickityInstance.selectedElement), b.matchesBreakpoint("lap-and-up") && this.element.querySelectorAll(".product-gallery__carousel-item:not(.is-selected)").forEach(function(e) {
                        e.classList.add("product-gallery__carousel-item--hidden")
                    })
                }
            }, {
                key: "_onThumbnailClicked",
                value: function e(t, i) {
                    t.preventDefault(), this.flickityInstance && (this.flickityInstance.selectCell('[data-media-id="'.concat(i.getAttribute("data-media-id"), '"]')), b.matchesBreakpoint("lap-and-up")) && this.element.querySelectorAll(".product-gallery__carousel-item").forEach(function(e) {
                        e.classList.remove("product-gallery__carousel-item--hidden")
                    })
                }
            }, {
                key: "_disableDrag",
                value: function e() {
                    this.flickityInstance.options.draggable = !1, this.flickityInstance.updateDraggable()
                }
            }, {
                key: "_enableDrag",
                value: function e() {
                    this.flickityInstance.options.draggable = !b.matchesBreakpoint("supports-hover"), this.flickityInstance.updateDraggable()
                }
            }, {
                key: "_handleMedia",
                value: function e(t) {
                    var i = null === this.previouslySelectedMedia;
                    if (this.previouslySelectedMedia && this.previouslySelectedMedia !== t) {
                        switch (this.previouslySelectedMedia.getAttribute("data-media-type")) {
                            case "video":
                            case "external_video":
                            case "model":
                                this.media[this.previouslySelectedMedia.getAttribute("data-media-id")].hasBeenDeselected()
                        }
                        "model" === this.previouslySelectedMedia.getAttribute("data-media-type") && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", this.viewInSpaceElement.getAttribute("data-shopify-model3d-default-id"))
                    }
                    switch (t.getAttribute("data-media-type")) {
                        case "video":
                        case "external_video":
                        case "model":
                            this.media[t.getAttribute("data-media-id")].hasBeenSelected(i), this.element.querySelector(".product-gallery__carousel").classList.remove("product-gallery__carousel--zoomable");
                            break;
                        case "image":
                            this.element.querySelector(".product-gallery__carousel").classList.add("product-gallery__carousel--zoomable")
                    }
                    "model" === t.getAttribute("data-media-type") && this.viewInSpaceElement && this.viewInSpaceElement.setAttribute("data-shopify-model3d-id", t.getAttribute("data-media-id")), this.previouslySelectedMedia = t
                }
            }, ]), e
        }(),
        e$ = function() {
            function e(i) {
                t(this, e), i && (this.element = i, this.inputElement = this.element.querySelector('[name="quantity"]'), this.delegateElement = new v(this.element), this._attachListeners())
            }
            return n(e, [{
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="decrease-picker-quantity"]', this._onDecrease.bind(this)), this.delegateElement.on("click", '[data-action="increase-picker-quantity"]', this._onIncrease.bind(this)), this.delegateElement.on("keyup", this._onInputValueChanged.bind(this)), this.delegateElement.on("focusout", this._onInputFocusOut.bind(this))
                }
            }, {
                key: "_onDecrease",
                value: function e() {
                    this.inputElement.value = Math.max(1, parseInt(this.inputElement.value) - 1)
                }
            }, {
                key: "_onIncrease",
                value: function e() {
                    this.inputElement.value = parseInt(this.inputElement.value) + 1
                }
            }, {
                key: "_onInputValueChanged",
                value: function e(t) {
                    var i = t.target.value;
                    "" !== i && isNaN(i) && (t.target.value = Math.max(1, parseInt(i) || 1))
                }
            }, {
                key: "_onInputFocusOut",
                value: function e(t) {
                    t.target.value = Math.max(1, parseInt(t.target.value) || 1)
                }
            }, ]), e
        }(),
        ew = function() {
            function e(i, n) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = n, this.countrySelector = new y(this.element.querySelector('[name="country"]'), this.element.querySelector('[name="province"]')), this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off("click"), this.countrySelector.destroy()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="estimate-shipping"]', this._fetchRates.bind(this))
                }
            }, {
                key: "_fetchRates",
                value: function e() {
                    document.dispatchEvent(new CustomEvent("theme:loading:start")), this.options.singleProduct ? this._fetchRatesForProduct() : this._fetchRatesForCart()
                }
            }, {
                key: "_fetchRatesForCart",
                value: function e() {
                    var t = this,
                        i = this.element.querySelector('[name="country"]').value,
                        n = this.element.querySelector('[name="province"]').value,
                        s = this.element.querySelector('[name="zip"]').value;
                    fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(s, "&shipping_address[country]=").concat(i, "&shipping_address[province]=").concat(n), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        document.dispatchEvent(new CustomEvent("theme:loading:end")), e.json().then(function(i) {
                            t._formatResults(e.ok, i)
                        })
                    })
                }
            }, {
                key: "_fetchRatesForProduct",
                value: function e() {
                    var t = this,
                        i = this._getCookie("cart"),
                        n = "temp-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random()),
                        s = "fake-cart-cookie___" + Date.now() + parseInt(1e3 * Math.random());
                    if (i || (this._updateCartCookie(n), i = this._getCookie("cart")), !(i.length < 32)) {
                        this._updateCartCookie(s);
                        var o = document.querySelector('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(o)),
                            credentials: "same-origin",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            },
                            method: "POST"
                        }).then(function(e) {
                            e.json().then(function() {
                                var e = t.element.querySelector('[name="country"]').value,
                                    n = t.element.querySelector('[name="province"]').value,
                                    s = t.element.querySelector('[name="zip"]').value;
                                fetch("".concat(window.routes.cartUrl, "/shipping_rates.json?shipping_address[zip]=").concat(s, "&shipping_address[country]=").concat(e, "&shipping_address[province]=").concat(n), {
                                    credentials: "same-origin",
                                    method: "GET"
                                }).then(function(e) {
                                    document.dispatchEvent(new CustomEvent("theme:loading:end")), e.json().then(function(i) {
                                        t._formatResults(e.ok, i)
                                    }), t._updateCartCookie(i)
                                }).catch(function() {
                                    t._updateCartCookie(i)
                                })
                            }).catch(function() {
                                t._updateCartCookie(i), document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    }
                }
            }, {
                key: "_formatResults",
                value: function e(t, i) {
                    var n = this.element.querySelector(".shipping-estimator__results");
                    if (n.innerHTML = "", t) {
                        var s = i.shipping_rates;
                        if (0 === s.length) n.innerHTML = "<p>".concat(window.languages.shippingEstimatorNoResults, "</p>");
                        else {
                            1 === s.length ? n.innerHTML = "<p>".concat(window.languages.shippingEstimatorOneResult, "</p>") : n.innerHTML = "<p>".concat(window.languages.shippingEstimatorMultipleResults.replace("{{count}}", s.length), "</p>");
                            var o = "";
                            s.forEach(function(e) {
                                o += "<li>".concat(e.name, ": ").concat(D.formatMoney(parseInt(100 * e.price), window.theme.moneyFormat), "</li>")
                            }), n.innerHTML += "<ul>".concat(o, "</ul>")
                        }
                    } else {
                        n.innerHTML = "<p>".concat(window.languages.shippingEstimatorErrors, "</p>");
                        var a = "";
                        Object.keys(i).forEach(function(e) {
                            a += '<li class="alert__list-item">'.concat(e, " ").concat(i[e], "</li>")
                        }), n.innerHTML += "<ul>".concat(a, "</ul>")
                    }
                    n.style.display = "block"
                }
            }, {
                key: "_getCookie",
                value: function e(t) {
                    var i = "; ".concat(document.cookie).split("; " + t + "=");
                    if (2 === i.length) return i.pop().split(";").shift()
                }
            }, {
                key: "_updateCartCookie",
                value: function e(t) {
                    var i = new Date;
                    i.setTime(i.getTime() + 12096e5), document.cookie = "cart=".concat(t, "; expires=").concat(i.toUTCString(), "; path=/")
                }
            }, ]), e
        }(),
        eE = function() {
            function e(i) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                t(this, e), this.id = i, this.delegateRoot = new v(document.documentElement), this.isOpen = !1, this.togglerElement = document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')), this.onSelect = n.onValueSelect || function() {}, this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateRoot.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateRoot.on("click", '[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)), this.delegateRoot.on("click", '[data-action="close-value-picker"][aria-controls="'.concat(this.id, '"]'), this._toggle.bind(this)), this.delegateRoot.on("click", "#".concat(this.id, ' [data-action="select-value"]'), this._selectValue.bind(this)), this.delegateRoot.on("click", this._detectOutsideClick.bind(this), !0), this.delegateRoot.on("focusout", "#".concat(this.id), this._onFocusOut.bind(this))
                }
            }, {
                key: "_toggle",
                value: function e(t) {
                    this.isOpen ? this._close(t) : this._open(t)
                }
            }, {
                key: "_open",
                value: function e() {
                    document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "true"), document.getElementById(this.id).setAttribute("aria-hidden", "false"), b.matchesBreakpoint("phone") && (document.querySelector(".shopify-section__header").style.zIndex = "3"), this.isOpen = !0, document.body.classList.add("no-mobile-scroll")
                }
            }, {
                key: "_close",
                value: function e() {
                    document.querySelector('[data-action="open-value-picker"][aria-controls="'.concat(this.id, '"]')).setAttribute("aria-expanded", "false"), document.getElementById(this.id).setAttribute("aria-hidden", "true"), document.querySelector(".shopify-section__header").style.zIndex = "", this.isOpen = !1, document.body.classList.remove("no-mobile-scroll")
                }
            }, {
                key: "_selectValue",
                value: function e(t, i) {
                    this.onSelect(i.getAttribute("data-value")), this._close()
                }
            }, {
                key: "_onFocusOut",
                value: function e(t) {
                    document.getElementById(this.id).contains(t.relatedTarget) || this._close()
                }
            }, {
                key: "_detectOutsideClick",
                value: function e(t) {
                    !(!this.isOpen || this.togglerElement === t.target || this.togglerElement.contains(t.target)) && !t.target.closest(".value-picker__inner") && this.isOpen && this._close(t)
                }
            }, ]), e
        }(),
        ek = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.element.querySelectorAll('[action*="/account/addresses"]').forEach(function(e) {
                    new y(e.querySelector('[name="address[country]"]'), e.querySelector('[name="address[province]"]'))
                }), this.pageSelector = new eE("account-selector")
            }
            return n(e, [{
                key: "_onUnload",
                value: function e() {
                    this.pageSelector.destroy()
                }
            }, ]), e
        }(),
        eS = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.isOpen = !1, this.options.showNewsletter ? document.documentElement.style.setProperty("--announcement-bar-button-width", this.element.querySelector(".announcement-bar__button").clientWidth + "px") : document.documentElement.style.removeProperty("--announcement-bar-button-width"), this._attachListeners()
            }
            return n(e, [{
                key: "onSelect",
                value: function e() {
                    this.options.showNewsletter && !this.isOpen && this._toggleNewsletter()
                }
            }, {
                key: "onDeselect",
                value: function e() {
                    this.options.showNewsletter && this.isOpen && this._toggleNewsletter()
                }
            }, {
                key: "onUnload",
                value: function e() {
                    this.domDelegate.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.domDelegate.on("click", '[data-action="toggle-newsletter"]', this._toggleNewsletter.bind(this)), this.domDelegate.on("keyup", this._handleKey.bind(this))
                }
            }, {
                key: "_toggleNewsletter",
                value: function e() {
                    var t = this.element.querySelector(".announcement-bar__button"),
                        i = this.element.querySelector(".announcement-bar__newsletter");
                    "false" === t.getAttribute("aria-expanded") ? (t.setAttribute("aria-expanded", "true"), i.setAttribute("aria-hidden", "false"), u.slideDown(i, function() {
                        S.trapFocus(i, "announcement-bar")
                    })) : (t.setAttribute("aria-expanded", "false"), i.setAttribute("aria-hidden", "true"), u.slideUp(i), S.removeTrapFocus(i, "announcement-bar")), this.isOpen = !this.isOpen
                }
            }, {
                key: "_handleKey",
                value: function e(t) {
                    "Escape" === t.key && this.isOpen && this._toggleNewsletter()
                }
            }, ]), e
        }(),
        ex = function() {
            function e(i) {
                if (t(this, e), this.element = i, this.blogTagSelector = new eE("blog-tag-selector"), Shopify.designMode) {
                    var n = this.element.querySelector(".page__header");
                    n && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", n))
                }
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.blogTagSelector.destroy()
                }
            }, ]), e
        }(),
        e_ = function e(i) {
            if (t(this, e), this.element = i, Shopify.designMode) {
                var n = this.element.querySelector(".page__header");
                n && (document.querySelector(".blog-container").previousElementSibling.remove(), document.querySelector(".blog-container").insertAdjacentElement("beforebegin", n))
            }
        },
        eC = function() {
            function e(i) {
                t(this, e), this.element = i, "blog" === window.theme.pageType && this._fixItemsPerRow()
            }
            return n(e, [{
                key: "_fixItemsPerRow",
                value: function e() {
                    0 === this.element.querySelectorAll(".blog-sidebar__item").length ? (document.querySelector(".blog-container").classList.add("blog-container--without-sidebar"), document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(e) {
                        e.classList.contains("1/2--lap-and-up") && (e.classList.remove("1/2--lap-and-up"), e.classList.add("1/3--lap-and-up"))
                    })) : (document.querySelector(".blog-container").classList.remove("blog-container--without-sidebar"), document.querySelectorAll(".shopify-section__blog-posts .block-list__item").forEach(function(e) {
                        e.classList.contains("1/3--lap-and-up") && (e.classList.remove("1/3--lap-and-up"), e.classList.add("1/2--lap-and-up"))
                    }))
                }
            }, ]), e
        }(),
        eL = function() {
            function e(i) {
                var n = this;
                if (t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.productGallery = new e8(this.element, this.options), this._initShopifyReviews(), this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init(), this.productVariants = new q(this.element, this.options), this.options.showShippingEstimator && (this.shippingEstimator = new ew(this.element.querySelector(".shipping-estimator"), {
                        singleProduct: !0
                    })), this.options.showQuantitySelector) {
                    var s = this.element.querySelector(".quantity-selector--product");
                    s && (this.quantityPicker = new e$(s))
                }
                // var o = this.element.querySelector(".product-block-list__item--info .card");
                // o && (this.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(o.clientHeight, "px"), window.ResizeObserver && (this.productInfoResizeObserver = new ResizeObserver(function(e) {
                //     e[0].contentBoxSize ? n.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(e[0].contentBoxSize[0].blockSize, "px") : n.element.querySelector(".product-block-list__wrapper").style.minHeight = "".concat(e[0].contentRect.height, "px")
                // }), this.productInfoResizeObserver.observe(o)), this.options.infoOverflowScroll && (this.infoOverflowScroller = new P(o, {
                //     offsetTop: document.documentElement.style.getPropertyValue("--header-is-sticky") * parseInt(document.documentElement.style.getPropertyValue("--header-height") + 30),
                //     offsetBottom: 30
                // }))), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.productVariants.destroy(), this.productGallery.destroy(), this.options.showShippingEstimator && this.shippingEstimator.destroy(), this.options.infoOverflowScroll && this.infoOverflowScroller.destroy(), window.ResizeObserver && this.productInfoResizeObserver && this.productInfoResizeObserver.disconnect(), this.delegateElement.off(), this.element.removeEventListener("variant:changed", this._onVariantChangedListener)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._onVariantChangedListener = this._onVariantChanged.bind(this), this.element.addEventListener("variant:changed", this._onVariantChangedListener)
                }
            }, {
                key: "_initShopifyReviews",
                value: function e() {
                    var t = this;
                    Shopify.designMode && window.SPR && (window.SPR.initDomEls(), window.SPR.loadProducts()), window.SPRCallbacks = {}, window.SPRCallbacks.onFormSuccess = function() {
                        t.element.querySelector("#shopify-product-reviews .spr-form").classList.add("spr-form-submitted")
                    }, this.options.isQuickView && this.options.showPaymentButton && window.Shopify.PaymentButton && Shopify.PaymentButton.init()
                }
            }, {
                key: "_onVariantChanged",
                value: function e(t) {
                    this.productGallery.variantHasChanged(t.detail.variant)
                }
            }, ]), e
        }(),
        eA = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.delegateRoot = new v(document.documentElement), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.showShippingEstimator && (this.shippingEstimator = new ew(this.element.querySelector(".shipping-estimator"), {
                    singleProduct: !1
                })), this._attachListeners(), this._enforceMinimumHeight()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.options.showShippingEstimator && this.shippingEstimator.destroy()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.domDelegate.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.domDelegate.on("click", '[data-action="save-note"]', this._saveNote.bind(this)), this.domDelegate.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), this.delegateRoot.on("cart:rerendered", this._onCartRerendered.bind(this))
                }
            }, {
                key: "_saveNote",
                value: function e() {
                    var t = this.element.querySelector('[name="note"]').value;
                    fetch("".concat(window.routes.cartUrl, "/update.js"), {
                        body: JSON.stringify({
                            note: t
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }), this.element.querySelector(".cart-recap__note-edit").classList.toggle("is-visible", "" !== t), document.dispatchEvent(new CustomEvent("collapsible:toggle", {
                        detail: {
                            id: "order-note"
                        }
                    }))
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                  console.log(t)
                    var n = this;
                    if ("page" !== window.theme.cartType) {
             
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = i.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                     
                            e.ok ? (i.removeAttribute("disabled"), n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    variant: null,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            }))) : i.removeAttribute("disabled")
                        }), t.preventDefault()
                    }
                }
            }, {
                key: "_openQuickView",
                value: function e(t, i) {
                    var n = document.getElementById(i.getAttribute("aria-controls"));
                    n.classList.add("is-loading"), fetch("".concat(i.getAttribute("data-product-url"), "?view=quick-view"), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            n.querySelector(".modal__inner").innerHTML = e, n.classList.remove("is-loading");
                            var t = new eL(n.querySelector('[data-section-type="product"]')),
                                i = function e() {
                                    t.onUnload(), n.removeEventListener("modal:closed", e)
                                };
                            n.addEventListener("modal:closed", i)
                        })
                    })
                }
            }, {
                key: "_enforceMinimumHeight",
                value: function e() {
                    var t = this.element.querySelector(".cart-wrapper"),
                        i = this.element.querySelector(".cart-recap__scroller");
                    t && i && (t.style.minHeight = "".concat(i.clientHeight, "px"), window.ResizeObserver) && new ResizeObserver(function(e) {
                        var i, n = function e(t, i) {
                            if ("undefined" == typeof Symbol || null == t[Symbol.iterator]) {
                                if (Array.isArray(t) || (o = function e(t, i) {
                                        if (t) {
                                            if ("string" == typeof t) return c(t, i);
                                            var n = Object.prototype.toString.call(t).slice(8, -1);
                                            if ("Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n) return Array.from(t);
                                            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return c(t, i)
                                        }
                                    }(t))) {
                                    o && (t = o);
                                    var n = 0,
                                        s = function() {};
                                    return {
                                        s: s,
                                        n: function() {
                                            return n >= t.length ? {
                                                done: !0
                                            } : {
                                                done: !1,
                                                value: t[n++]
                                            }
                                        },
                                        e: function(e) {
                                            throw e
                                        },
                                        f: s
                                    }
                                }
                                throw TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                            }
                            var o, a, r = !0,
                                l = !1;
                            return {
                                s: function() {
                                    o = t[Symbol.iterator]()
                                },
                                n: function() {
                                    var e = o.next();
                                    return r = e.done, e
                                },
                                e: function(e) {
                                    l = !0, a = e
                                },
                                f: function() {
                                    try {
                                        r || null == o.return || o.return()
                                    } finally {
                                        if (l) throw a
                                    }
                                }
                            }
                        }(e);
                        try {
                            for (n.s(); !(i = n.n()).done;) {
                                var s = i.value;
                                t.style.minHeight = "".concat(parseInt(s.contentRect.height), "px")
                            }
                        } catch (o) {
                            n.e(o)
                        } finally {
                            n.f()
                        }
                    }).observe(i)
                }
            }, {
                key: "_onCartRerendered",
                value: function e() {
                    this.options.showShippingEstimator && (this.shippingEstimator.destroy(), this.shippingEstimator = new ew(this.element.querySelector(".shipping-estimator"), {
                        singleProduct: !1
                    })), this._enforceMinimumHeight()
                }
            }, ]), e
        }(),
        eP = function() {
            function e(i) {
                var n = this;
                t(this, e), this.element = i;
                var s = this.element.querySelector(".collection-list");
                this.flickityInstance = new et(s, {
                    watchCSS: !0,
                    prevNextButtons: !0,
                    draggable: !window.matchMedia("(-moz-touch-enabled: 0), (hover: hover)").matches,
                    pageDots: !1,
                    resize: !1,
                    cellAlign: s.childElementCount < 6 ? "center" : "left",
                    contain: !0,
                    groupCells: !0
                });
                var o = window.innerWidth;
                window.addEventListener("resize", function() {
                    window.innerWidth !== o && (n.flickityInstance.resize(), o = window.innerWidth)
                })
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    this.flickityInstance.isActive && this.flickityInstance.selectCell(parseInt(t.target.getAttribute("data-collection-index")), null, t.detail.load)
                }
            }, ]), e
        }(),
        eI = function() {
            function e(i) {
                var n = this;
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.currentUrl = new URL(window.location.href), this.mobileFilterDrawer = new w(this.options), this.displayByValuePicker = new eE("display-by-selector", {
                    onValueSelect: this._showingCountChanged.bind(this)
                }), this.sortByValuePicker = new eE("sort-by-selector", {
                    onValueSelect: this._sortByChanged.bind(this)
                }), this.productItemColorSwatch = new z(this.element), "search" === window.theme.pageType && "product" !== window.theme.searchMode && this._loadContentResults(), window.addEventListener("popstate", function() {
                    n.currentUrl = new URL(window.location.href), n._reload(!1)
                });
                var s = this.element.querySelector(".stickySidebar");
                s && (this.element.querySelector("[data-collection-layout]").style.minHeight = "".concat(s.clientHeight, "px"), window.ResizeObserver && (this.productInfoResizeObserver = new ResizeObserver(function(e) {
                    e[0].contentBoxSize ? n.element.querySelector("[data-collection-layout]").style.minHeight = "".concat(e[0].contentBoxSize[0].blockSize, "px") : n.element.querySelector("[data-collection-layout]").style.minHeight = "".concat(e[0].contentRect.height, "px")
                }), this.productInfoResizeObserver.observe(s)), this.options.infoOverflowScroll && (this.infoOverflowScroller = new P(s, {
                    offsetTop: document.documentElement.style.getPropertyValue("--header-is-sticky") * parseInt(document.documentElement.style.getPropertyValue("--header-height") + 30),
                    offsetBottom: 30
                }))), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.delegateElement.off(), this.mobileFilterDrawer.destroy(), this.displayByValuePicker.destroy(), this.sortByValuePicker.destroy(), this.productItemColorSwatch.destroy()
                }
            }, {
                key: "onSelect",
                value: function e(t) {
                    Shopify.designMode && t.detail.load && (this.element.querySelector('.collection__layout-button[data-layout-mode="'.concat(this.options.defaultLayout, '"]')).click(), this._showingCountChanged(this.options.defaultProductsPerPage))
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="change-layout"]', this._changeLayout.bind(this)), this.delegateElement.on("change", "#mobile-sort-by, #desktop-sort-by", this._sortByChanged.bind(this)), this.delegateElement.on("change", "#showing-count", this._showingCountChanged.bind(this)), this.delegateElement.on("click", ".pagination [data-page]", this._paginationPageChanged.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("change", '[name^="filter."]', this._onFilterChanged.bind(this)), this.delegateElement.on("click", '[data-action="clear-filters"]', this._onFiltersCleared.bind(this))
                }
            }, {
                key: "_openQuickView",
                value: function e(t, i) {
                    var n = new URL("".concat(window.location.origin).concat(i.getAttribute("data-product-url")));
                    if (b.matchesBreakpoint("phone") || b.matchesBreakpoint("tablet")) return window.location.href = n.href, !1;
                    var s = document.getElementById(i.getAttribute("aria-controls"));
                    s.classList.add("is-loading"), n.searchParams.set("view", "quick-view"), fetch(n.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                           // const html = new DOMParser().parseFromString(e, "text/html");       
                          // const form = html.querySelector('.product-form');
                            s.querySelector(".modal__dialog").classList.add('product-item-modal'); 
                            s.querySelector(".modal__inner").innerHTML = e, s.classList.remove("is-loading");
                             // const price =  modal.querySelector('.product-form__info-list');
                            // price.insertAdjacentHTML("afterend", prodVariants.innerHTML);
                           // const variantWrapper = modal.querySelector('.product-meta--variants-options');
                            // variantWrapper.addEventListener("click", function(e){
                            //   if(e.target.closest('.product-meta--variants-option-link')){
                            //     const activeInput = variantWrapper.querySelector(".product-meta--variants-option-link.is-current");
                            //     activeInput.classList.remove('is-current');
                            //     e.target.closest('.product-meta--variants-option-link').classList.add("is-current");
                            //     const currentVariant = JSON.parse(e.target.closest('.product-meta--variants-option-link').querySelector("input").dataset.variant);
                            //     const currentVariantTitle = currentVariant.title;
                            //     const currentVariantHandle = currentVariant.handle;
                            //     const currentVariantId = currentVariant.variants[0].id;
                            //     const currentVariantPrice = currentVariant.price;
                            //     const currentVariantComparePrice = currentVariant.compare_at_price;                              
                            //     const title = modal.querySelector('.product-meta__title');
                            //     const variantInput = modal.querySelector('input[name="id"]');
                            //     const priceWrapper =  modal.querySelector('.priceWrapper');
                            //     if(currentVariantComparePrice!=null){
       
                            //       priceWrapper.innerHTML = `
                            //         <span class="price price--highlight">
                            //           <span class="visually-hidden"></span>${(currentVariantPrice / 100).toFixed(2).toString().replace(".",",")}</span>
                          
                            //         <span class="price price--compare">
                            //           <span class="visually-hidden"></span>${(currentVariantComparePrice / 100).toFixed(2).toString().replace(".",",")} </span>
                            //       `;
                            //     } else{
                            //       priceWrapper.innerHTML = `
                            //       <span class="price">
                            //           <span class="visually-hidden"></span>${(currentVariantPrice  / 100).toFixed(2).toString().replace(".",",")}</span>        
                            //       `;
                            //     }
                            //     title.innerHTML = `<a href="/products/${currentVariantHandle}">${currentVariantTitle}</a>`;
                            //     variantInput.value = currentVariantId;
                            //   }
                            // })
                            var t = new eL(s.querySelector('[data-section-type="product"]')),
                                i = function e() {
                                    t.onUnload(), s.removeEventListener("modal:closed", e)
                                };
                            s.addEventListener("modal:closed", i)
                        })
                    })
                }
            }, {
                key: "_changeLayout",
                value: function e(t, i) {
                    var n = this;
                    if (!i.classList.contains("is-selected")) {
                        var s = i.getAttribute("data-layout-mode");
                        fetch("".concat(window.routes.cartUrl, "/update.js"), {
                            body: JSON.stringify({
                                attributes: {
                                    collection_layout: s
                                }
                            }),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }), A.mutate(function() {
                            d.getSiblings(i, ".is-selected").forEach(function(e) {
                                return e.classList.remove("is-selected")
                            }), i.classList.add("is-selected");
                            let e = n.element.querySelector(".product-list.product-list--collection");
                            "grid" === s ? e.className = "product-list product-list--collection product-list--collection-grid" : e.className = "product-list product-list--collection product-list--collection-list", n.element.querySelectorAll(".product-item").forEach(function(e) {
                                "grid" === s ? e.className = "product-item product-item--vertical ".concat(n.options.gridClasses) : e.className = "product-item product-item--list"
                            }), n.productItemColorSwatch.recalculateSwatches()
                        })
                    }
                }
            }, {
                key: "_sortByChanged",
                value: function e(t) {
                    this.currentUrl.searchParams.set("sort_by", t), this.currentUrl.searchParams.delete("page"), this._reload(!0)
                }
            }, {
                key: "_showingCountChanged",
                value: function e(t) {
                    var i = this;
                    this.currentUrl.searchParams.delete("page"), fetch("".concat(window.routes.cartUrl, "/update.js"), {
                        body: JSON.stringify({
                            attributes: {
                                collection_products_per_page: t
                            }
                        }),
                        credentials: "same-origin",
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            "X-Requested-With": "XMLHttpRequest"
                        }
                    }).then(function() {
                        i._reload(!0)
                    })
                }
            }, {
                key: "_paginationPageChanged",
                value: function e(t, i) {
                    t.preventDefault(), this.currentUrl.searchParams.set("page", parseInt(i.getAttribute("data-page"))), this._reload(!0)
                }
            }, {
                key: "_onFilterChanged",
                value: function e(t, i) {
                    var n = new FormData(i.closest("form")),
                        s = new URLSearchParams(n).toString();
                    this.currentUrl = new URL("".concat(window.location.pathname, "?").concat(s), window.location.origin), this._reload(!0)
                }
            }, {
                key: "_onFiltersCleared",
                value: function e(t, i) {
                    this.currentUrl = new URL(i.getAttribute("data-url"), window.location.origin), this._reload(!0)
                }
            }, {
                key: "_reload",
                value: function e(t) {
                    var i = this;
                    this.abortController && this.abortController.abort(), t && window.history.pushState({
                        path: this.currentUrl.toString()
                    }, "", this.currentUrl.toString()), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    var n = window.getComputedStyle(document.documentElement),
                        s = "";
                    s = this.currentUrl.search ? "".concat(this.currentUrl.pathname, "/").concat(this.currentUrl.search, "&section_id=").concat(this.element.getAttribute("data-section-id")) : "".concat(this.currentUrl.pathname, "?section_id=").concat(this.element.getAttribute("data-section-id"));
                    try {
                        return this.abortController = new AbortController, fetch(s, {
                            credentials: "same-origin",
                            method: "GET",
                            signal: this.abortController.signal
                        }).then(function(e) {
                            e.text().then(function(e) {
                                var t = document.createElement("div");
                                t.innerHTML = e, i.element.querySelector(".collection__dynamic-part").innerHTML = t.querySelector(".collection__dynamic-part").innerHTML;
                                var s = i.element.querySelector("#desktop-filters-form"),
                                    o = i.element.querySelector("#mobile-collection-filters"),
                                    a = 0;
                                o && (a = o.querySelector(".collection-drawer__inner").scrollTop), s && (Array.from(i.element.querySelectorAll(".collection__filter-group-name")).forEach(function(e) {
                                    var i = t.querySelector('[aria-controls="'.concat(e.getAttribute("aria-controls"), '"]'));
                                    "true" === e.getAttribute("aria-expanded") ? (i.setAttribute("aria-expanded", "true"), i.nextElementSibling.setAttribute("aria-hidden", "false"), i.nextElementSibling.style.height = "auto", i.nextElementSibling.style.overflow = "visible") : (i.setAttribute("aria-expanded", "false"), i.nextElementSibling.setAttribute("aria-hidden", "true"), i.nextElementSibling.style = "")
                                }), s.innerHTML = t.querySelector("#desktop-filters-form").innerHTML, o.innerHTML = t.querySelector("#mobile-collection-filters").innerHTML, o.querySelector(".collection-drawer__inner").scrollTop = a, i.mobileFilterDrawer._computeDrawerHeight()), i.productItemColorSwatch.recalculateSwatches();
                                var r = i.element.querySelector(".collection").getBoundingClientRect().top - 25 - parseInt(n.getPropertyValue("--header-is-sticky")) * parseInt(n.getPropertyValue("--header-height"));
                                r < 0 && window.scrollBy({
                                    top: r,
                                    behavior: "smooth"
                                }), document.dispatchEvent(new CustomEvent("theme:loading:end"))
                            })
                        })
                    } catch (o) {}
                }
            }, {
                key: "_loadContentResults",
                value: function e() {
                    var t = this,
                        i = new URL(window.location.href);
                    fetch("".concat(window.routes.searchUrl, "?section_id=search-content&q=").concat(i.searchParams.get("q"), "&type=").concat(window.theme.searchMode.replace("product,", "")), {
                        credentials: "same-origin"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            var i = t.element.querySelector(".link-search-results"),
                                n = document.createElement("div");
                            n.innerHTML = e, i && "" !== e.trim() && (i.innerHTML = n.firstElementChild.innerHTML, i.style.display = "block")
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                    var n = this;
                                                    
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = i.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                     
                            i.removeAttribute("disabled"), e.ok ? n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: i,
                                    variant: null,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                       i.classList.add("product-added");
                    
                        }), t.preventDefault()
             
                 // Add to cart button for collection product item
                    // if ("page" !== window.theme.cartType) {                     
                    //     t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                    //     var s = i.closest('form[action*="/cart/add"]');
                    //     fetch("".concat(window.routes.cartAddUrl, ".js"), {
                    //         body: JSON.stringify(T.serialize(s)),
                    //         credentials: "same-origin",
                    //         method: "POST",
                    //         headers: {
                    //             "Content-Type": "application/json",
                    //             "X-Requested-With": "XMLHttpRequest"
                    //         }
                    //     }).then(function(e) {
                     
                    //         i.removeAttribute("disabled"), e.ok ? n.element.dispatchEvent(new CustomEvent("product:added", {
                    //             bubbles: !0,
                    //             detail: {
                    //                 button: i,
                    //                 variant: null,
                    //                 quantity: parseInt(s.querySelector('[name="quantity"]').value)
                    //             }
                    //         })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                    //     }), t.preventDefault()
                    // }
                }
            }, ]), e
        }(),
        ez = function() {
            function e(i) {
                if (t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), !this.options.stackable) {
                    var n = window.innerWidth;
                    window.addEventListener("resize", function() {
                        window.innerWidth !== n && (n = window.innerWidth)
                    })
                }
                this.productItemColorSwatch = new z(this.element), this._fixSafari(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), this.delegateElement.off("change"), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    var t = this;
                    this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this)), window.ResizeObserver && this.flickityInstance && (this.resizeObserver = new ResizeObserver(function() {
                        t.flickityInstance.resize()
                     
                    }), this.element.querySelectorAll(".product-item").forEach(function(e) {
                        t.resizeObserver.observe(e)
                    }))
                }
            }, {
                key: "_fixSafari",
                value: function e() {
                    var t = window.navigator.userAgent.toLowerCase();
                    if (t.includes("safari") && (t.includes("version/10.1") || t.includes("version/10.3") || t.includes("version/11.0"))) {
                        var i = b.matchesBreakpoint("phone");
                        this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(e) {
                            i ? e.parentNode.style.height = null : e.parentNode.style.height = "".concat(e.clientHeight, "px")
                        })
                    }
                }
            }, {
                key: "_openQuickView",
                value: function e(t, i) {
                    var n = new URL("".concat(window.location.origin).concat(i.getAttribute("data-product-url")));
                    if (b.matchesBreakpoint("phone") || b.matchesBreakpoint("tablet")) return window.location.href = n.href, !1;
                    var s = document.getElementById(i.getAttribute("aria-controls"));
                    s.classList.add("is-loading"), n.searchParams.set("view", "quick-view"), fetch(n.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            s.querySelector(".modal__inner").innerHTML = e, s.classList.remove("is-loading");
                            var t = new eL(s.querySelector('[data-section-type="product"]')),
                                i = function e() {
                                    t.onUnload(), s.removeEventListener("modal:closed", e)
                                };
                            s.addEventListener("modal:closed", i)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                  console.log(t)
                    var n = this;
                    if ("page" !== window.theme.cartType) {
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = i.closest('form[action*="/cart/add"]');
                    
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                          
                            i.removeAttribute("disabled"), e.ok ? n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: i,
                                    variant: null,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), t.preventDefault()
                    }
                }
            }, ]), e
        }(),
        eD = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this._createQrCode(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.delegateElement.off()
                }
            }, {
                key: "_createQrCode",
                value: function e() {
                    document.querySelectorAll(".gift-card__qr").forEach(function(e) {
                        new QRCode(e, {
                            text: e.getAttribute("data-identifier"),
                            width: 200,
                            height: 200
                        })
                    })
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="print"]', this._print.bind(this)), this.delegateElement.on("click", '[data-action="select-code"]', this._selectCode.bind(this))
                }
            }, {
                key: "_print",
                value: function e() {
                    window.print()
                }
            }, {
                key: "_selectCode",
                value: function e(t, i) {
                    i.select()
                }
            }, ]), e
        }(),
        eT = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.localeValuePicker = new eE("footer-locale-picker"), this.currencyValuePicker = new eE("footer-currency-picker"), this.cookieBarElement = this.element.querySelector(".cookie-bar"), this.cookieBarElement && this._setupCookieBar(), this._setupCollapsibles(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    window.removeEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.off(), this.localeValuePicker.destroy(), this.currencyValuePicker.destroy()
                }
            }, {
                key: "onSelect",
                value: function e() {
                    this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "false")
                }
            }, {
                key: "onDeselect",
                value: function e() {
                    this.cookieBarElement && this.cookieBarElement.setAttribute("aria-hidden", "true")
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._setupCollapsiblesListener = this._setupCollapsibles.bind(this), window.addEventListener("resize", this._setupCollapsiblesListener), this.domDelegate.on("click", '[data-action="accept-terms"]', this._acceptCookieBarTerms.bind(this))
                }
            }, {
                key: "_setupCollapsibles",
                value: function e() {
                    var t = this.element.querySelectorAll('[data-action="toggle-collapsible"]'),
                        i = b.matchesBreakpoint("phone");
                    t.forEach(function(e) {
                        i ? e.removeAttribute("disabled") : (e.setAttribute("disabled", "disabled"), document.getElementById(e.getAttribute("aria-controls")).style.height = "")
                    })
                }
            }, {
                key: "_setupCookieBar",
                value: function e() {
                    try {
                        null === localStorage.getItem("cookieWasAccepted") && this.cookieBarElement.setAttribute("aria-hidden", "false")
                    } catch (t) {}
                }
            }, {
                key: "_acceptCookieBarTerms",
                value: function e() {
                    this.cookieBarElement.setAttribute("aria-hidden", "true");
                    try {
                        localStorage.setItem("cookieWasAccepted", "true")
                    } catch (t) {}
                }
            }, ]), e
        }(),
        eM = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.headerElement = this.element.closest(".header"), this.searchBarElement = this.element.querySelector(".search-bar"), this.inputElement = this.element.querySelector('[name="q"]'), this.searchMenuElement = this.element.querySelector(".search-bar__menu-wrapper"), this.searchResultsElement = this.element.querySelector(".search-bar__results"), this.closeButtonElement = this.element.querySelector(".search-bar__close-button"), this.productTypeFilter = "", this.isSearchOpen = !1, this._attachListeners()
            }
            return n(e, [{
                key: "destroy",
                value: function e() {
                    this.delegateElement.off()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="clear-input"]', this._clearInput.bind(this)), this.delegateElement.on("click", '[data-action="unfix-search"]', this._unfixMobileSearch.bind(this)), this.delegateElement.on("focusin", '[name="q"]', this._onInputFocus.bind(this)), document.addEventListener("click", this._onFocusOut.bind(this)), this.delegateElement.on("keydown", '[name="q"]', this._handleTab.bind(this)), this.delegateElement.on("input", '[name="q"]', this._debounce(this._doSearch.bind(this), 250)), this.delegateElement.on("change", "#search-product-type", this._productTypeChanged.bind(this)), this.delegateElement.on("submit", this._onFormSubmit.bind(this))
                }
            }, {
                key: "toggleMobileSearch",
                value: function e() {
                    this.isSearchOpen ? (this.headerElement.classList.remove("header--search-expanded"), this.element.classList.remove("is-visible")) : (this.headerElement.classList.add("header--search-expanded"), this.element.classList.add("is-visible")), this.isSearchOpen = !this.isSearchOpen
                }
            }, {
                key: "_unfixMobileSearch",
                value: function e() {
                    this.element.classList.remove("is-fixed"), this.closeButtonElement.style.width = "", this.searchBarElement.classList.remove("is-expanded"), this.searchResultsElement.setAttribute("aria-hidden", "true"), this.inputElement.classList.remove("is-filled"), document.body.classList.remove("no-mobile-scroll"), this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true")
                }
            }, {
                key: "_clearInput",
                value: function e() {
                    this.inputElement.value = "", this.inputElement.classList.remove("is-filled"), this.searchResultsElement.setAttribute("aria-hidden", "true"), this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false")
                }
            }, {
                key: "_onInputFocus",
                value: function e() {
                    this.element.classList.add("is-fixed"), this.closeButtonElement.style.width = "".concat(this.closeButtonElement.firstElementChild.offsetWidth, "px"), document.body.classList.add("no-mobile-scroll"), "" === this.inputElement.value ? (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "false"), this.searchResultsElement.setAttribute("aria-hidden", "true")) : (this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), this.searchResultsElement.setAttribute("aria-hidden", "false"), this.inputElement.classList.add("is-filled"), this.searchBarElement.classList.add("is-expanded")), this.searchMenuElement && this.searchBarElement.classList.add("is-expanded")
                }
            }, {
                key: "_onFocusOut",
                value: function e(t) {
                    var i = this;
                    !(b.matchesBreakpoint("phone") || b.matchesBreakpoint("phone") || t.target.classList.contains("search-bar__input") || t.target.closest(".search-bar__inner")) && setTimeout(function() {
                        i.element.classList.remove("is-fixed"), document.body.classList.remove("no-mobile-scroll"), i.element.contains(t.relatedTarget) || (i.searchMenuElement && i.searchMenuElement.setAttribute("aria-hidden", "true"), i.searchResultsElement.setAttribute("aria-hidden", "true"), i.searchBarElement.classList.remove("is-expanded"))
                    }, 150)
                }
            }, {
                key: "_handleTab",
                value: function e(t) {
                    if ("Tab" === t.key) {
                        var i = this.searchResultsElement.querySelector("a");
                        i && (i.focus(), t.preventDefault())
                    }
                }
            }, {
                key: "_doSearch",
                value: function e() {
                    var t = this,
                        i = this.inputElement.value;
                  console.log(t)
                  //          if(this.inputElement.value==""){
                  //   console.log(t)
                  //     t.preventDefault()
                  //  // window.stop();
                  // }   else{
                  //  t.returnValue = true;
                  // }    
                    if (this.lastInputValue = i, "" === i) this.searchMenuElement ? this.searchMenuElement.setAttribute("aria-hidden", "false") : this.searchBarElement.classList.remove("is-expanded"), this.searchResultsElement.setAttribute("aria-hidden", "true");
                    else {
                        this.searchMenuElement && this.searchMenuElement.setAttribute("aria-hidden", "true"), this.searchResultsElement.setAttribute("aria-hidden", "false"), this.searchBarElement.classList.add("is-expanded", "is-loading");
                        var n = {
                                method: "GET",
                                credentials: "same-origin"
                            },
                            s = "".concat("" !== this.productTypeFilter ? "product_type:".concat(this.productTypeFilter, " AND ") : "").concat(encodeURIComponent(this.lastInputValue)),
                            o = [fetch("".concat(window.routes.searchUrl, "?section_id=search-ajax&q=").concat(s, "&options[prefix]=last&options[unavailable_products]=").concat(window.theme.searchUnavailableProducts, "&type=product"), n), ];
          
                        "product" !== window.theme.searchMode && o.push(fetch("".concat(window.routes.searchUrl, "?section_id=search-ajax&q=").concat(encodeURIComponent(this.lastInputValue), "&options[prefix]=last&type=").concat(window.theme.searchMode.replace("product,", "")), n)), Promise.all(o).then(function(e) {
                            t.lastInputValue === i && Promise.all(e.map(function(e) {
                              if(e.url.includes("unavailable_products")){
                                t.searchBarElement.addEventListener("submit", function (e){
                                  // e.preventDefault()
                                })
                              }
                              return e.text().then(function(e) {
                                    var t = document.createElement("div");
                                    return t.innerHTML = e, t.querySelector(".search-ajax").innerHTML
                                })
                            })).then(function(e) {
                                t.searchBarElement.classList.remove("is-loading");
                                var i = document.createElement("div");
                                i.innerHTML = e.join("").trim();
                                var n = i.querySelector(".search-bar__view-all");
                                n && i.insertAdjacentElement("beforeend", n), t.searchBarElement.querySelector(".search-bar__results-inner").innerHTML = i.innerHTML
                            })
                        })
                    }
                }
            }, {
                key: "_productTypeChanged",
                value: function e(t, i) {
                    i.closest(".search-bar__filter").querySelector(".search-bar__filter-active").innerText = i.options[i.selectedIndex].innerText, this.productTypeFilter = i.value, "" !== this.inputElement.value && this._doSearch()
                }
            }, {
                key: "_onFormSubmit",
                value: function e(t) {
                 if(this.inputElement.value!==""){
                       return true
                    var i = this.inputElement.cloneNode();
                    i.setAttribute("type", "hidden"), i.value = "", "" !== this.productTypeFilter && (i.value += "product_type:".concat(this.productTypeFilter), "" !== this.inputElement.value && (i.value += " AND ")), i.value += this.inputElement.value, this.inputElement.removeAttribute("name"), this.inputElement.insertAdjacentElement("afterend", i)
                   
                   }   else{
                   t.preventDefault()
                     
                   } 
                  
                }
            }, {
                key: "_debounce",
                value: function e(t, i) {
                    var n = this,
                        s = null;
                    return function() {
                        for (var e = arguments.length, o = Array(e), a = 0; a < e; a++) o[a] = arguments[a];
                        clearTimeout(s), s = setTimeout(function() {
                            t.apply(n, o)
                        }, i)
                    }
                }
            }, ]), e
        }(),
        eq = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.searchBar = new eM(this.element.querySelector(".header__search-bar-wrapper")), this.cart = new x(this.element.querySelector(".header__action-item--cart"), {
                    useStickyHeader: this.options.useStickyHeader
                });
                var n = this.element.querySelector("inline" === this.options.navigationLayout ? ".nav-bar" : ".header__desktop-nav");
                n && (this.desktopNavigation = new $(n, this.options.navigationLayout, this.options.desktopOpenTrigger));
                var s = this.element.querySelector(".header__mobile-nav");
          
                s && (this.mobileNavigation = new _(s)), this._setupCssVariables(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.searchBar.destroy(), this.cart.destroy(), this.desktopNavigation && this.desktopNavigation.destroy(), this.mobileNavigation && this.mobileNavigation.destroy(), window.removeEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    this.desktopNavigation && this.desktopNavigation.onBlockSelect(t)
                }
            }, {
                key: "onBlockDeselect",
                value: function e(t) {
                    this.desktopNavigation && this.desktopNavigation.onBlockDeselect(t)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener), this.delegateElement.on("click", '[data-action="toggle-search"]', this._toggleMobileSearch.bind(this))
                }
            }, {
                key: "_setupCssVariables",
                value: function e() {
                    document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px")
                }
            }, {
                key: "_toggleMobileSearch",
                value: function e(t) {
                    this.searchBar.toggleMobileSearch(), t.preventDefault()
                }
            }, ]), e
        }(),
        eO = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.customerLoginForm = this.element.querySelector("#customer_login"), this.recoverPasswordForm = this.element.querySelector("#recover_customer_password"), this.domDelegate.on("click", '[data-action="toggle-login-form"]', this._showRecoverPassword.bind(this))
            }
            return n(e, [{
                key: "_showRecoverPassword",
                value: function e() {
                    "block" === this.customerLoginForm.style.display ? (this.customerLoginForm.style.display = "none", this.recoverPasswordForm.style.display = "block") : (this.customerLoginForm.style.display = "block", this.recoverPasswordForm.style.display = "none")
                }
            }, ]), e
        }(),
        eB = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(i.getAttribute("data-section-settings")), this.mapPositions = [], this.desktopMarkers = [], this.desktopMapElement = null, this.mobileMarkers = [], this.mobileMapElements = [], this.options.apiKey && this.options.mapAddresses.length > 0 && this._loadScript().then(this._initMaps.bind(this)), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.delegateElement.off("click"), this.options.apiKey && this.options.mapAddresses.length > 0 && google.maps.event.clearInstanceListeners(window)
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    this._showStore(t.target)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    var t = this;
                    this.delegateElement.on("click", '[data-action="toggle-store"]', function(e, i) {
                        t._showStore(i.closest(".map__store-item"))
                    })
                }
            }, {
                key: "_showStore",
                value: function e(t) {
                    var i = this,
                        n = t.querySelector('[data-action="toggle-store"]');
                    if ("phone" === b.getCurrentBreakpoint() || "true" !== n.getAttribute("aria-expanded")) {
                        "true" === n.getAttribute("aria-expanded") ? (n.setAttribute("aria-expanded", "false"), u.slideUp(t.querySelector(".map__store-collapsible"))) : (n.setAttribute("aria-expanded", "true"), u.slideDown(t.querySelector(".map__store-collapsible"))), d.getSiblings(t).forEach(function(e) {
                            e.querySelector('[data-action="toggle-store"]').setAttribute("aria-expanded", "false"), u.slideUp(e.querySelector(".map__store-collapsible"))
                        });
                        var s = parseInt(t.getAttribute("data-store-index"));
                        this.desktopMapElement.panTo(this.mapPositions[s]), this.desktopMarkers.forEach(function(e, t) {
                            e.setMap(i.desktopMapElement), t === s ? e.icon.fillColor = i.options.markerActiveColor : e.icon.fillColor = i.options.markerColor
                        })
                    }
                }
            }, {
                key: "_loadScript",
                value: function e() {
                    var t = this;
                    return new Promise(function(e, i) {
                        var n = document.createElement("script");
                        document.body.appendChild(n), n.onload = e, n.onerror = i, n.async = !0, n.src = "https://maps.googleapis.com/maps/api/js?key=".concat(t.options.apiKey)
                    })
                }
            }, {
                key: "_initMaps",
                value: function e() {
                    var t = this,
                        i = {
                            zoom: this.options.zoom,
                            draggable: this.options.draggableMap,
                            clickableIcons: !1,
                            scrollwheel: this.options.draggableMap,
                            disableDoubleClickZoom: !0,
                            disableDefaultUI: !this.options.showMapControls,
                            styles: JSON.parse(this.element.querySelector("[data-gmap-style]").innerHTML)
                        };
                    this.desktopMapElement = new google.maps.Map(this.element.querySelector(".map__map-container--desktop .map__gmap"), i), this.mobileMapElements = [], this.element.querySelectorAll(".map__map-container--mobile .map__gmap").forEach(function(e, n) {
                        t.mobileMapElements[n] = new google.maps.Map(e, i)
                    }), this._geocodeAddresses(), google.maps.event.addDomListener(window, "resize", function() {
                        var e = t.desktopMapElement.getCenter();
                        google.maps.event.trigger(t.desktopMapElement, "resize"), t.desktopMapElement.setCenter(e), t.mobileMapElements.forEach(function(e) {
                            var t = e.getCenter();
                            google.maps.event.trigger(e, "resize"), e.setCenter(t)
                        })
                    })
                }
            }, {
                key: "_onMarkerClicked",
                value: function e(t) {
                    window.open("https://www.google.com/maps/search/?api=1&query=".concat(t), "_blank")
                }
            }, {
                key: "_geocodeAddresses",
                value: function e() {
                    var t = this,
                        i = new google.maps.Geocoder;
                    this.options.mapAddresses.forEach(function(e, n) {
                        i.geocode({
                            address: e
                        }, function(i, s) {
                            if (s !== google.maps.GeocoderStatus.OK) Shopify.designMode;
                            else {
                                var o = i[0].geometry.location;
                                t.mapPositions[n] = o, t.desktopMarkers[n] = new google.maps.Marker({
                                    map: 0 === n ? t.desktopMapElement : null,
                                    position: o,
                                    icon: {
                                        path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                        fillColor: 0 === n ? t.options.markerActiveColor : t.options.markerColor,
                                        fillOpacity: 1,
                                        anchor: new google.maps.Point(12, 30),
                                        strokeWeight: 0
                                    }
                                }), t.mobileMarkers[n] = new google.maps.Marker({
                                    map: t.mobileMapElements[n],
                                    position: o,
                                    icon: {
                                        path: "M12.5,0 C6.388889,0 0,4.7304348 0,12.5217391 C0,19.8956522 11.111111,31.1652174 11.527778,31.5826087 C11.805556,31.8608696 12.083333,32 12.5,32 C12.916667,32 13.194444,31.8608696 13.472222,31.5826087 C13.888889,31.1652174 25,19.8956522 25,12.5217391 C25,4.7304348 18.611111,0 12.5,0 Z M12,16 C9.733333,16 8,14.2666667 8,12 C8,9.7333333 9.733333,8 12,8 C14.266667,8 16,9.7333333 16,12 C16,14.2666667 14.266667,16 12,16 Z",
                                        fillColor: t.options.markerActiveColor,
                                        fillOpacity: 1,
                                        anchor: new google.maps.Point(12, 30),
                                        strokeWeight: 0
                                    }
                                }), t.desktopMarkers[n].addListener("click", t._onMarkerClicked.bind(t, e)), t.mobileMarkers[n].addListener("click", t._onMarkerClicked.bind(t, e)), 0 === n && t.desktopMapElement.setCenter(o), t.mobileMapElements[n].setCenter(o)
                            }
                        })
                    })
                }
            }, ]), e
        }(),
        eH = function() {
            function e(i) {
                t(this, e), this.element = i, this._setupCssVariables(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    window.removeEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._setupCssVariablesListener = this._setupCssVariables.bind(this), window.addEventListener("resize", this._setupCssVariablesListener)
                }
            }, {
                key: "_setupCssVariables",
                value: function e() {
                    document.documentElement.style.setProperty("--header-height", this.element.parentNode.clientHeight + "px")
                }
            }, ]), e
        }(),
        eR = function e(i) {
            t(this, e), this.element = i, Shopify.designMode && this.element.classList.remove("hidden-lap-and-up")
        },
        e0 = function() {
            function e(i) {
                var n = this;
                t(this, e), i.querySelectorAll("[data-popup-type]").forEach(function(e) {
                    "exit" === e.getAttribute("data-popup-type") ? n.exitPopup = new E(e) : "newsletter" === e.getAttribute("data-popup-type") && (n.newsletterPopup = new L(e))
                })
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.exitPopup && this.exitPopup.destroy(), this.newsletterPopup && this.newsletterPopup.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    "exit" === t.target.getAttribute("data-popup-type") && this.exitPopup ? this.exitPopup._openPopup() : "newsletter" === t.target.getAttribute("data-popup-type") && this.newsletterPopup && this.newsletterPopup._openPopup()
                }
            }, {
                key: "onBlockDeselect",
                value: function e() {
                    this.exitPopup && this.exitPopup._closePopup(), this.newsletterPopup && this.newsletterPopup._closePopup()
                }
            }, ]), e
        }(),
        eF = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.options.useRecommendations ? this._loadRecommendations().then(this._createSlideshow.bind(this)) : this._createSlideshow(), this.productItemColorSwatch = new z(this.element), this._fixSafari(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.options.stackable || this.flickityInstance.destroy(), window.removeEventListener("resize", this._fixSafariListener), this.delegateElement.off("change"), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this._fixSafariListener = this._fixSafari.bind(this), window.addEventListener("resize", this._fixSafariListener), this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this))
                }
            }, {
                key: "_fixSafari",
                value: function e() {
                    var t = window.navigator.userAgent.toLowerCase();
                    if (t.includes("safari") && (t.includes("version/10.1") || t.includes("version/10.3") || t.includes("version/11.0"))) {
                        var i = b.matchesBreakpoint("phone");
                        this.element.querySelectorAll(".product-item__image-wrapper .aspect-ratio, .product-item__image-wrapper .placeholder-svg").forEach(function(e) {
                            i ? e.parentNode.style.height = null : e.parentNode.style.height = "".concat(e.clientHeight, "px")
                        })
                    }
                }
            }, {
                key: "_loadRecommendations",
                value: function e() {
                    var t = this;
                    return fetch("".concat(window.routes.productRecommendationsUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&product_id=").concat(this.options.productId, "&limit=").concat(this.options.recommendationsCount)).then(function(e) {
                        return e.text().then(function(e) {
                            var i = document.createElement("div");
                            i.innerHTML = e, t.element.querySelector(".product-recommendations").innerHTML = i.querySelector(".product-recommendations").innerHTML, t.productItemColorSwatch.recalculateSwatches()
                        })
                    })
                }
            }, {
                key: "_createSlideshow",
                value: function e() {
                    var t = this;
                    if (!this.options.stackable) {
                        var i = window.innerWidth;
                        window.addEventListener("resize", function() {
                            window.innerWidth !== i && (i = window.innerWidth)
                        })
                    }
                    window.ResizeObserver && this.flickityInstance && (this.resizeObserver = new ResizeObserver(function() {
                        t.flickityInstance.resize()
                    }), this.element.querySelectorAll(".product-item").forEach(function(e) {
                        t.resizeObserver.observe(e)
                    }))
                }
            }, {
                key: "_openQuickView",
                value: function e(t, i) {
                    var n = new URL("".concat(window.location.origin).concat(i.getAttribute("data-product-url")));
                    if (b.matchesBreakpoint("phone") || b.matchesBreakpoint("tablet")) return window.location.href = n.href, !1;
                    var s = document.getElementById(i.getAttribute("aria-controls"));
                    s.classList.add("is-loading"), n.searchParams.set("view", "quick-view"), fetch(n.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            s.querySelector(".modal__inner").innerHTML = e, s.classList.remove("is-loading");
                            var t = new eL(s.querySelector('[data-section-type="product"]')),
                                i = function e() {
                                    t.onUnload(), s.removeEventListener("modal:closed", e)
                                };
                            s.addEventListener("modal:closed", i)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                  console.log(t)
                    var n = this;
                    if ("page" !== window.theme.cartType) {
                  
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = i.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                          
                            i.removeAttribute("disabled"), e.ok ? n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: i,
                                    variant: null,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), t.preventDefault()
                    }
                }
            }, ]), e
        }(),
        e1 = function() {
            function e(i) {
                t(this, e), this.element = i, this.delegateElement = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.productItemColorSwatch = new z(this.element), this._fetchProducts(), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.flickityInstance && this.flickityInstance.destroy(), this.productItemColorSwatch.destroy(), this.resizeObserver && this.resizeObserver.disconnect()
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.delegateElement.on("click", '[data-action="add-to-cart"]', this._addToCart.bind(this)), this.delegateElement.on("click", '[data-secondary-action="open-quick-view"]', this._openQuickView.bind(this))
                }
            }, {
                key: "_fetchProducts",
                value: function e() {
                    var t = this,
                        i = this._getSearchQueryString();
                    "" !== i && fetch("".concat(window.routes.searchUrl, "?section_id=").concat(this.element.getAttribute("data-section-id"), "&type=product&q=").concat(i), {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            var i = document.createElement("div");
                            i.innerHTML = e, t.element.querySelector(".recently-viewed-products-placeholder").innerHTML = i.querySelector('[data-section-type="recently-viewed-products"] .recently-viewed-products-placeholder').innerHTML, t.element.parentNode.style.display = "block", t.productItemColorSwatch.recalculateSwatches();
                            var n = window.innerWidth;
                            window.addEventListener("resize", function() {
                                window.innerWidth !== n && (n = window.innerWidth)
                            }), window.ResizeObserver && t.flickityInstance && (t.resizeObserver = new ResizeObserver(function() {
                                t.flickityInstance.resize()
                            }), t.element.querySelectorAll(".product-item").forEach(function(e) {
                                t.resizeObserver.observe(e)
                            }))
                        })
                    })
                }
            }, {
                key: "_getSearchQueryString",
                value: function e() {
                    var t = JSON.parse(localStorage.getItem("recentlyViewedProducts") || "[]");
                    return t.includes(this.options.currentProductId) && t.splice(t.indexOf(this.options.currentProductId), 1), t.map(function(e) {
                        return "id:" + e
                    }).join(" OR ")
                }
            }, {
                key: "_openQuickView",
                value: function e(t, i) {
                    var n = new URL("".concat(window.location.origin).concat(i.getAttribute("data-product-url")));
                    if (b.matchesBreakpoint("phone") || b.matchesBreakpoint("tablet")) return window.location.href = n.href, !1;
                    var s = document.getElementById(i.getAttribute("aria-controls"));
                    s.classList.add("is-loading"), n.searchParams.set("view", "quick-view"), fetch(n.href, {
                        credentials: "same-origin",
                        method: "GET"
                    }).then(function(e) {
                        e.text().then(function(e) {
                            s.querySelector(".modal__inner").innerHTML = e, s.classList.remove("is-loading");
                            var t = new eL(s.querySelector('[data-section-type="product"]')),
                                i = function e() {
                                    t.onUnload(), s.removeEventListener("modal:closed", e)
                                };
                            s.addEventListener("modal:closed", i)
                        })
                    })
                }
            }, {
                key: "_addToCart",
                value: function e(t, i) {
                  console.log(t)
                    var n = this;
                    if ("page" !== window.theme.cartType) {
                    
                        t.preventDefault(), t.stopPropagation(), i.setAttribute("disabled", "disabled"), document.dispatchEvent(new CustomEvent("theme:loading:start"));
                        var s = i.closest('form[action*="/cart/add"]');
                        fetch("".concat(window.routes.cartAddUrl, ".js"), {
                            body: JSON.stringify(T.serialize(s)),
                            credentials: "same-origin",
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                "X-Requested-With": "XMLHttpRequest"
                            }
                        }).then(function(e) {
                         
                            i.removeAttribute("disabled"), e.ok ? n.element.dispatchEvent(new CustomEvent("product:added", {
                                bubbles: !0,
                                detail: {
                                    button: i,
                                    variant: null,
                                    quantity: parseInt(s.querySelector('[name="quantity"]').value)
                                }
                            })) : document.dispatchEvent(new CustomEvent("theme:loading:end"))
                        }), t.preventDefault()
                    }
                }
            }, ]), e
        }(),
        eN = function() {
            function e() {
                t(this, e), this.constructors = [], this.instances = [], this._attachListeners()
            }
            return n(e, [{
                key: "_attachListeners",
                value: function e() {
                    document.addEventListener("shopify:section:load", this._onSectionLoad.bind(this)), document.addEventListener("shopify:section:unload", this._onSectionUnload.bind(this)), document.addEventListener("shopify:section:select", this._onSelect.bind(this)), document.addEventListener("shopify:section:deselect", this._onDeselect.bind(this)), document.addEventListener("shopify:section:reorder", this._onReorder.bind(this)), document.addEventListener("shopify:block:select", this._onBlockSelect.bind(this)), document.addEventListener("shopify:block:deselect", this._onBlockDeselect.bind(this))
                }
            }, {
                key: "register",
                value: function e(t, i) {
                    var n = this;
                    this.constructors[t] = i, document.querySelectorAll("[data-section-type=".concat(t, "]")).forEach(function(e) {
                        n._createInstance(e, i)
                    })
                }
            }, {
                key: "_findInstance",
                value: function e(t, i, n) {
                    for (var s = 0; s < t.length; s++)
                        if (t[s][i] === n) return t[s]
                }
            }, {
                key: "_removeInstance",
                value: function e(t, i, n) {
                    for (var s = t.length; s--;)
                        if (t[s][i] === n) {
                            t.splice(s, 1);
                            break
                        }
                    return t
                }
            }, {
                key: "_onSectionLoad",
                value: function e(t) {
                    var i = t.target.querySelector("[data-section-id]");
                    i && this._createInstance(i)
                }
            }, {
                key: "_onSectionUnload",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && ("function" == typeof i.onUnload && i.onUnload(t), this.instances = this._removeInstance(this.instances, "id", t.detail.sectionId))
                }
            }, {
                key: "_onSelect",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && "function" == typeof i.onSelect && i.onSelect(t)
                }
            }, {
                key: "_onDeselect",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && "function" == typeof i.onDeselect && i.onDeselect(t)
                }
            }, {
                key: "_onReorder",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && "function" == typeof i.onReorder && i.onReorder(t)
                }
            }, {
                key: "_onBlockSelect",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && "function" == typeof i.onBlockSelect && i.onBlockSelect(t)
                }
            }, {
                key: "_onBlockDeselect",
                value: function e(t) {
                    var i = this._findInstance(this.instances, "id", t.detail.sectionId);
                    i && "function" == typeof i.onBlockDeselect && i.onBlockDeselect(t)
                }
            }, {
                key: "_createInstance",
                value: function e(t, i) {
                    var n = t.getAttribute("data-section-id"),
                        s = t.getAttribute("data-section-type");
                    if (void 0 !== (i = i || this.constructors[s])) try {
                        var o = Object.assign(new i(t), {
                            id: n,
                            type: s,
                            container: t
                        });
                        this.instances.push(o)
                    } catch (a) {
                        console.error("Logged exception (this may happen if you have tried to edit the code without properly adjusting the JavaScript): " + a.message)
                    }
                }
            }, ]), e
        }(),
        eU = function() {
            function e(i) {
                var n = this;
                t(this, e), this.element = i, this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this.flickityInstance = new ei(i.querySelector(".slideshow"), {
                    pageDots: this.options.pageDots,
                    prevNextButtons: this.options.prevNextButtons,
                    wrapAround: !0,
                    dragThreshold: 12,
                    resize: !1,
                    draggable: ">1",
                    fade: "fade" === this.options.transitionEffect,
                    setGallerySize: this.options.setGallerySize,
                    adaptiveHeight: this.options.adaptiveHeight,
                    autoPlay: !!this.options.autoPlay && this.options.cycleSpeed
                });
                var s = window.innerWidth;
                window.addEventListener("resize", function() {
                    window.innerWidth !== s && (n.flickityInstance.resize(), s = window.innerWidth)
                })
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(t.target.getAttribute("data-block-index")), !1, t.detail.load), this.flickityInstance.pausePlayer())
                }
            }, {
                key: "onBlockDeselect",
                value: function e() {
                    this.flickityInstance.isActive && this.flickityInstance.unpausePlayer()
                }
            }, ]), e
        }(),
        eW = function() {
            function e(i) {
                t(this, e)
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.flickityInstance.destroy()
                }
            }, {
                key: "onBlockSelect",
                value: function e(t) {
                    this.flickityInstance.isActive && (this.flickityInstance.selectCell(parseInt(t.target.getAttribute("data-block-index")), !1, t.detail.load), this.flickityInstance.pausePlayer())
                }
            }, {
                key: "onBlockDeselect",
                value: function e() {
                    this.flickityInstance.isActive && this.flickityInstance.unpausePlayer()
                }
            }, ]), e
        }(),
        e4 = function() {
            function e(i) {
                t(this, e), this.element = i, this.domDelegate = new v(this.element), this.options = JSON.parse(this.element.getAttribute("data-section-settings")), this._attachListeners()
            }
            return n(e, [{
                key: "onUnload",
                value: function e() {
                    this.domDelegate.off("click")
                }
            }, {
                key: "_attachListeners",
                value: function e() {
                    this.domDelegate.on("click", '[data-action="play-video"]', this._playVideo.bind(this))
                }
            }, {
                key: "_playVideo",
                value: function e(t, i) {
                    var n = i.querySelector("iframe");
                    n.src = n.getAttribute("data-src"), i.classList.add("is-playing")
                }
            }, ]), e
        }(),
        eV = f(function(t, i) {
            t.exports = {
                polyfill: function t() {
                    var i = window,
                        n = document;
                    if (!("scrollBehavior" in n.documentElement.style) || !0 === i.__forceSmoothScrollPolyfill__) {
                        var s, o = i.HTMLElement || i.Element,
                            a = {
                                scroll: i.scroll || i.scrollTo,
                                scrollBy: i.scrollBy,
                                elementScroll: o.prototype.scroll || c,
                                scrollIntoView: o.prototype.scrollIntoView
                            },
                            r = i.performance && i.performance.now ? i.performance.now.bind(i.performance) : Date.now,
                            l = (s = i.navigator.userAgent, RegExp("MSIE |Trident/|Edge/").test(s)) ? 1 : 0;
                        i.scroll = i.scrollTo = function() {
                            if (void 0 !== arguments[0]) {
                                if (!0 === h(arguments[0])) {
                                    a.scroll.call(i, void 0 !== arguments[0].left ? arguments[0].left : "object" !== e(arguments[0]) ? arguments[0] : i.scrollX || i.pageXOffset, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : i.scrollY || i.pageYOffset);
                                    return
                                }
                                f.call(i, n.body, void 0 !== arguments[0].left ? ~~arguments[0].left : i.scrollX || i.pageXOffset, void 0 !== arguments[0].top ? ~~arguments[0].top : i.scrollY || i.pageYOffset)
                            }
                        }, i.scrollBy = function() {
                            if (void 0 !== arguments[0]) {
                                if (h(arguments[0])) {
                                    a.scrollBy.call(i, void 0 !== arguments[0].left ? arguments[0].left : "object" !== e(arguments[0]) ? arguments[0] : 0, void 0 !== arguments[0].top ? arguments[0].top : void 0 !== arguments[1] ? arguments[1] : 0);
                                    return
                                }
                                f.call(i, n.body, ~~arguments[0].left + (i.scrollX || i.pageXOffset), ~~arguments[0].top + (i.scrollY || i.pageYOffset))
                            }
                        }, o.prototype.scroll = o.prototype.scrollTo = function() {
                            if (void 0 !== arguments[0]) {
                                if (!0 === h(arguments[0])) {
                                    if ("number" == typeof arguments[0] && void 0 === arguments[1]) throw SyntaxError("Value could not be converted");
                                    a.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left : "object" !== e(arguments[0]) ? ~~arguments[0] : this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top : void 0 !== arguments[1] ? ~~arguments[1] : this.scrollTop);
                                    return
                                }
                                var t = arguments[0].left,
                                    i = arguments[0].top;
                                f.call(this, this, void 0 === t ? this.scrollLeft : ~~t, void 0 === i ? this.scrollTop : ~~i)
                            }
                        }, o.prototype.scrollBy = function() {
                            if (void 0 !== arguments[0]) {
                                if (!0 === h(arguments[0])) {
                                    a.elementScroll.call(this, void 0 !== arguments[0].left ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, void 0 !== arguments[0].top ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                                    return
                                }
                                this.scroll({
                                    left: ~~arguments[0].left + this.scrollLeft,
                                    top: ~~arguments[0].top + this.scrollTop,
                                    behavior: arguments[0].behavior
                                })
                            }
                        }, o.prototype.scrollIntoView = function() {
                            if (!0 === h(arguments[0])) {
                                a.scrollIntoView.call(this, void 0 === arguments[0] || arguments[0]);
                                return
                            }
                            var e = function e(t) {
                                    for (; t !== n.body && !1 === p(t);) t = t.parentNode || t.host;
                                    return t
                                }(this),
                                t = e.getBoundingClientRect(),
                                s = this.getBoundingClientRect();
                            e !== n.body ? (f.call(this, e, e.scrollLeft + s.left - t.left, e.scrollTop + s.top - t.top), "fixed" !== i.getComputedStyle(e).position && i.scrollBy({
                                left: t.left,
                                top: t.top,
                                behavior: "smooth"
                            })) : i.scrollBy({
                                left: s.left,
                                top: s.top,
                                behavior: "smooth"
                            })
                        }
                    }

                    function c(e, t) {
                        this.scrollLeft = e, this.scrollTop = t
                    }

                    function h(t) {
                        if (null === t || "object" !== e(t) || void 0 === t.behavior || "auto" === t.behavior || "instant" === t.behavior) return !0;
                        if ("object" === e(t) && "smooth" === t.behavior) return !1;
                        throw TypeError("behavior member of ScrollOptions " + t.behavior + " is not a valid value for enumeration ScrollBehavior.")
                    }

                    function u(e, t) {
                        return "Y" === t ? e.clientHeight + l < e.scrollHeight : "X" === t ? e.clientWidth + l < e.scrollWidth : void 0
                    }

                    function d(e, t) {
                        var n = i.getComputedStyle(e, null)["overflow" + t];
                        return "auto" === n || "scroll" === n
                    }

                    function p(e) {
                        var t = u(e, "Y") && d(e, "Y"),
                            i = u(e, "X") && d(e, "X");
                        return t || i
                    }

                    function f(e, t, s) {
                        var o, l, h, u, d = r();
                        e === n.body ? (o = i, l = i.scrollX || i.pageXOffset, h = i.scrollY || i.pageYOffset, u = a.scroll) : (o = e, l = e.scrollLeft, h = e.scrollTop, u = c),
                            function e(t) {
                                var n, s, o, a, l = (r() - t.startTime) / 468;
                                n = .5 * (1 - Math.cos(Math.PI * (a = l = l > 1 ? 1 : l))), s = t.startX + (t.x - t.startX) * n, o = t.startY + (t.y - t.startY) * n, t.method.call(t.scrollable, s, o), (s !== t.x || o !== t.y) && i.requestAnimationFrame(e.bind(i, t))
                            }({
                                scrollable: o,
                                method: u,
                                startTime: d,
                                startX: l,
                                startY: h,
                                x: t,
                                y: s
                            })
                    }
                }
            }
        }),
        e3 = new Set,
        e6 = document.createElement("link"),
        e2 = e6.relList && e6.relList.supports && e6.relList.supports("prefetch") && window.IntersectionObserver && "isIntersecting" in IntersectionObserverEntry.prototype,
        eX = "instantAllowQueryString" in document.body.dataset,
        e7 = "instantAllowExternalLinks" in document.body.dataset,
        ej = "instantWhitelist" in document.body.dataset,
        eZ = "instantMousedownShortcut" in document.body.dataset,
        eY = 65,
        e5 = !1,
        eG = !1,
        eQ = !1;
    if ("instantIntensity" in document.body.dataset) {
        var eK = document.body.dataset.instantIntensity;
        if ("mousedown" == eK.substr(0, 9)) e5 = !0, "mousedown-only" == eK && (eG = !0);
        else if ("viewport" == eK.substr(0, 8)) !(navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType && navigator.connection.effectiveType.includes("2g"))) && ("viewport" == eK ? document.documentElement.clientWidth * document.documentElement.clientHeight < 45e4 && (eQ = !0) : "viewport-all" == eK && (eQ = !0));
        else {
            var e9 = parseInt(eK);
            isNaN(e9) || (eY = e9)
        }
    }
    if (e2) {
        var eJ, te, tt, ti = {
            capture: !0,
            passive: !0
        };
        eG || document.addEventListener("touchstart", function e(t) {
            te = performance.now();
            var i = t.target.closest("a");
            ts(i) && to(i.href)
        }, ti), e5 ? eZ || document.addEventListener("mousedown", function e(t) {
            var i = t.target.closest("a");
            ts(i) && to(i.href)
        }, ti) : document.addEventListener("mouseover", function e(t) {
            if (!(performance.now() - te < 1111)) {
                var i = t.target.closest("a");
                ts(i) && (i.addEventListener("mouseout", tn, {
                    passive: !0
                }), eJ = setTimeout(function() {
                    to(i.href), eJ = void 0
                }, eY))
            }
        }, ti), eZ && document.addEventListener("mousedown", function e(t) {
            if (!(performance.now() - te < 1111)) {
                var i = t.target.closest("a");
                if (!(t.which > 1) && !t.metaKey && !t.ctrlKey && i) {
                    i.addEventListener("click", function(e) {
                        1337 != e.detail && e.preventDefault()
                    }, {
                        capture: !0,
                        passive: !1,
                        once: !0
                    });
                    var n = new MouseEvent("click", {
                        view: window,
                        bubbles: !0,
                        cancelable: !1,
                        detail: 1337
                    });
                    i.dispatchEvent(n)
                }
            }
        }, ti), eQ && (tt = window.requestIdleCallback ? function e(t) {
            requestIdleCallback(t, {
                timeout: 1500
            })
        } : function e(t) {
            t()
        })(function() {
            var e = new IntersectionObserver(function(t) {
                t.forEach(function(t) {
                    if (t.isIntersecting) {
                        var i = t.target;
                        e.unobserve(i), to(i.href)
                    }
                })
            });
            document.querySelectorAll("a").forEach(function(t) {
                ts(t) && e.observe(t)
            })
        })
    }

    function tn(e) {
        (!e.relatedTarget || e.target.closest("a") != e.relatedTarget.closest("a")) && eJ && (clearTimeout(eJ), eJ = void 0)
    }

    function ts(e) {
        if (e && e.href && (!ej || "instant" in e.dataset) && (e7 || e.origin == location.origin || "instant" in e.dataset) && ["http:", "https:"].includes(e.protocol) && ("http:" != e.protocol || "https:" != location.protocol) && (eX || !e.search || "instant" in e.dataset) && (!e.hash || e.pathname + e.search != location.pathname + location.search) && !("noInstant" in e.dataset)) return !0
    }

    function to(e) {
        if (!e3.has(e)) {
            var t = document.createElement("link");
            t.rel = "prefetch", t.href = e, document.head.appendChild(t), e3.add(e)
        }
    }
    var ta = f(function(e) {
        var t, i, n;
        t = "undefined" != typeof window ? window : {}, n = (i = function e(t, i, n) {
            if (function() {
                    var e, i = {
                        lazyClass: "lazyload",
                        loadedClass: "lazyloaded",
                        loadingClass: "lazyloading",
                        preloadClass: "lazypreload",
                        errorClass: "lazyerror",
                        autosizesClass: "lazyautosizes",
                        srcAttr: "data-src",
                        srcsetAttr: "data-srcset",
                        sizesAttr: "data-sizes",
                        minSize: 40,
                        customMedia: {},
                        init: !0,
                        expFactor: 1.5,
                        hFac: .8,
                        loadMode: 2,
                        loadHidden: !0,
                        ricTimeout: 0,
                        throttleDelay: 125
                    };
                    for (e in o = t.lazySizesConfig || t.lazysizesConfig || {}, i) e in o || (o[e] = i[e])
                }(), !i || !i.getElementsByClassName) return {
                init: function e() {},
                cfg: o,
                noSupport: !0
            };
            var s, o, a, r, l, c, h, u, d, p, f, m, v, g, y, b, $, w, E, k, S, x, _, C, L, A, P, I, z, D, T, M, q, O, B, H, R, F, N, U, W, V, X, j, Z, Y, G, Q = i.documentElement,
                K = t.HTMLPictureElement,
                J = "addEventListener",
                ee = "getAttribute",
                et = t[J].bind(t),
                ei = t.setTimeout,
                en = t.requestAnimationFrame || ei,
                es = t.requestIdleCallback,
                eo = /^picture$/i,
                ea = ["load", "error", "lazyincluded", "_lazyloaded"],
                er = {},
                el = Array.prototype.forEach,
                ec = function e(t, i) {
                    return er[i] || (er[i] = RegExp("(\\s|^)" + i + "(\\s|$)")), er[i].test(t[ee]("class") || "") && er[i]
                },
                eh = function e(t, i) {
                    ec(t, i) || t.setAttribute("class", (t[ee]("class") || "").trim() + " " + i)
                },
                eu = function e(t, i) {
                    var n;
                    (n = ec(t, i)) && t.setAttribute("class", (t[ee]("class") || "").replace(n, " "))
                },
                ed = function e(t, i, n) {
                    var s = n ? J : "removeEventListener";
                    n && e(t, i), ea.forEach(function(e) {
                        t[s](e, i)
                    })
                },
                ep = function e(t, n, o, a, r) {
                    var l = i.createEvent("Event");
                    return o || (o = {}), o.instance = s, l.initEvent(n, !a, !r), l.detail = o, t.dispatchEvent(l), l
                },
                ef = function e(i, n) {
                    var s;
                    !K && (s = t.picturefill || o.pf) ? (n && n.src && !i[ee]("srcset") && i.setAttribute("srcset", n.src), s({
                        reevaluate: !0,
                        elements: [i]
                    })) : n && n.src && (i.src = n.src)
                },
                em = function e(t, i) {
                    return (getComputedStyle(t, null) || {})[i]
                },
                ev = function e(t, i, n) {
                    for (n = n || t.offsetWidth; n < o.minSize && i && !t._lazysizesWidth;) n = i.offsetWidth, i = i.parentNode;
                    return n
                },
                eg = (c = [], h = l = [], u = function e() {
                    var t = h;
                    for (h = l.length ? c : l, a = !0, r = !1; t.length;) t.shift()();
                    a = !1
                }, (d = function e(t, n) {
                    a && !n ? t.apply(this, arguments) : (h.push(t), r || (r = !0, (i.hidden ? ei : en)(u)))
                })._lsFlush = u, d),
                ey = function e(t, i) {
                    return i ? function() {
                        eg(t)
                    } : function() {
                        var e = this,
                            i = arguments;
                        eg(function() {
                            t.apply(e, i)
                        })
                    }
                },
                eb = function e(t) {
                    var i, s = 0,
                        a = o.throttleDelay,
                        r = o.ricTimeout,
                        l = function e() {
                            i = !1, s = n.now(), t()
                        },
                        c = es && r > 49 ? function() {
                            es(l, {
                                timeout: r
                            }), r !== o.ricTimeout && (r = o.ricTimeout)
                        } : ey(function() {
                            ei(l)
                        }, !0);
                    return function(e) {
                        var t;
                        (e = !0 === e) && (r = 33), !i && (i = !0, (t = a - (n.now() - s)) < 0 && (t = 0), e || t < 9 ? c() : ei(c, t))
                    }
                },
                e8 = function e(t) {
                    var i, s, o = function e() {
                            i = null, t()
                        },
                        a = function e() {
                            var t = n.now() - s;
                            t < 99 ? ei(e, 99 - t) : (es || o)(o)
                        };
                    return function() {
                        s = n.now(), i || (i = ei(a, 99))
                    }
                },
                e$ = (x = /^img$/i, _ = /^iframe$/i, C = "onscroll" in t && !/(gle|ing)bot/.test(navigator.userAgent), L = 0, A = 0, P = 0, I = -1, z = function e(t) {
                    P--, t && !(P < 0) && t.target || (P = 0)
                }, D = function e(t) {
                    return null == S && (S = "hidden" == em(i.body, "visibility")), S || !("hidden" == em(t.parentNode, "visibility") && "hidden" == em(t, "visibility"))
                }, T = function e(t, n) {
                    var s, o = t,
                        a = D(t);
                    for ($ -= n, k += n, w -= n, E += n; a && (o = o.offsetParent) && o != i.body && o != Q;)(a = (em(o, "opacity") || 1) > 0) && "visible" != em(o, "overflow") && (a = E > (s = o.getBoundingClientRect()).left && w < s.right && k > s.top - 1 && $ < s.bottom + 1);
                    return a
                }, q = eb(M = function e() {
                    var t, n, a, r, l, c, h, u, d, m, g, x, _ = s.elements;
                    if ((v = o.loadMode) && P < 8 && (t = _.length)) {
                        for (n = 0, I++; n < t; n++)
                            if (_[n] && !_[n]._lazyRace) {
                                if (!C || s.prematureUnveil && s.prematureUnveil(_[n])) {
                                    U(_[n]);
                                    continue
                                }
                                if ((u = _[n][ee]("data-expand")) && (c = 1 * u) || (c = A), m || (m = !o.expand || o.expand < 1 ? Q.clientHeight > 500 && Q.clientWidth > 500 ? 500 : 370 : o.expand, s._defEx = m, g = m * o.expFactor, x = o.hFac, S = null, A < g && P < 1 && I > 2 && v > 2 && !i.hidden ? (A = g, I = 0) : A = v > 1 && I > 1 && P < 6 ? m : L), d !== c && (y = innerWidth + c * x, b = innerHeight + c, h = -1 * c, d = c), (k = (a = _[n].getBoundingClientRect()).bottom) >= h && ($ = a.top) <= b && (E = a.right) >= h * x && (w = a.left) <= y && (k || E || w || $) && (o.loadHidden || D(_[n])) && (f && P < 3 && !u && (v < 3 || I < 4) || T(_[n], c))) {
                                    if (U(_[n]), l = !0, P > 9) break
                                } else !l && f && !r && P < 4 && I < 4 && v > 2 && (p[0] || o.preloadAfterLoad) && (p[0] || !u && (k || E || w || $ || "auto" != _[n][ee](o.sizesAttr))) && (r = p[0] || _[n])
                            }
                        r && !l && U(r)
                    }
                }), B = ey(O = function e(t) {
                    var i = t.target;
                    if (i._lazyCache) {
                        delete i._lazyCache;
                        return
                    }
                    z(t), eh(i, o.loadedClass), eu(i, o.loadingClass), ed(i, H), ep(i, "lazyloaded")
                }), H = function e(t) {
                    B({
                        target: t.target
                    })
                }, R = function e(t, i) {
                    try {
                        t.contentWindow.location.replace(i)
                    } catch (n) {
                        t.src = i
                    }
                }, F = function e(t) {
                    var i, n = t[ee](o.srcsetAttr);
                    (i = o.customMedia[t[ee]("data-media") || t[ee]("media")]) && t.setAttribute("media", i), n && t.setAttribute("srcset", n)
                }, N = ey(function(e, t, i, n, s) {
                    var a, r, l, c, h, u;
                    !(h = ep(e, "lazybeforeunveil", t)).defaultPrevented && (n && (i ? eh(e, o.autosizesClass) : e.setAttribute("sizes", n)), r = e[ee](o.srcsetAttr), a = e[ee](o.srcAttr), s && (c = (l = e.parentNode) && eo.test(l.nodeName || "")), u = t.firesLoad || "src" in e && (r || a || c), h = {
                        target: e
                    }, eh(e, o.loadingClass), u && (clearTimeout(m), m = ei(z, 2500), ed(e, H, !0)), c && el.call(l.getElementsByTagName("source"), F), r ? e.setAttribute("srcset", r) : a && !c && (_.test(e.nodeName) ? R(e, a) : e.src = a), s && (r || c) && ef(e, {
                        src: a
                    })), e._lazyRace && delete e._lazyRace, eu(e, o.lazyClass), eg(function() {
                        var t = e.complete && e.naturalWidth > 1;
                        (!u || t) && (t && eh(e, "ls-is-cached"), O(h), e._lazyCache = !0, ei(function() {
                            "_lazyCache" in e && delete e._lazyCache
                        }, 9)), "lazy" == e.loading && P--
                    }, !0)
                }), U = function e(t) {
                    if (!t._lazyRace) {
                        var i, n = x.test(t.nodeName),
                            s = n && (t[ee](o.sizesAttr) || t[ee]("sizes")),
                            a = "auto" == s;
                        !((a || !f) && n && (t[ee]("src") || t.srcset) && !t.complete && !ec(t, o.errorClass) && ec(t, o.lazyClass)) && (i = ep(t, "lazyunveilread").detail, a && ew.updateElem(t, !0, t.offsetWidth), t._lazyRace = !0, P++, N(t, i, a, s, n))
                    }
                }, W = e8(function() {
                    o.loadMode = 3, q()
                }), V = function e() {
                    3 == o.loadMode && (o.loadMode = 2), W()
                }, X = function e() {
                    if (!f) {
                        if (n.now() - g < 999) {
                            ei(e, 999);
                            return
                        }
                        f = !0, o.loadMode = 3, q(), et("scroll", V, !0)
                    }
                }, {
                    _: function e() {
                        g = n.now(), s.elements = i.getElementsByClassName(o.lazyClass), p = i.getElementsByClassName(o.lazyClass + " " + o.preloadClass), et("scroll", q, !0), et("resize", q, !0), et("pageshow", function(e) {
                            if (e.persisted) {
                                var t = i.querySelectorAll("." + o.loadingClass);
                                t.length && t.forEach && en(function() {
                                    t.forEach(function(e) {
                                        e.complete && U(e)
                                    })
                                })
                            }
                        }), t.MutationObserver ? new MutationObserver(q).observe(Q, {
                            childList: !0,
                            subtree: !0,
                            attributes: !0
                        }) : (Q[J]("DOMNodeInserted", q, !0), Q[J]("DOMAttrModified", q, !0), setInterval(q, 999)), et("hashchange", q, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach(function(e) {
                            i[J](e, q, !0)
                        }), /d$|^c/.test(i.readyState) ? X() : (et("load", X), i[J]("DOMContentLoaded", q), ei(X, 2e4)), s.elements.length ? (M(), eg._lsFlush()) : q()
                    },
                    checkElems: q,
                    unveil: U,
                    _aLSL: V
                }),
                ew = (Z = ey(function(e, t, i, n) {
                    var s, o, a;
                    if (e._lazysizesWidth = n, n += "px", e.setAttribute("sizes", n), eo.test(t.nodeName || ""))
                        for (o = 0, a = (s = t.getElementsByTagName("source")).length; o < a; o++) s[o].setAttribute("sizes", n);
                    i.detail.dataAttr || ef(e, i.detail)
                }), Y = function e(t, i, n) {
                    var s, o = t.parentNode;
                    o && (n = ev(t, o, n), !(s = ep(t, "lazybeforesizes", {
                        width: n,
                        dataAttr: !!i
                    })).defaultPrevented && (n = s.detail.width) && n !== t._lazysizesWidth && Z(t, o, s, n))
                }, {
                    _: function e() {
                        j = i.getElementsByClassName(o.autosizesClass), et("resize", G)
                    },
                    checkElems: G = e8(function e() {
                        var t, i = j.length;
                        if (i)
                            for (t = 0; t < i; t++) Y(j[t])
                    }),
                    updateElem: Y
                }),
                eE = function e() {
                    !e.i && i.getElementsByClassName && (e.i = !0, ew._(), e$._())
                };
            return ei(function() {
                o.init && eE()
            }), s = {
                cfg: o,
                autoSizer: ew,
                loader: e$,
                init: eE,
                uP: ef,
                aC: eh,
                rC: eu,
                hC: ec,
                fire: ep,
                gW: ev,
                rAF: eg
            }
        })(t, t.document, Date), t.lazySizes = n, e.exports && (e.exports = n)
    });
    f(function(t) {
        var i, n, s;
        i = window, n = function(t, i, n) {
            var s, o, a, r, l, c, h, u, d = n.cfg,
                p = {
                    string: 1,
                    number: 1
                },
                f = /^\-*\+*\d+\.*\d*$/,
                m = /^picture$/i,
                v = /\s*\{\s*width\s*\}\s*/i,
                g = /\s*\{\s*height\s*\}\s*/i,
                y = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,
                b = /^\[.*\]|\{.*\}$/,
                $ = /^(?:auto|\d+(px)?)$/,
                w = i.createElement("a"),
                E = i.createElement("img"),
                k = "srcset" in E && !("sizes" in E),
                S = !!t.HTMLPictureElement && !k;

            function x(t, n, s) {
                var o, a, r, l, c = 0,
                    d = 0,
                    f = s;
                if (t) {
                    if ("container" === n.ratio) {
                        for (c = f.scrollWidth, d = f.scrollHeight;
                            (!c || !d) && f !== i;) c = (f = f.parentNode).scrollWidth, d = f.scrollHeight;
                        c && d && (n.ratio = n.traditionalRatio ? d / c : c / d)
                    }(t = (o = t, a = n, r = [], l = function t(i, n) {
                        return p[e(a[n])] ? a[n] : i
                    }, r.srcset = [], a.absUrl && (w.setAttribute("href", o), o = w.href), o = ((a.prefix || "") + o + (a.postfix || "")).replace(y, l), a.widths.forEach(function(e) {
                        var t = a.widthmap[e] || e,
                            i = a.aspectratio || a.ratio,
                            n = !a.aspectratio && u.traditionalRatio,
                            s = {
                                u: o.replace(v, t).replace(g, i ? n ? Math.round(e * i) : Math.round(e / i) : ""),
                                w: e
                            };
                        r.push(s), r.srcset.push(s.c = s.u + " " + e + "w")
                    }), r)).isPicture = n.isPicture, k && "IMG" == s.nodeName.toUpperCase() ? s.removeAttribute(h.srcsetAttr) : s.setAttribute(h.srcsetAttr, t.srcset.join(", ")), Object.defineProperty(s, "_lazyrias", {
                        value: t,
                        writable: !0
                    })
                }
            }

            function _(e) {
                return e.getAttribute(e.getAttribute("data-srcattr") || u.srcAttr) || e.getAttribute(h.srcsetAttr) || e.getAttribute(h.srcAttr) || e.getAttribute("data-pfsrcset") || ""
            }! function() {
                var e, t = {
                    prefix: "",
                    postfix: "",
                    srcAttr: "data-src",
                    absUrl: !1,
                    modifyOptions: function e() {},
                    widthmap: {},
                    ratio: !1,
                    traditionalRatio: !1,
                    aspectratio: !1
                };
                for (e in (h = n && n.cfg).supportsType || (h.supportsType = function(e) {
                        return !e
                    }), h.rias || (h.rias = {}), "widths" in (u = h.rias) || (u.widths = [], function(e) {
                        for (var t, i = 0; !t || t < 3e3;)(i += 5) > 30 && (i += 1), t = 36 * i, e.push(t)
                    }(u.widths)), t) e in u || (u[e] = t[e])
            }(), addEventListener("lazybeforesizes", function(e) {
                var i, s, o, a, r, l, c, d, p, g, w, E, k, L, A, P;
                if (e.detail.instance == n) {
                    if (i = e.target, e.detail.dataAttr && !e.defaultPrevented && !u.disabled && (p = i.getAttribute(h.sizesAttr) || i.getAttribute("sizes")) && $.test(p)) {
                        if (s = _(i), o = (L = i, P = function e(i, n) {
                                var s, o, a, r, l = t.getComputedStyle(i);
                                for (s in r = {
                                        isPicture: !!((o = i.parentNode) && m.test(o.nodeName || ""))
                                    }, a = function e(t, n) {
                                        var s = i.getAttribute("data-" + t);
                                        if (!s) {
                                            var o = l.getPropertyValue("--ls-" + t);
                                            o && (s = o.trim())
                                        }
                                        if (s) {
                                            if ("true" == s) s = !0;
                                            else if ("false" == s) s = !1;
                                            else if (f.test(s)) s = parseFloat(s);
                                            else if ("function" == typeof u[t]) s = u[t](i, s);
                                            else if (b.test(s)) try {
                                                s = JSON.parse(s)
                                            } catch (a) {}
                                            r[t] = s
                                        } else t in u && "function" != typeof u[t] ? r[t] = u[t] : n && "function" == typeof u[t] && (r[t] = u[t](i, s))
                                    }, u) a(s);
                                return n.replace(y, function(e, t) {
                                    t in r || a(t, !0)
                                }), r
                            }(L, A = s), u.modifyOptions.call(L, {
                                target: L,
                                details: P,
                                detail: P
                            }), n.fire(L, "lazyriasmodifyoptions", P), P), w = v.test(o.prefix) || v.test(o.postfix), o.isPicture && (a = i.parentNode))
                            for (l = 0, c = (r = a.getElementsByTagName("source")).length; l < c; l++)(w || v.test(d = _(r[l]))) && (x(d, o, r[l]), E = !0);
                        w || v.test(s) ? (x(s, o, i), E = !0) : E && ((k = []).srcset = [], k.isPicture = !0, Object.defineProperty(i, "_lazyrias", {
                            value: k,
                            writable: !0
                        })), E && (S ? i.removeAttribute(h.srcAttr) : "auto" != p && (g = {
                            width: parseInt(p, 10)
                        }, C({
                            target: i,
                            detail: g
                        })))
                    }
                }
            }, !0);
            var C = (s = function e(t, i) {
                return t.w - i.w
            }, o = function e(t) {
                for (var i, n, s = t.length, o = t[s - 1], a = 0; a < s; a++)
                    if ((o = t[a]).d = o.w / t.w, o.d >= t.d) {
                        !o.cached && (i = t[a - 1]) && i.d > t.d - .13 * Math.pow(t.d, 2.2) && (n = Math.pow(i.d - .6, 1.6), i.cached && (i.d += .15 * n), i.d + (o.d - t.d) * n > t.d && (o = i));
                        break
                    }
                return o
            }, a = function e(t, i) {
                var s;
                return !t._lazyrias && n.pWS && (s = n.pWS(t.getAttribute(h.srcsetAttr || ""))).length && (Object.defineProperty(t, "_lazyrias", {
                    value: s,
                    writable: !0
                }), i && t.parentNode && (s.isPicture = "PICTURE" == t.parentNode.nodeName.toUpperCase())), t._lazyrias
            }, r = function e(i) {
                var s = t.devicePixelRatio || 1;
                return Math.min(n.getX && n.getX(i) || s, 2.4, s)
            }, l = function e(i, n) {
                var l, c, h, u, d, p;
                if ((d = i._lazyrias).isPicture && t.matchMedia) {
                    for (c = 0, h = (l = i.parentNode.getElementsByTagName("source")).length; c < h; c++)
                        if (a(l[c]) && !l[c].getAttribute("type") && (!(u = l[c].getAttribute("media")) || (matchMedia(u) || {}).matches)) {
                            d = l[c]._lazyrias;
                            break
                        }
                }
                return (!d.w || d.w < n) && (d.w = n, d.d = r(i), p = o(d.sort(s))), p
            }, c = function e(s) {
                if (s.detail.instance == n) {
                    var o, r = s.target;
                    if (!k && (t.respimage || t.picturefill || d.pf)) {
                        i.removeEventListener("lazybeforesizes", c);
                        return
                    }("_lazyrias" in r || s.detail.dataAttr && a(r, !0)) && (o = l(r, s.detail.width)) && o.u && r._lazyrias.cur != o.u && (r._lazyrias.cur = o.u, o.cached = !0, n.rAF(function() {
                        r.setAttribute(h.srcAttr, o.u), r.setAttribute("src", o.u)
                    }))
                }
            }, S ? c = function e() {} : addEventListener("lazybeforesizes", c), c)
        }, s = function e() {
            n(i.lazySizes), i.removeEventListener("lazyunveilread", e, !0)
        }, n = n.bind(null, i, i.document), t.exports ? n(ta) : i.lazySizes ? s() : i.addEventListener("lazyunveilread", s, !0)
    }), f(function(e) {
        var t, i, n;
        t = window, i = function(e, t, i) {
            var n, s, o = {};

            function a(e, i) {
                if (!o[e]) {
                    var n = t.createElement(i ? "link" : "script"),
                        s = t.getElementsByTagName("script")[0];
                    i ? (n.rel = "stylesheet", n.href = e) : n.src = e, o[e] = !0, o[n.src || n.href] = !0, s.parentNode.insertBefore(n, s)
                }
            }
            t.addEventListener && (s = /\(|\)|\s|'/, n = function e(i, n) {
                var s = t.createElement("img");
                s.onload = function() {
                    s.onload = null, s.onerror = null, s = null, n()
                }, s.onerror = s.onload, s.src = i, s && s.complete && s.onload && s.onload()
            }, addEventListener("lazybeforeunveil", function(e) {
                if (e.detail.instance == i && !e.defaultPrevented) {
                    var t, o, r, l, c = e.target;
                    if ("none" == c.preload && (c.preload = c.getAttribute("data-preload") || "auto"), null != c.getAttribute("data-autoplay")) {
                        if (c.getAttribute("data-expand") && !c.autoplay) try {
                            c.play()
                        } catch (h) {} else requestAnimationFrame(function() {
                            c.setAttribute("data-expand", "-10"), i.aC(c, i.cfg.lazyClass)
                        })
                    }(t = c.getAttribute("data-link")) && a(t, !0), (t = c.getAttribute("data-script")) && a(t), (t = c.getAttribute("data-require")) && (i.cfg.requireJs ? i.cfg.requireJs([t]) : a(t)), (r = c.getAttribute("data-bg")) && (e.detail.firesLoad = !0, o = function t() {
                        c.style.backgroundImage = "url(" + (s.test(r) ? JSON.stringify(r) : r) + ")", e.detail.firesLoad = !1, i.fire(c, "_lazyloaded", {}, !0, !0)
                    }, n(r, o)), (l = c.getAttribute("data-poster")) && (e.detail.firesLoad = !0, o = function t() {
                        c.poster = l, e.detail.firesLoad = !1, i.fire(c, "_lazyloaded", {}, !0, !0)
                    }, n(l, o))
                }
            }, !1))
        }, n = function e() {
            i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0)
        }, i = i.bind(null, t, t.document), e.exports ? i(ta) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
    }), f(function(e) {
        var t, i, n;
        t = window, i = function(e, t, i) {
            if (e.addEventListener) {
                var n = i.cfg,
                    s = /\s+/g,
                    o = /\s*\|\s+|\s+\|\s*/g,
                    a = /^(.+?)(?:\s+\[\s*(.+?)\s*\])(?:\s+\[\s*(.+?)\s*\])?$/,
                    r = /^\s*\(*\s*type\s*:\s*(.+?)\s*\)*\s*$/,
                    l = /\(|\)|'/,
                    c = {
                        contain: 1,
                        cover: 1
                    },
                    h = function e(t) {
                        var n = i.gW(t, t.parentNode);
                        return (!t._lazysizesWidth || n > t._lazysizesWidth) && (t._lazysizesWidth = n), t._lazysizesWidth
                    },
                    u = function e(t) {
                        var i;
                        return !c[i = (getComputedStyle(t) || {
                            getPropertyValue: function e() {}
                        }).getPropertyValue("background-size")] && c[t.style.backgroundSize] && (i = t.style.backgroundSize), i
                    },
                    d = function e(t, i) {
                        if (i) {
                            var s = i.match(r);
                            s && s[1] ? t.setAttribute("type", s[1]) : t.setAttribute("media", n.customMedia[i] || i)
                        }
                    },
                    p = function e(i, r, l) {
                        var c = t.createElement("picture"),
                            h = r.getAttribute(n.sizesAttr),
                            u = r.getAttribute("data-ratio"),
                            p = r.getAttribute("data-optimumx");
                        r._lazybgset && r._lazybgset.parentNode == r && r.removeChild(r._lazybgset), Object.defineProperty(l, "_lazybgset", {
                            value: r,
                            writable: !0
                        }), Object.defineProperty(r, "_lazybgset", {
                            value: c,
                            writable: !0
                        }), i = i.replace(s, " ").split(o), c.style.display = "none", l.className = n.lazyClass, 1 != i.length || h || (h = "auto"), i.forEach(function(e) {
                            var i, s = t.createElement("source");
                            h && "auto" != h && s.setAttribute("sizes", h), (i = e.match(a)) ? (s.setAttribute(n.srcsetAttr, i[1]), d(s, i[2]), d(s, i[3])) : s.setAttribute(n.srcsetAttr, e), c.appendChild(s)
                        }), h && (l.setAttribute(n.sizesAttr, h), r.removeAttribute(n.sizesAttr), r.removeAttribute("sizes")), p && l.setAttribute("data-optimumx", p), u && l.setAttribute("data-ratio", u), c.appendChild(l), r.appendChild(c)
                    },
                    f = function e(t) {
                        if (t.target._lazybgset) {
                            var n = t.target,
                                s = n._lazybgset,
                                o = n.currentSrc || n.src;
                            if (o) {
                                var a = i.fire(s, "bgsetproxy", {
                                    src: o,
                                    useSrc: l.test(o) ? JSON.stringify(o) : o
                                });
                                a.defaultPrevented || (s.style.backgroundImage = "url(" + a.detail.useSrc + ")")
                            }
                            n._lazybgsetLoading && (i.fire(s, "_lazyloaded", {}, !1, !0), delete n._lazybgsetLoading)
                        }
                    };
                addEventListener("lazybeforeunveil", function(e) {
                    var n, s, o;
                    !e.defaultPrevented && (n = e.target.getAttribute("data-bgset")) && (o = e.target, (s = t.createElement("img")).alt = "", s._lazybgsetLoading = !0, e.detail.firesLoad = !0, p(n, o, s), setTimeout(function() {
                        i.loader.unveil(s), i.rAF(function() {
                            i.fire(s, "_lazyloaded", {}, !0, !0), s.complete && f({
                                target: s
                            })
                        })
                    }))
                }), t.addEventListener("load", f, !0), e.addEventListener("lazybeforesizes", function(e) {
                    if (e.detail.instance == i && e.target._lazybgset && e.detail.dataAttr) {
                        var t = u(e.target._lazybgset);
                        c[t] && (e.target._lazysizesParentFit = t, i.rAF(function() {
                            e.target.setAttribute("data-parent-fit", t), e.target._lazysizesParentFit && delete e.target._lazysizesParentFit
                        }))
                    }
                }, !0), t.documentElement.addEventListener("lazybeforesizes", function(e) {
                    !e.defaultPrevented && e.target._lazybgset && e.detail.instance == i && (e.detail.width = h(e.target._lazybgset))
                })
            }
        }, n = function e() {
            i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0)
        }, i = i.bind(null, t, t.document), e.exports ? i(ta) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
    }), f(function(e) {
        ! function(t, i) {
            if (t) {
                var n = function e() {
                    i(t.lazySizes), t.removeEventListener("lazyunveilread", e, !0)
                };
                i = i.bind(null, t, t.document), e.exports ? i(ta) : t.lazySizes ? n() : t.addEventListener("lazyunveilread", n, !0)
            }
        }("undefined" != typeof window ? window : 0, function(e, t, i) {
            var n, s, o, a, r, l, c, h, u, d, p, f, m, v, g, y, b, $, w = i.cfg,
                E = t.createElement("img"),
                k = "sizes" in E && "srcset" in E,
                S = /\s+\d+h/g,
                x = (b = /\s+(\d+)(w|h)\s+(\d+)(w|h)/, $ = Array.prototype.forEach, function() {
                    var e = t.createElement("img"),
                        n = function e(t) {
                            var i, n, s = t.getAttribute(w.srcsetAttr);
                            s && (n = s.match(b)) && ((i = "w" == n[2] ? n[1] / n[3] : n[3] / n[1]) && t.setAttribute("data-aspectratio", i), t.setAttribute(w.srcsetAttr, s.replace(S, "")))
                        },
                        s = function e(t) {
                            if (t.detail.instance == i) {
                                var s = t.target.parentNode;
                                s && "PICTURE" == s.nodeName && $.call(s.getElementsByTagName("source"), n), n(t.target)
                            }
                        },
                        o = function i() {
                            e.currentSrc && t.removeEventListener("lazybeforeunveil", s)
                        };
                    t.addEventListener("lazybeforeunveil", s), e.onload = o, e.onerror = o, e.srcset = "data:,a 1w 1h", e.complete && o()
                });
            if (w.supportsType || (w.supportsType = function(e) {
                    return !e
                }), e.HTMLPictureElement && k) {
                !i.hasHDescriptorFix && t.msElementsFromPoint && (i.hasHDescriptorFix = !0, x());
                return
            }!e.picturefill && !w.pf && (w.pf = function(t) {
                var i, n;
                if (!e.picturefill)
                    for (i = 0, n = t.elements.length; i < n; i++) y(t.elements[i])
            }, y = (n = function e(t, i) {
                return t.w - i.w
            }, s = /^\s*\d+\.*\d*px\s*$/, o = function e(t) {
                for (var i, n, s = t.length, o = t[s - 1], a = 0; a < s; a++)
                    if ((o = t[a]).d = o.w / t.w, o.d >= t.d) {
                        !o.cached && (i = t[a - 1]) && i.d > t.d - .13 * Math.pow(t.d, 2.2) && (n = Math.pow(i.d - .6, 1.6), i.cached && (i.d += .15 * n), i.d + (o.d - t.d) * n > t.d && (o = i));
                        break
                    }
                return o
            }, h = (r = /(([^,\s].[^\s]+)\s+(\d+)w)/g, l = /\s/, c = function e(t, i, n, s) {
                a.push({
                    c: i,
                    u: n,
                    w: 1 * s
                })
            }, function(e) {
                return a = [], (e = e.trim()).replace(S, "").replace(r, c), a.length || !e || l.test(e) || a.push({
                    c: e,
                    u: e,
                    w: 99
                }), a
            }), u = function e() {
                var i, n, s;
                !e.init && (e.init = !0, addEventListener("resize", (n = t.getElementsByClassName("lazymatchmedia"), s = function e() {
                    var t, i;
                    for (t = 0, i = n.length; t < i; t++) y(n[t])
                }, function() {
                    clearTimeout(i), i = setTimeout(s, 66)
                })))
            }, d = function t(n, s) {
                var o, a = n.getAttribute("srcset") || n.getAttribute(w.srcsetAttr);
                !a && s && (a = n._lazypolyfill ? n._lazypolyfill._set : n.getAttribute(w.srcAttr) || n.getAttribute("src")), n._lazypolyfill && n._lazypolyfill._set == a || (o = h(a || ""), s && n.parentNode && (o.isPicture = "PICTURE" == n.parentNode.nodeName.toUpperCase(), o.isPicture && e.matchMedia && (i.aC(n, "lazymatchmedia"), u())), o._set = a, Object.defineProperty(n, "_lazypolyfill", {
                    value: o,
                    writable: !0
                }))
            }, p = function t(n) {
                var s = e.devicePixelRatio || 1;
                return Math.min(i.getX && i.getX(n) || s, 2.5, s)
            }, f = function t(i) {
                return e.matchMedia ? (f = function e(t) {
                    return !t || (matchMedia(t) || {}).matches
                })(i) : !i
            }, m = function e(t) {
                var a, r, l, c, h, u, m;
                if (d(c = t, !0), (h = c._lazypolyfill).isPicture) {
                    for (r = 0, l = (a = t.parentNode.getElementsByTagName("source")).length; r < l; r++)
                        if (w.supportsType(a[r].getAttribute("type"), t) && f(a[r].getAttribute("media"))) {
                            d(c = a[r]), h = c._lazypolyfill;
                            break
                        }
                }
                return h.length > 1 ? (m = c.getAttribute("sizes") || "", m = s.test(m) && parseInt(m, 10) || i.gW(t, t.parentNode), h.d = p(t), h.src && h.w && !(h.w < m) ? u = h.src : (h.w = m, u = o(h.sort(n)), h.src = u)) : u = h[0], u
            }, (v = function e(t) {
                if (!k || !t.parentNode || "PICTURE" == t.parentNode.nodeName.toUpperCase()) {
                    var i = m(t);
                    i && i.u && t._lazypolyfill.cur != i.u && (t._lazypolyfill.cur = i.u, i.cached = !0, t.setAttribute(w.srcAttr, i.u), t.setAttribute("src", i.u))
                }
            }).parse = h, v), w.loadedClass && w.loadingClass && (g = [], ['img[sizes$="px"][srcset].', "picture > img:not([srcset])."].forEach(function(e) {
                g.push(e + w.loadedClass), g.push(e + w.loadingClass)
            }), w.pf({
                elements: t.querySelectorAll(g.join(", "))
            })))
        })
    });
    var tr = function(e) {
        ! function e(t, i) {
            if ("function" != typeof i && null !== i) throw TypeError("Super expression must either be null or a function");
            t.prototype = Object.create(i && i.prototype, {
                constructor: {
                    value: t,
                    writable: !0,
                    configurable: !0
                }
            }), i && o(t, i)
        }(c, e);
        var i, r, l = (i = c, r = a(), function e() {
            var t, n, o, a = s(i);
            if (r) {
                var l = s(this).constructor;
                o = Reflect.construct(a, arguments, l)
            } else o = a.apply(this, arguments);
            return t = this, (n = o) && ("object" == typeof n || "function" == typeof n) ? n : function e(t) {
                if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t
            }(t)
        });

        function c() {
            return t(this, c), l.apply(this, arguments)
        }
        return n(c, [{
            key: "connectedCallback",
            value: function e() {
                var t = this;
                this.rangeLowerBound = this.querySelector(".price-range__range-group input:first-child"), this.rangeHigherBound = this.querySelector(".price-range__range-group input:last-child"), this.textInputLowerBound = this.querySelector(".price-range__input:first-child input"), this.textInputHigherBound = this.querySelector(".price-range__input:last-child input"), this.textInputLowerBound.addEventListener("focus", function() {
                    return t.textInputLowerBound.select()
                }), this.textInputHigherBound.addEventListener("focus", function() {
                    return t.textInputHigherBound.select()
                }), this.textInputLowerBound.addEventListener("change", function(e) {
                    e.target.value = Math.max(Math.min(parseInt(e.target.value), parseInt(t.textInputHigherBound.value || e.target.max) - 1), e.target.min), t.rangeLowerBound.value = e.target.value, t.rangeLowerBound.parentElement.style.setProperty("--range-min", "".concat(parseInt(t.rangeLowerBound.value) / parseInt(t.rangeLowerBound.max) * 100, "%"))
                }), this.textInputHigherBound.addEventListener("change", function(e) {
                    e.target.value = Math.min(Math.max(parseInt(e.target.value), parseInt(t.textInputLowerBound.value || e.target.min) + 1), e.target.max), t.rangeHigherBound.value = e.target.value, t.rangeHigherBound.parentElement.style.setProperty("--range-max", "".concat(parseInt(t.rangeHigherBound.value) / parseInt(t.rangeHigherBound.max) * 100, "%"))
                }), this.rangeLowerBound.addEventListener("change", function(e) {
                    t.textInputLowerBound.value = e.target.value, t.textInputLowerBound.dispatchEvent(new Event("change", {
                        bubbles: !0
                    }))
                }), this.rangeHigherBound.addEventListener("change", function(e) {
                    t.textInputHigherBound.value = e.target.value, t.textInputHigherBound.dispatchEvent(new Event("change", {
                        bubbles: !0
                    }))
                }), this.rangeLowerBound.addEventListener("input", function(e) {
                    t.dispatchEvent(new CustomEvent("collection:abort-loading", {
                        bubbles: !0
                    })), e.target.value = Math.min(parseInt(e.target.value), parseInt(t.textInputHigherBound.value || e.target.max) - 1), e.target.parentElement.style.setProperty("--range-min", "".concat(parseInt(e.target.value) / parseInt(e.target.max) * 100, "%")), t.textInputLowerBound.value = e.target.value
                }), this.rangeHigherBound.addEventListener("input", function(e) {
                    t.dispatchEvent(new CustomEvent("collection:abort-loading", {
                        bubbles: !0
                    })), e.target.value = Math.max(parseInt(e.target.value), parseInt(t.textInputLowerBound.value || e.target.min) + 1), e.target.parentElement.style.setProperty("--range-max", "".concat(parseInt(e.target.value) / parseInt(e.target.max) * 100, "%")), t.textInputHigherBound.value = e.target.value
                })
            }
        }, ]), c
    }(l(HTMLElement));
    window.customElements.define("price-range", tr),
        function() {
            var e = function e() {
                window.NodeList && !NodeList.prototype.forEach && (NodeList.prototype.forEach = function(e, t) {
                    t = t || window;
                    for (var i = 0; i < this.length; i++) e.call(t, this[i], i, this)
                }), eV.polyfill(), new g, new k, new C, new I;
                var t, i, n, s, o, a = new eN;
                a.register("account", ek), a.register("announcement-bar", eS), a.register("blog", ex), a.register("blog-sidebar", eC), a.register("blog-post", e_), a.register("cart", eA), a.register("collection-list", eP), a.register("collection", eI), a.register("featured-collection", ez), a.register("footer", eT), a.register("gift-card", eD), a.register("header", eq), a.register("login", eO), a.register("map", eB), a.register("minimal-header", eH), a.register("popups", e0), a.register("product-recommendations", eF), a.register("product", eL), a.register("quick-links", eR), a.register("recently-viewed-products", e1), a.register("slideshow", eU), a.register("text-with-icons", eW), a.register("video", e4), document.querySelectorAll(".rte table").forEach(function(e) {
                        e.outerHTML = '<div class="table-wrapper">' + e.outerHTML + "</div>"
                    }), document.querySelectorAll(".rte iframe").forEach(function(e) {
                        (-1 !== e.src.indexOf("youtube") || -1 !== e.src.indexOf("youtu.be") || -1 !== e.src.indexOf("vimeo")) && (e.outerHTML = '<div class="video-wrapper">' + e.outerHTML + "</div>", e.src = e.src)
                    }), i = !1, document.body.addEventListener("touchstart", function(e) {
                        var n = e.target.closest(".flickity-slider");
                        if (n) {
                            if (et.data(n.closest(".flickity-enabled")).isDraggable) i = !0;
                            else {
                                i = !1;
                                return
                            }
                        } else {
                            i = !1;
                            return
                        }
                        t = {
                            x: e.touches[0].pageX,
                            y: e.touches[0].pageY
                        }
                    }), document.body.addEventListener("touchmove", function(e) {
                        i && e.cancelable && Math.abs({
                            x: e.touches[0].pageX - t.x,
                            y: e.touches[0].pageY - t.y
                        }.x) > 8 && e.preventDefault()
                    }, {
                        passive: !1
                    }), new v(document.body).on("click", ".expandable-content__toggle", function(e, t) {
                        var i = t.closest(".expandable-content");
                        if ("true" === i.getAttribute("aria-expanded")) {
                            i.setAttribute("aria-expanded", "false"), i.style["max-height"] = "".concat(i.offsetHeight, "px"), i.offsetHeight, i.style["max-height"] = null;
                            var n = t.querySelector(".expandable-content__toggle-text");
                            n.innerHTML = n.getAttribute("data-view-more");
                            var s = i.closest(".card");
                            if (s) {
                                var o = s.getBoundingClientRect().top - 15 - parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-height"));
                                window.scrollBy({
                                    top: o,
                                    behavior: "smooth"
                                })
                            }
                        } else {
                            i.setAttribute("aria-expanded", "true"), t.previousElementSibling && (t.previousElementSibling.style["margin-bottom"] = "".concat(parseInt(t.clientHeight), "px")), u.slideDown(i, null, "max-height");
                            var a = t.querySelector(".expandable-content__toggle-text");
                            a.innerHTML = a.getAttribute("data-view-less")
                        }
                    }), n = function e() {
                        document.querySelectorAll(".expandable-content[aria-expanded]").forEach(function(e) {
                            e.scrollHeight > e.clientHeight ? e.classList.add("expandable-content--expandable") : e.setAttribute("aria-expanded", "true")
                        })
                    }, document.addEventListener("shopify:section:load", function(e) {
                        n()
                    }), n(),
                    function() {
                        if ("phone" === b.getCurrentBreakpoint())
                            for (var e = document.querySelectorAll("input[autofocus]"), t = 0; t < e.length; t++) e[t].blur(), e[t].removeAttribute("autofocus")
                    }(), new v(document.body).on("click", '[href^="#"], [data-href]', function(e, t) {
                        var i = t.hasAttribute("href") ? t.getAttribute("href") : t.getAttribute("data-href");
                        if ("#" !== i && "#main" !== i) {
                            var n = null;
                            try {
                                n = document.querySelector(i)
                            } catch (s) {
                                return
                            }
                            for (var o = parseInt(t.getAttribute("data-offset") || 0), a = 0;
                                "BODY" !== n.offsetParent.tagName;) a += n.offsetTop, n = n.offsetParent;
                            a += n.offsetTop, window.scrollTo({
                                behavior: "smooth",
                                top: a - o
                            }), e.preventDefault()
                        }
                    }),
                    function() {
                        function e(t) {
                            "Tab" === t.key && (document.body.classList.add("is-tabbing"), window.removeEventListener("keydown", e))
                        }
                        window.addEventListener("keydown", e)
                    }(), (s = new v(document.body)).on("keyup", "input, textarea", function(e, t) {
                        t.classList.toggle("is-filled", "" !== t.value)
                    }), s.on("change", "select", function(e, t) {
                        t.parentNode.classList.toggle("is-filled", "" !== t.value)
                    }), o = document.links, A.mutate(function() {
                        for (var e = 0, t = o.length; e < t; e++) o[e].hostname === window.location.hostname || o[e].classList.contains("langSwitchLink") || (o[e].target = "_blank", o[e].relList.add("noopener"), o[e].setAttribute("aria-describedby", "a11y-new-window-message"))
                    })
            };
            if ("fetch" in window && "assign" in Object) e();
            else {
                var t = document.createElement("script");
                t.src = "//cdn.polyfill.io/v3/polyfill.min.js?unknown=polyfill&features=fetch,Element.prototype.closest,Element.prototype.matches,Element.prototype.remove,Element.prototype.classList,Array.prototype.includes,String.prototype.includes,Object.assign,CustomEvent,URL,DOMTokenList", t.async = !1, t.onload = function() {
                    e()
                }, document.head.appendChild(t)
            }
        }()
  class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;
    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);
});